export default {
  translation: {

    // App
    'apartment_system': 'Système de Gestion d\'Appartements',
    'apartment_management': 'Gestion d\'Appartements',
    'building_management': 'Gestion de Bâtiments',

    // Navigation - updated
    'dashboard': 'Tableau de Bord',
    'user_management': 'Gestion des Utilisateurs',
    'building_management': 'Gestion de Bâtiments',
    'apartment_management': 'Gestion d\'Appartements',
    'owner_management': 'Gestion des Propriétaires',
    'tenant_management': 'Gestion des Locataires',
    'payment_management': 'Gestion des Paiements',
    'service_management': 'Gestion des Services',
    'report_management': 'Rapports & Analyses',
    'log_management': 'Journaux d\'Activité',

    // Buildings
    'buildings': 'Bâtiments',
    'building_list': 'Liste des Bâtiments',
    'switch_building': 'Bâtiment actuel',
    'add_building': 'Ajouter un Bâtiment',
    'edit_building': 'Modifier le Bâtiment',
    'building_details': 'Détails du Bâtiment',
    'building_name': 'Nom du Bâtiment',
    'building_address': 'Adresse',
    'total_floors': 'Nombre Total d\'Étages',
    'total_apartments': 'Nombre Total d\'Appartements',

    // Apartments (renamed from Properties)
    'apartments': 'Appartements',
    'apartment_list': 'Liste des Appartements',
    'add_apartment': 'Ajouter un Appartement',
    'add_your_first_apartment': 'Ajoutez votre premier appartement',
    'edit_apartment': 'Modifier l\'Appartement',
    'apartment_details': 'Détails de l\'Appartement',
    'apartment_number': 'Numéro d\'Appartement',
    'apartment_display': 'Chambre {{number}}',
    'apt': 'Appart',
    'floor_number': 'Numéro d\'Étage',
    'floor_display': 'Étage {{number}}',
    'monthly_rent': 'Loyer Mensuel',
    'apartment_status': 'Statut',
    'vacant': 'Vacant',
    'occupied': 'Occupé',
    'under_maintenance': 'En Maintenance',
    'key_status': 'État des clés',
    'at_office': 'Au bureau',
    'with_tenant': 'Chez le locataire',
    'with_maintenance': 'En maintenance',
    'lost': 'Perdu',
    'key_handover': 'Remise des clés',
    'give_out_keys': 'Remettre les clés',
    'return_keys': 'Rendre les clés',
    'keys': 'Clés',
    'remotes': 'Télécommandes',
    'fobs': 'Badges / Fobs',
    'possession_date': 'Date de possession',
    'key_details': 'Détails des clés',
    'key_history': 'Historique des clés',
    'record_handover': 'Enregistrer la remise',
    'confirm_and_record': 'Confirmer la remise',
    'add_notes': 'Ajouter des notes supplémentaires ici...',
    'no_key_history': 'Aucun historique de remise de clés trouvé.',
    'loading_history': 'Chargement de l\'historique...',
    'by': 'par',
    'warning_handover_no_tenant': 'Enregistrement de la remise sans locataire associé.',
    'key_handover_success': 'Remise de clés enregistrée avec succès',
    'failed_to_record_handover': 'Échec de l\'enregistrement de la remise de clés',
    'failed_to_load_history': 'Échec du chargement de l\'historique des clés',
    'key_management': 'Gestion des clés',
    'manage_keys': 'Gérer les clés',
    'total_handovers': 'Total événements',
    'given_out': 'Remis',
    'returned': 'Retourné',
    'currently_out': 'Actuellement sorti',

    // Services
    'services': 'Services',
    'service_payments': 'Paiements de Services',
    'generate_services': 'Générer des Paiements de Services',
    'service_statistics': 'Statistiques des Services',
    'service_type': 'Type de Service',
    'service_amount': 'Montant',
    'service_date': 'Date du Service',
    'service_status': 'Statut du Paiement',
    'service_paid': 'Payé',
    'service_unpaid': 'Non Payé',
    'total_service_fees': 'Total des Frais de Service',

    // Reports - updated
    'revenue_report': 'Rapport de Revenus',
    'payment_logs': 'Journaux de Paiement',
    'occupancy_report': 'Rapport d\'Occupation',
    'monthly_payments_report': 'Rapport des Paiements Mensuels',
    'monthly_payments_subtitle': 'Vue consolidée des loyers et paiements de services des locataires',
    'all_paid': 'Tout est payé',
    'try_adjusting_filters': 'Essayez d\'ajuster le mois, l\'année ou les filtres',
    'pending': 'en attente',
    'total': 'Total',
    'print_receipt': 'Imprimer le Reçu',
    'monthly_revenue': 'Revenu Mensuel',
    'building_revenue': 'Revenu du Bâtiment',
    'owner_revenue': 'Revenu du Propriétaire',
    'paid_until': 'Payé Jusqu\'au',
    'tenant_payments': 'Statut des Paiements Locataires',
    'next_billing_date': 'Prochaine Date de Facturation',
    'current_tenant': 'Locataire Actuel',
    'future_tenant_upcoming': 'Futur Locataire',

    // Logs
    'activity_logs': 'Journaux d\'Activité',
    'all_user_activities': 'Toutes les Activités des Utilisateurs',
    'all_user_activities_desc': 'Afficher toutes les activités et les modifications des utilisateurs',
    'tenant_logs': 'Historique des Locataires',
    'tenant_activity_desc': 'Afficher toutes les activités liées aux locataires',
    'revenue_by_user': 'Revenu Par Utilisateur',
    'monthly_revenue_by_user': 'Revenu Mensuel par Utilisateur',
    'revenue_breakdown_desc': 'Afficher la répartition des revenus par utilisateur pour un mois donné',
    'time': 'Heure',
    'entity': 'Entité',
    'details': 'Détails',
    'amount': 'Montant',
    'search_logs': 'Rechercher dans les journaux...',
    'filter_activities': 'Filtrer les activités',
    'action_type': 'Type d\'action',
    'entity_type': 'Type d\'entité',
    'apply_filter': 'Appliquer le filtre',
    'entries': 'entrées',
    'no_logs_matching_search': 'Aucun journal ne correspond à vos critères de recherche',
    'no_logs_available': 'Aucun journal d\'activité disponible',
    'showing_range': 'Affichage de {{start}} à {{end}} sur {{total}} entrées',
    'select_month': 'Sélectionner le mois',
    'payment_count': 'Nombre de paiements',
    'total_amount': 'Montant total',
    'percentage': 'Pourcentage',
    'no_revenue_data': 'Aucune donnée de revenus disponible pour ce mois',
    'january': 'Janvier',
    'february': 'Février',
    'march': 'Mars',
    'april': 'Avril',
    'may': 'Mai',
    'june': 'Juin',
    'july': 'Juillet',
    'august': 'Août',
    'september': 'Septembre',
    'october': 'Octobre',
    'november': 'Novembre',
    'december': 'Décembre',
    'notification_log': 'Journal des notifications',
    'all_notifications': 'Toutes les notifications',
    'all_channels': 'Tous les canaux',
    'all_statuses': 'Tous les statuts',
    'all_recipients': 'Tous les destinataires',
    'sent_at': 'Envoyé le',
    'template_subject': 'Modèle / Sujet',
    'email_templates': 'Modèles d\'e-mail',
    'active_templates_count_one': 'Un modèle actif',
    'active_templates_count_other': '{{count}} modèles actifs',
    'new_template': 'Nouveau modèle',
    'test_email_placeholder': 'Adresse e-mail de test (utilisée pour tous les boutons d\'envoi de test)',
    'no_email_templates': 'Pas encore de modèles d\'e-mail',
    'create_first_template': 'Créer le premier modèle',
    'rent_due': 'Loyer dû',
    'late_payment': 'Paiement en retard',
    'lease_renewal': 'Renouvellement de bail',
    'lease_expiry': 'Expiration du bail',
    'move_in': 'Emménagement',
    'move_out': 'Déménagement',
    'violation': 'Violation',
    'maintenance': 'Maintenance',
    'inspection': 'Inspection',
    'owner_payout': 'Paiement du propriétaire',
    'email_template_form_desc': 'Concevez des e-mails automatisés pour vos locataires et propriétaires',
    'update_template': 'Mettre à jour le modèle',
    'create_template': 'Créer un modèle',
    'visual': 'Visuel',
    'html': 'HTML',
    'live_preview': 'Aperçu en direct',
    'subject_line': 'Ligne d\'objet',
    'email_content': 'Contenu de l\'e-mail',
    'event_trigger': 'Déclencheur d\'événement',
    'internal_name': 'Nom interne',
    'dynamic_tags': 'Balises dynamiques',
    'starter_templates': 'Modèles de départ',
    'starter_templates_desc': 'Choisissez une base pour commencer à concevoir plus rapidement',
    'apply_design': 'Appliquer le design',
    'payment_settings': 'Paramètres de paiement',
    'accept_online_payments': 'Accepter les paiements en ligne',
    'stripe_connect_desc': 'Connectez votre compte Stripe pour permettre aux locataires de payer le loyer directement via le portail. Les fonds sont déposés directement sur votre compte bancaire, et notre système suit tout automatiquement.',
    'why_stripe_connect': 'Pourquoi utiliser Stripe Connect ?',
    'stripe_benefit_1': 'Collecte et suivi automatisés des loyers',
    'stripe_benefit_2': 'Dépôts directs sur votre compte bancaire',
    'stripe_benefit_3': 'Traitement sécurisé conforme aux normes PCI',
    'stripe_benefit_4': 'Prise en charge de la répartition des frais de plateforme',
    'start_stripe_onboarding': 'Démarrer l\'intégration Stripe',
    'stripe_account_status': 'État du compte Stripe',
    'active_verified': 'Actif et vérifié',
    'pending_onboarding': 'Action requise : Intégration en attente',
    'complete_setup': 'Terminer la configuration',
    'payments_enabled': 'Paiements activés',
    'payouts_enabled': 'Versements activés',
    'account_id': 'ID du compte',
    'payment_configuration': 'Configuration du paiement',
    'platform_fee_type': 'Type de frais de plateforme',
    'no_fee_direct': 'Sans frais (paiement direct)',
    'percentage_soon': 'Pourcentage (Bientôt disponible)',
    'fixed_soon': 'Montant fixe (Bientôt disponible)',
    'platform_fee_disabled': 'Les frais de plateforme QuadCores sont actuellement désactivés pour votre organisation.',
    'yes': 'Oui',
    'no': 'Non',
    'previous': 'Précédent',
    'next': 'Suivant',

    // Common
    'loading': 'Chargement...',
    'save': 'Enregistrer',
    'cancel': 'Annuler',
    'edit': 'Modifier',
    'delete': 'Supprimer',
    'add': 'Ajouter',
    'view': 'Voir',
    'search': 'Rechercher',
    'filter': 'Filtrer',
    'actions': 'Actions',
    'status': 'Statut',
    'refresh': 'Actualiser',
    'active': 'Actif',
    'inactive': 'Inactif',
    'yes': 'Oui',
    'no': 'Non',
    'confirm': 'Confirmer',
    'success': 'Succès',
    'error': 'Erreur',
    'warning': 'Avertissement',
    'info': 'Information',

    // App
    'apartment_system': 'Système d\'Appartements',
    'apartment_management': 'Gestion d\'Appartements',

    // Authentication
    'login': 'Connexion',
    'logout': 'Déconnexion',
    'login_to_continue': 'Connectez-vous pour continuer',
    'dont_have_account': "Vous n'avez pas de compte ?",
    'register': 'S\'inscrire',
    'username': 'Nom d\'utilisateur',
    'password': 'Mot de passe',
    'email': 'E-mail',
    'remember_me': 'Se souvenir de moi',
    'forgot_password': 'Mot de passe oublié ?',
    'forgot_password_instructions': 'Entrez votre nom d\'utilisateur ou votre e-mail pour recevoir un code de vérification',
    'send_code': 'Envoyer le code de vérification',
    'reset_password': 'Réinitialiser le mot de passe',
    'password_reset_success': 'Votre mot de passe a été réinitialisé avec succès',
    'password_min_length': 'Le mot de passe doit comporter au moins 8 caractères',
    'login_failed': 'Échec de la connexion',
    'invalid_credentials': 'Identifiants invalides',
    'security_verification': 'Vérification de sécurité',
    'verification_code_sent': 'Code de vérification envoyé à votre appareil enregistré.',
    'enter_valid_otp': 'Veuillez entrer un code de vérification valide',
    'verification_failed': 'Vérification échouée',
    'code_resent_success': 'Code de vérification renvoyé avec succès.',
    'too_many_attempts': 'Trop de tentatives. Veuillez réessayer plus tard.',
    'check_device_for_code': 'Vérifiez votre appareil pour le code',
    'verifying': 'Vérification...',

    // Navigation
    'dashboard': 'Tableau de Bord',
    'core': 'Principal',
    "accounting": "Comptabilité",
    'user_management': 'Gestion des Utilisateurs',
    'property_management': 'Gestion Immobilière',
    'maintenance_operations': 'Maintenance & Opérations',
    'financial_management': 'Gestion Financière',
    'financial_payments': 'Paiements',
    'financial_accounting': 'Comptabilité',
    'financial_portfolio': 'Portefeuille & KPIs',
    'portfolio_kpis': 'Portefeuille & KPI',
    'reports_analytics': 'Rapports & Analyses',
    'system': 'Système',

    // Users
    'system_users': 'Utilisateurs du Système',
    'user_list': 'Liste des Utilisateurs',
    'add_user': 'Ajouter un Utilisateur',
    'edit_user': 'Modifier l\'Utilisateur',
    'user_profile': 'Profil de l\'Utilisateur',
    'first_name': 'Prénom',
    'last_name': 'Nom',
    'phone_number': 'Numéro de Téléphone',
    'role': 'Rôle',
    'administrator': 'Administrateur',
    'front_desk': 'Réception',
    'created_at': 'Créé Le',
    'last_login': 'Dernière Connexion',
    'never': 'Jamais',

    // Properties
    'properties': 'Propriétés',
    'property_list': 'Liste des Propriétés',
    'add_property': 'Ajouter une Propriété',
    'property_owners': 'Propriétaires',
    'owner_list': 'Liste des Propriétaires',
    'add_owner': 'Ajouter un Propriétaire',
    'owners': 'Propriétaires',
    'owner_contracts': 'Contrats des Propriétaires',
    'management_agreements': 'Accords de Gestion',
    'add_contract': 'Ajouter un Contrat',
    'contract_details': 'Détails du Contrat',
    'no_contracts_message': 'Aucun contrat de gestion trouvé pour ce propriétaire.',
    'contract_type': 'Type de Contrat',
    'total_contract_value': 'Valeur Totale du Contrat',
    'contract_progress': 'Progression du Contrat',
    'installment_schedule': 'Échéancier de Paiement',

    // Tenants
    'tenants': 'Locataires',
    'tenant_list': 'Liste des Locataires',
    'add_tenant': 'Ajouter un Locataire',
    'owner_living': 'Propriétaire Résident',
    'future_tenant': 'Futur Locataire',

    // Payments
    'payments': 'Paiements',
    'all_payments': 'Tous les Paiements',
    'record_payment': 'Enregistrer un Paiement',
    'manage_services': 'Gérer les Services',
    'generate_payments': 'Générer des Paiements',
    'overdue_payments': 'Paiements en Retard',
    'receipts': 'Reçus',

    // Reports
    'reports': 'Rapports',
    'all_reports': 'Tous les Rapports',
    'reports_dashboard': 'Tableau de Bord des Rapports',
    'financial_reports': 'Rapports Financiers',
    'payment_reports': 'Rapports de Paiements',
    'property_reports': 'Rapports Immobiliers',
    'reports_1099_desc': 'Rapport IRS 1099-MISC pour les distributions de propriétés aux propriétaires',
    'vendor_1099_nec': 'Fournisseur 1099-NEC',
    'vendor_1099_desc': 'Déclaration annuelle à l\'IRS – fournisseurs payés ≥ 600 $ en rémunération de non-salariés',
    'rent_roll_desc': 'Aperçu de toutes les unités, de l\'état d\'occupation, du loyer et des détails du bail',
    'ar_aging_desc': 'Soldes impayés des locataires regroupés par ancienneté (0, 1-30, 31-60, 61-90, 90+)',
    'total_vendors': 'Total des Fournisseurs',
    'require_1099': '1099 Requis',
    'total_reportable': 'Total Déclarable',
    '1099_required': '1099 Requis',
    'below_threshold': 'Sous le seuil',
    'occupancy_rate': 'Taux d\'occupation',
    'scheduled_rent': 'Loyer prévu',
    'aging_breakdown': 'Répartition par ancienneté',

    // Settings
    'settings': 'Paramètres',
    'profile_settings': 'Paramètres du Profil',
    'system_settings': 'Paramètres du Système',
    'profile': 'Profil',
    'personal_details': 'Informations Personnelles',
    'security_settings': 'Paramètres de Sécurité',
    'change_password': 'Changer de Mot de Passe',
    'current_password': 'Mot de Passe Actuel',
    'new_password': 'Nouveau Mot de Passe',
    'confirm_new_password': 'Confirmer le Nouveau Mot de Passe',
    'organization_settings': 'Paramètres de l\'Organisation',
    'organization_name': 'Nom de l\'Organisation',
    'timezone': 'Fuseau Horaire',
    'subscription_plan': 'Abonnement',
    'trial_period': 'Période d\'Essai',
    'days_left': 'Il reste {{days}} jours',
    'subscription_required': 'Abonnement Requis',
    'subscription_expired_message': 'L\'accès à votre espace de travail est actuellement verrouillé. Renouvelez votre abonnement pour continuer à gérer vos propriétés.',
    'premium_experience_notice': 'Espace de Travail Premium Requis',
    'feature_locked_message': 'Cette fonctionnalité n\'est pas disponible dans votre forfait actuel. Veuillez mettre à niveau pour y accéder.',
    'renew_subscription': 'Renouveler l\'Abonnement',
    'update_profile_success': 'Profil mis à jour avec succès',
    'update_password_success': 'Mot de passe modifié avec succès',
    'update_system_success': 'Paramètres du système mis à jour avec succès',
    'settings_subtitle': 'Gérez votre compte et vos préférences système',
    'manage_your_account_and_system_preferences': 'Gérez votre compte et vos préférences système',
    'standard_plan': 'Forfait Standard',
    'enterprise_plan': 'Forfait Entreprise',

    // Notifications
    'notifications': 'Notifications',
    'view_all_notifications': 'Voir Toutes les Notifications',

    // WhatsApp Settings
    'whatsapp_settings': 'Paramètres WhatsApp',
    'whatsapp_settings_description': 'Notifications WhatsApp automatisées pour les locataires et propriétaires',
    'send_reminders_now': 'Envoyer les Rappels Maintenant',
    'general_settings': 'Paramètres Généraux',
    'whatsapp_enable': 'Activer les Notifications WhatsApp',
    'whatsapp_enable_sub': 'Activer ou désactiver tous les messages WhatsApp automatisés',
    'default_country_code': 'Indicatif de Pays par Défaut',
    'default_messaging_language': 'Langue de Messagerie par Défaut',
    'default_language_help': 'Utilisé si le locataire n\'a pas de langue préférée définie.',
    'tenant_rent_reminder': 'Rappel de Loyer pour Locataire',
    'enable_tenant_rent_reminders': 'Activer les Rappels',
    'tenant_rent_reminder_sub': 'Envoyer un rappel aux locataires avant ou après la date d\'échéance du paiement',
    'days_before_due': 'Jours Avant Échéance',
    'service_fee_reminder': 'Rappel de Frais de Service',
    'enable_service_fee_reminder': 'Activer le Rappel de Frais de Service',
    'service_fee_reminder_sub': 'Informer les locataires des prochains paiements de frais de service',
    'owner_reminder': 'Rappel pour Propriétaire',
    'enable_owner_reminders': 'Activer les Rappels pour Propriétaires',
    'owner_reminder_sub': 'Informer les propriétaires lorsque leurs locataires ont des paiements en retard',
    'payment_confirmation': 'Confirmation de Paiement',
    'send_on_payment': 'Envoyer lors du Paiement',
    'payment_confirmation_sub': 'Envoyé automatiquement au locataire lorsqu\'un paiement est enregistré',
    'preview_reminders': 'Aperçu des Rappels Automatisés',
    'notification_log_desc': 'Piste d\'audit de toutes les notifications sortantes',
    'total_sent': 'Total Envoyé',
    'failed_bounced': 'Échec / Rejeté',
    'email_templates_desc': 'Concevez des e-mails automatisés pour vos locataires et propriétaires',
    'test_email_address': 'Adresse e-mail de test',
    'payment_settings': 'Paramètres de Paiement',
    'accept_online_payments': 'Accepter les Paiements en Ligne',
    'connect_stripe_desc': 'Connectez votre compte Stripe pour permettre aux locataires de payer leur loyer directement via le portail.',
    'start_stripe_onboarding': 'Démarrer l\'onboarding Stripe',
    'active_verified': 'Actif & Vérifié',
    'action_required_onboarding': 'Action requise : Onboarding en attente',
    'webhooks_desc': 'Envoyez des événements à vos systèmes lorsque des choses se produisent dans APS',
    'recent_deliveries': 'Livraisons récentes',
    'failed_to_load_settings': 'Échec du chargement des paramètres',
    'settings_saved': 'Paramètres enregistrés avec succès',
    'failed_to_save': 'Échec de l\'enregistrement',
    'server_error': 'Erreur serveur',

    // Forms
    'personal_information': 'Informations Personnelles',
    'account_information': 'Informations du Compte',
    'security': 'Sécurité',
    'enter_first_name': 'Entrez le prénom',
    'enter_last_name': 'Entrez le nom',
    'enter_email': 'Entrez l\'e-mail',
    'enter_username': 'Entrez le nom d\'utilisateur',
    'enter_password': 'Entrez le mot de passe',
    'enter_phone_number': 'Entrez le numéro de téléphone',
    'confirm_password': 'Confirmer le Mot de Passe',
    'leave_blank_to_keep_current': 'Laissez vide pour conserver le mot de passe actuel',

    // Validation
    'first_name_required': 'Le prénom est requis',
    'last_name_required': 'Le nom est requis',
    'email_required': 'L\'e-mail est requis',
    'invalid_email': 'Veuillez entrer une adresse e-mail valide',
    'username_required': 'Le nom d\'utilisateur est requis',
    'username_too_short': 'Le nom d\'utilisateur doit comporter au moins 3 caractères',
    'password_required': 'Le mot de passe est requis',
    'password_too_short': 'Le mot de passe doit comporter au moins 6 caractères',
    'passwords_do_not_match': 'Les mots de passe ne correspondent pas',
    'phone_invalid_format': 'Veuillez entrer un numéro de téléphone valide',

    // Actions
    'saving': 'Enregistrement...',
    'deleting': 'Suppression...',
    'loading_users': 'Chargement des utilisateurs...',
    'loading_user_data': 'Chargement des données de l\'utilisateur...',
    'update': 'Mettre à jour',
    'activate': 'Activer',
    'deactivate': 'Désactiver',
    'show_all': 'Tout Afficher',
    'hide_inactive': 'Masquer les Inactifs',
    'all_roles': 'Tous les Rôles',
    'retry': 'Réessayer',

    // Messages
    'no_users_found': 'Aucun utilisateur trouvé',
    'user_created_successfully': 'Utilisateur créé avec succès',
    'user_updated_successfully': 'Utilisateur mis à jour avec succès',
    'user_deleted_successfully': 'Utilisateur supprimé avec succès',
    'confirm_deletion': 'Confirmer la Suppression',
    'delete_user_confirmation': 'Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action est irréversible.',

    // Dashboard
    'welcome_back': 'Bon retour',
    'dashboard_subtitle': 'Voici ce qui se passe avec vos propriétés aujourd\'hui.',
    'total_properties': 'Total des Propriétés',
    'active_tenants': 'Locataires Actifs',
    'monthly_revenue': 'Revenu Mensuel',
    'pending_payments': 'Paiements en Attente',
    'recent_activity': 'Activité Récente',
    'recent_transactions': 'Transactions Récentes',
    'quick_actions': 'Actions Rapides',
    'alerts_notifications': 'Alertes & Notifications',
    'showing': 'Affichage de',
    'of': 'sur',
    'users': 'utilisateurs',
    'contact': 'Contact',
    'user': 'Utilisateur',
    'active_properties': 'Propriétés Actives',
    'occupancy_rate_desc': 'Taux d\'occupation de {{rate}}%',
    'vs_last_month': 'vs mois dernier',
    'overdue_amount': '{{amount}} en retard',
    'payment_desc': 'Paiement de {{type}} - Appart {{number}}',
    'overdue_payments': 'Paiements en Retard',
    'overdue_payments_msg': '{{count}} locataires ont des paiements en attente totalisant {{amount}}',
    'view_details': 'Voir les Détails',
    'lease_expiring_soon': 'Bail Expirant Bientôt',
    'lease_expiring_msg': '{{count}} contrats de bail expirent dans les 30 jours',
    'review_leases': 'Examiner les Baux',
    'trial_ending_soon': 'Fin de Période d\'Essai Proche',
    'trial_ending_msg': 'Votre essai se termine dans {{days}} jours. Veuillez vous abonner pour éviter une interruption de service.',
    'upgrade_plan': 'Mettre à Niveau le Forfait',
    'last_7_days': 'Les 7 derniers jours',
    'last_30_days': 'Les 30 derniers jours',
    'last_3_months': 'Les 3 derniers mois',
    'last_year': 'L\'année dernière',
    'error_loading_dashboard': 'Erreur lors du chargement du tableau de bord',
    'reports_dashboard': 'Tableau de Bord des Rapports',
    'overview_of_financial_performance': 'Aperçu des performances financières et statistiques immobilières',
    'view_all_reports': 'Voir Tous les Rapports',
    'total_revenue': 'Revenu Total',
    'total_payments_count': '{{count}} paiements',
    'total_tenants': 'Total des Locataires',
    'new_tenants_this_year': '{{count}} nouveaux cette année',
    'total_buildings_count': '{{count}} bâtiments',
    'total_owners': 'Total des Propriétaires Résidents',
    'ended_contracts_count': '{{count}} contrats terminés',
    'urgent_action': 'Action Urgente',
    'monthly_revenue_year': 'Revenu Mensuel - {{year}}',
    'occupancy_rate': 'Taux d\'Occupation',
    'quick_reports': 'Rapports Rapides',
    'annual_revenue': 'Revenu Annuel',
    'yearly_breakdown': 'Répartition annuelle de tous les revenus',
    'building_revenue': 'Revenu par Bâtiment',
    'revenue_by_building': 'Répartition des revenus par bâtiment',
    'owner_revenue': 'Revenu par Propriétaire',
    'revenue_by_owner': 'Répartition des revenus par propriétaire immobilier',
    'detailed_payment_history': 'Historique détaillé des paiements et journaux',
    'occupied': 'Occupé',
    'vacant': 'Vacant',
    'maintenance': 'Maintenance',
    'excellent': 'Excellent',
    'good': 'Bon',
    'needs_improvement': 'Nécessite des Améliorations',
    'rent': 'Loyer',
    'service': 'Service',
    'deposit': 'Caution',
    'commission': 'Commission',
    'insurance': 'Assurance',
    'total': 'Total',
    'no_recent_payments': 'Aucun paiement récent trouvé',
    'no_overdue_payments': 'Aucun paiement en retard trouvé',
    'overdue': 'En Retard',
    'partial': 'Partiel',
    'expired': 'Expiré',
    'pending': 'En Attente',
    'paid': 'Payé',
    'apt': 'Appart',
    'days_overdue': 'jours de retard',
    'more_overdue_tenants': 'plus de locataires en retard',
    'error_fetching_occupancy': 'Erreur lors de la récupération des données d\'occupation',
    'failed_load_occupancy': 'Échec du chargement des statistiques d\'occupation',
    'error_fetching_payments': 'Erreur lors de la récupération des paiements récents',
    'failed_load_payments': 'Échec du chargement des paiements récents',
    'error_fetching_tenant_status': 'Erreur lors de la récupération du statut de paiement des locataires',
    'failed_load_tenant_status': 'Échec du chargement du statut de paiement des locataires',
    'failed_to_load_report_data': 'Échec du chargement des données du rapport',
    'mgmt_fee_collected': 'Frais de gestion perçus (cumul annuel)',
    'mgmt_fee_outstanding': 'Frais de gestion en attente',
    'active_tenant_arrears': 'Arriérés des locataires actifs',
    'all_accounts_settled': 'Tous les comptes sont réglés',
    'owner_payments': 'Paiements du Propriétaire',
    'all_months': 'Tous les Mois',

    "floor_number": "Étage {{number}}",
    "apartment_number": "Chambre {{number}}",

    // Sidebar specific translations
    'core': 'Principal',
    'user_management': 'Gestion des Utilisateurs',
    'property_management': 'Gestion Immobilière',
    'maintenance_operations': 'Maintenance & Opérations',
    'financial_management': 'Gestion Financière',
    'financial_payments': 'Paiements',
    'financial_accounting': 'Comptabilité',
    'financial_portfolio': 'Portefeuille & KPIs',
    'reports_analytics': 'Rapports & Analyses',
    'logs_audit': 'Journaux & Audit',
    'all_activities': 'Toutes les Activités',
    'tenant_activities': 'Activités des Locataires',
    'system': 'Système',
    'bookings': 'Réservations',
    'booking_list': 'Liste des Réservations',
    'new_booking': 'Nouvelle Réservation',
    'booking_calendar': 'Calendrier des Réservations',
    'waitlist': 'Liste d\'Attente',
    'analytics': 'Analyses',

    'system_users': 'Utilisateurs du Système',
    'user_list': 'Liste des Utilisateurs',
    'add_user': 'Ajouter un Utilisateur',

    'buildings': 'Bâtiments',
    'building_list': 'Liste des Bâtiments',
    'add_building': 'Ajouter un Bâtiment',

    'apartments': 'Appartements',
    'apartment_list': 'Liste des Appartements',
    'add_apartment': 'Ajouter un Appartement',

    'owners': 'Propriétaires',
    'owner_list': 'Liste des Propriétaires',
    'add_owner': 'Ajouter un Propriétaire',

    'tenants': 'Locataires',
    'tenant_list': 'Liste des Locataires',
    'add_tenant': 'Ajouter un Locataire',
    'overdue_rent': 'Loyers en Retard',

    'payments': 'Paiements',
    'all_payments': 'Tous les Paiements',
    'record_payment': 'Enregistrer un Paiement',
    'payment_stats': 'Statistiques de Paiement',

    'service_payments': 'Paiements de Services',
    'manage_services': 'Gérer les Services',
    'generate_payments': 'Générer des Paiements',
    'service_statistics': 'Statistiques de service',
    'finance': 'Finance',
    'transactions': 'Transactions',
    'service_charges': 'Frais de service',
    'owner_installments': 'Mensualités du propriétaire',
    'messages': 'Messages',
    'announcements_manager': 'Gestionnaire d\'annonces',
    'all_announcements': 'Toutes les annonces',
    'sales': 'Ventes',
    'sales_management': 'Gestion des ventes',
    'inspections': 'Inspections',
    'all_inspections': 'Toutes les inspections',
    'renewal_risk': 'Risque de renouvellement',
    'lease_renewals': 'Renouvellements de bail',
    'lease_applications': 'Demandes de location',
    'application_links': 'Liens de candidature',
    'leases': 'Baux',
    'violations': 'Violations',
    'notices': 'Avis',
    'screening': 'Filtrage',
    'documents': 'Documents',
    'amenities_parking': 'Équipements et Parking',

    // Messages
    'messages_title': 'Messages',
    'tenants_tab': 'Locataires',
    'owners_tab': 'Propriétaires',
    'no_conversations': 'Pas encore de conversations',
    'select_conversation_hint': 'Sélectionnez une conversation à gauche pour commencer à envoyer des messages',
    'type_message_placeholder': 'Tapez un message...',
    'your_inbox': 'Votre boîte de réception',
    'you_label': 'Vous : ',
    'mark_as_read': 'Marquer comme lu',
    'failed_to_load_messages': 'Échec du chargement des messages',
    'failed_to_load_chat_history': 'Échec du chargement de l\'historique de discussion',
    'failed_to_send_message': 'Échec de l\'envoi du message',

    // Expenses
    'expenses_title': 'Dépenses',
    'expenses_subtitle': 'Suivi des dépenses opérationnelles avec flux d\'approbation',
    'new_expense': 'Nouvelle dépense',
    'new_expense_subtitle': 'Enregistrer une dépense opérationnelle',
    'total_expenses': 'Total des dépenses',
    'approved_amount': 'Approuvé',
    'how_it_works': 'Comment ça fonctionne',
    'expense_hint1': 'Enregistrez tout coût payé pour un bâtiment : réparations, nettoyage, frais de gestion, etc.',
    'expense_hint2': 'Les dépenses marquées "En attente" doivent être approuvées avant d\'affecter le RNB',
    'expense_hint3': '"Facturer au propriétaire" inscrit la dépense directement sur le grand livre du propriétaire',
    'expense_hint4': 'RNB = Loyers encaissés - Dépenses approuvées',
    'search_expenses': 'Rechercher par description, fournisseur, catégorie...',
    'expense_records': 'Registres des dépenses',
    'no_expenses_found': 'Aucune dépense trouvée',

    // Storage / Inventory
    'storage_title': 'Stock',
    'storage_subtitle': 'Suivez les articles en stock et affectez-les aux appartements — comptabilisé automatiquement dans les Dépenses',
    'add_stock': 'Ajouter du stock',
    'stock_value': 'Valeur du stock',
    'items_in_storage': 'Articles en stock',
    'total_issued': 'Total sorti',
    'stock_on_hand': 'Stock disponible',
    'issuance_history': 'Historique des sorties',
    'quantity_on_hand': 'Disponible',
    'issue_to_apartment': 'Affecter à un appartement',
    'issue': 'Affecter',
    'storage_hint1': 'Enregistrez d\'abord les articles en stock : portes, fenêtres, équipements, etc. — aucun appartement requis pour l\'instant',
    'storage_hint2': '« Affecter à un appartement » déplace le stock vers une unité et comptabilise le coût automatiquement',
    'storage_hint3': 'Le coût affecté est comptabilisé comme une dépense en attente d\'approbation',
    'storage_hint4': 'Le récapitulatif par appartement affiche le coût total par unité, basé sur ce qui a réellement été affecté',
    'search_materials': 'Rechercher par article, appartement, fournisseur...',
    'no_materials_found': 'Rien ici pour l\'instant',
    'spend_by_apartment': 'Dépenses par appartement',
    'apartment_label': 'Appartement',
    'item_name': 'Article',
    'item_name_placeholder': 'ex. Porte intérieure, fenêtre à double vitrage',
    'items_logged': 'Articles',
    'quantity': 'Quantité',
    'quantity_required': 'La quantité est requise',
    'quantity_exceeds_stock': 'Seulement {{available}} disponible(s) en stock',
    'available_short': '{{qty}} disponible(s)',
    'unit_cost': 'Coût unitaire',
    'total_cost': 'Coût total',
    'select_apartment': 'Sélectionner un appartement',
    'stock_added': 'Stock ajouté',
    'material_issued': 'Affecté à l\'appartement et comptabilisé dans les dépenses',
    'failed_to_load_materials': 'Échec du chargement des données de stock',
    'failed_to_load_apartments': 'Échec du chargement des appartements — vérifiez votre connexion et réessayez',

    'approve': 'Approuver',
    'void': 'Annuler',
    'confirm_void': 'Annuler cette dépense ? Cela ne peut pas être annulé.',
    'expense_description_placeholder': 'ex : Service mensuel de lutte contre les nuisibles',
    'select_category': '— Sélectionner une catégorie —',
    'charge_to_owner': 'Facturer au propriétaire (sera inscrit au grand livre du propriétaire)',
    'create_expense': 'Créer une dépense',
    'expense_created': 'Dépense créée',
    'expense_approved': 'Dépense approuvée',
    'expense_voided': 'Dépense annulée',
    'invoice_number': 'N° de facture',
    'all_statuses': 'Tous les statuts',
    'failed_to_load_expenses': 'Échec du chargement des dépenses',
    'expense_rejected': 'Dépense rejetée',
    'confirm_reject': 'Rejeter cette dépense ? Cette action est irréversible.',
    'date_from': 'Date de début',
    'date_to': 'Date de fin',
    'failed_to_load': 'Échec du chargement des données',
    'assign_failed': 'Échec de l\'assignation',
    'unavailable': 'Indisponible',
    'filtered_by': 'Filtré par :',
    'calendar': 'Calendrier',
    'notes_placeholder': 'Notes supplémentaires…',
    'no_amenities_match_filter': 'Aucun équipement ne correspond au filtre sélectionné.',
    'all_amenities': 'Tous les équipements',
    'no_bookings_on_day': 'Aucune réservation ce jour-là.',
    'parking_assigned': 'Parking assigné',
    'parking_unassigned': 'Parking désassigné',
    'parking_space_deleted': 'Place de parking supprimée',
    'parking_space_created': 'Place de parking créée',
    'parking_space_updated': 'Place de parking mise à jour',
    'parking_spaces_generated': 'Places de parking générées en masse',
    'booking_deleted': 'Réservation supprimée',
    'parking_layout_hint': 'Assignez des rangées via Modifier l\'espace pour organiser votre plan de parking',
    'delete_amenity_title': 'Supprimer l\'équipement',
    'confirm_delete_amenity': 'Êtes-vous sûr de vouloir supprimer cet équipement ? Cette action est irréversible.',
    'delete_parking_space_title': 'Supprimer la place de parking',
    'confirm_delete_parking': 'Êtes-vous sûr de vouloir supprimer cette place de parking ? Cette action est irréversible.',
    'delete_booking_title': 'Supprimer la réservation',
    'confirm_delete_booking': 'Êtes-vous sûr de vouloir supprimer cette réservation ? Cette action est irréversible.',
    'unassign_parking_title': 'Désassigner le parking',
    'confirm_unassign_parking': 'Êtes-vous sûr de vouloir désassigner cette place de parking ?',
    'start_end_required': 'Numéros de début et de fin requis',
    'space_number_required': 'Le numéro d\'espace est requis',
    'row_zone': 'Rangée / Zone',
    'row_zone_hint': 'pour la disposition de la carte',
    'status_pending_approval': 'En attente',
    'status_approved': 'Approuvé',
    'status_voided': 'Annulé',
    'status_rejected': 'Rejeté',
    'owner_label': 'Propriétaire',
    'select_building': '— Sélectionner un bâtiment —',
    'payment_method': 'Mode de paiement',
    'method_bank_transfer': 'Virement bancaire',
    'method_cash': 'Espèces',
    'method_check': 'Chèque',
    'method_credit_card': 'Carte de crédit',
    'method_stripe': 'Stripe',
    'method_wire': 'Virement télégraphique',
    'method_other': 'Autre',
    'items_plural': 'articles',
    'item_singular': 'article',
    'all_buildings': 'Tous les bâtiments',

    // Late Fees
    'late_fee_mgmt': 'Gestion des frais de retard',
    'pending_charges': 'Frais en attente',
    'history_tab': 'Historique',
    'fee_settings': 'Paramètres des frais',
    'late_fees_disabled_hint': 'Les frais de retard sont désactivés — activez-les dans les paramètres',
    'tenants_due_fee': 'Locataires devant des frais de retard',
    'next_cron_run': 'Prochaine exécution automatique à 10h00 (heure de l\'organisation)',
    'apply_now': 'Appliquer maintenant',
    'applying': 'Application...',
    'waive': 'Exonérer',
    'waive_late_fee': 'Exonérer les frais de retard',
    'waive_reason_label': 'Motif',
    'waive_reason_placeholder': 'ex : Accord de paiement convenu, courtoisie pour la première fois, etc.',
    'confirm_waiver': 'Confirmer l\'exonération',
    'waiving': 'Exonération...',
    'failed_to_load_pending': 'Échec du chargement des frais en attente',
    'failed_to_load_history': 'Échec du chargement de l\'historique',
    'fee_waived': 'Frais exonérés',
    'failed_to_waive': 'Échec de l\'exonération',
    'late_fee_assessed': 'Frais de retard évalués',
    'failed_to_assess': 'Échec de l\'évaluation',
    'days_overdue': 'Jours de retard',
    'projected_fee': 'Frais prévus',
    'last_fee': 'Derniers frais',
    'waive_amount_label': 'Montant de l\'exonération ($)',
    'not_found': 'Introuvable',
    'never': 'Jamais',
    'balance': 'Solde',
    'source': 'Source',
    'auto_label': 'Auto',
    'manual_label': 'Manuel',
    'late_fees_disabled': 'Frais de retard désactivés',
    'of_rent': 'du loyer',
    'day_grace': 'jours de grâce',
    'no_pending_late_fees': 'Aucun locataire n\'a de frais de retard en attente pour le moment.',
    'enable_late_fees_hint': 'Activez les frais de retard dans les paramètres pour commencer le suivi.',
    'no_late_fee_records': 'Aucun enregistrement de frais de retard trouvé.',
    'all_late_fee_charges': 'Tous les frais de retard',
    'failed_to_load_owner_balances': 'Échec du chargement des soldes des propriétaires',
    'select_at_least_one_owner': 'Sélectionnez au moins un propriétaire',
    'confirm_bulk_payout': 'Payer {{count}} propriétaire(s) pour un total de {{amount}} ?',
    'bulk_payout_success': '{{count}} propriétaire(s) payé(s) — {{amount}} au total',
    'bulk_payout_failed': 'Échec du paiement en masse',
    'bulk_owner_payout': 'Paiement en masse des propriétaires',
    'bulk_payout_subtitle': 'Payer tous les propriétaires ayant des soldes impayés en un seul lot',
    'total_owed_all': 'Total dû (tous les propriétaires)',
    'owners_with_balance': 'Propriétaires avec solde',
    'selected_to_pay': 'Sélectionné pour payer',
    'balance_owed': 'Solde dû',
    'last_payout': 'Dernier paiement',
    'payout_settings': 'Paramètres de paiement',
    'period_month': 'Mois de la période',
    'payout_notes_placeholder': 'ex : Distribution mensuelle',
    'pay_owners_btn': 'Payer {{count}} propriétaire(s) · {{amount}}',
    'last_batch_results': 'Résultats du dernier lot',
    'wire_transfer': 'Virement télégraphique',
    'status_held': 'Retenu',
    'status_returned': 'Rendu',
    'status_not_collected': 'Non collecté',
    'error_loading_deposits': 'Échec du chargement des dépôts de garantie',
    'deposit_collected': 'Dépôt de garantie collecté',
    'deposit_returned': 'Dépôt de garantie rendu',
    'security_deposits_subtitle': 'Suivi des dépôts conforme — légalement séparé du loyer',
    'total_held': 'Total détenu',
    'active_deposits': 'Dépôts actifs',
    'deposits_returned': 'Dépôts rendus',
    'all_tenants_deposit_status': 'Tous les locataires — État du dépôt',
    'paid_on': 'Payé le',
    'collect': 'Collecter',
    'return': 'Rendre',
    'collect_security_deposit': 'Collecter le dépôt de garantie',
    'return_security_deposit': 'Rendre le dépôt de garantie',
    'damages_unpaid_rent': 'dommages, loyers impayés, etc.',
    'optional_notes': 'Notes optionnelles...',
    'record_collection': 'Enregistrer la collecte',
    'record_return': 'Enregistrer le retour',
    'deposit_amount_placeholder': 'ex. 1500.00',
    'error_loading_utility_data': 'Échec du chargement des données de services publics',
    'utility_account_created': 'Compte de service public créé',
    'reading_recorded_generate_bills': 'Relevé enregistré — générez les factures ci-dessous',
    'rubs_complete_msg': 'RUBS terminé — {{count}} locataires facturés {{amount_each}} chacun (total {{total}})',
    'no_pending_bills_to_charge': 'Aucune facture en attente à débiter',
    'confirm_charge_all_bills': 'Poster {{count}} factures en attente sur les grands livres des locataires ?',
    'confirm_charge_all_bills_title': 'Débiter toutes les factures en attente',
    'charge_all_success_msg': '{{count}} factures postées sur les grands livres !{{failed_msg}}',
    'generate_bills_btn': 'Générer les factures',
    'generate_from_meters': 'Générer depuis les compteurs',
    'charge_all_btn': 'Tout facturer ({{count}})',
    'bills_generated_msg': '{{count}} factures de services générées',
    'rubs_failed': 'Échec du calcul RUBS',
    'failed_to_update_account': 'Échec de la mise à jour du compte',
    'utility_management': 'Gestion des services publics',
    'utility_subtitle': 'Suivre les compteurs, les relevés et facturer les locataires',
    'add_account': 'Ajouter un compte',
    'utility_accounts': 'Comptes de services publics',
    'no_utility_accounts': 'Aucun compte — ajoutez-en un pour commencer',
    'provider': 'Fournisseur',
    'account_number_label': 'N° de compte',
    'meter_number_label': 'N° de compteur',
    'utility_bills': 'Factures de services publics',
    'no_bills_found_msg': 'Aucune facture trouvée — utilisez "Générer des factures"',
    'period': 'Période',
    'usage': 'Consommation',
    'charge_tenant': 'Facturer le locataire',
    'add_utility_account': 'Ajouter un compte de service public',
    'add_utility_account_subtitle': 'Enregistrer un nouveau compteur ou service',
    'utility_type': 'Type de service',
    'provider_name': 'Nom du fournisseur',
    'provider_placeholder': 'ex: EDF, Suez',
    'shared_meter': 'Compteur partagé (couvre tout le bâtiment)',
    'add_meter_reading': 'Ajouter un relevé',
    'reading_value': 'Relevé actuel',
    'reading_date': 'Date du relevé',
    'record_reading': 'Enregistrer le relevé',
    'error_loading_kpi_data': 'Échec du chargement des données KPI',
    'snapshot_complete': 'Instantané terminé',
    'snapshot_failed': 'Échec de l\'instantané',
    'kpi_dashboard': 'Tableau de bord KPI',
    'kpi_subtitle': 'Performance du portefeuille en direct — occupation, NOI, taux de capitalisation, taux de collecte',
    'capturing': 'Capture en cours...',
    'snapshot_now': 'Prendre un instantané',
    'occupancy_rate': 'Taux d\'occupation',
    'annual_gross_rent': 'Loyer brut annuel',
    'portfolio_value': 'Valeur du portefeuille',
    'total_units': 'Total des unités',
    'units_occupied_msg': '{{occupied}} sur {{total}} unités occupées',
    'per_month_suffix': '{{amount}} / mois',
    'equity_label_val': '{{amount}} de capitaux propres',
    'vacant_units_count': '{{count}} vacantes',
    'kpi_step1': 'Cliquez sur "Prendre un instantané" pour calculer les mesures d\'aujourd\'hui pour tous les bâtiments',
    'kpi_step2': 'L\'instantané s\'exécute automatiquement chaque nuit',
    'kpi_step3': 'Enregistrez les évaluations foncières dans la page Portefeuille pour débloquer le taux de capitalisation et le rendement',
    'per_building_metrics': 'Mesures par bâtiment',
    'no_snapshots_yet': 'Aucun instantané pour le moment — cliquez sur "Prendre un instantané" pour en générer',
    'collection_rate': 'Collecte',
    'monthly_noi': 'NOI mensuel',
    'cap_rate': 'Taux de capitalisation',
    'gross_yield': 'Rendement brut',
    'overdue_tenants': 'En retard',
    'investment_summary': 'Résumé des investissements',
    'current_value': 'Valeur actuelle',
    'purchase_cost': 'Coût d\'achat',
    'equity': 'Capitaux propres',
    'error_loading_portfolio_data': 'Échec du chargement des données du portefeuille',
    'valuation_recorded': 'Évaluation enregistrée',
    'investment_portfolio': 'Portefeuille d\'investissement',
    'portfolio_subtitle': 'Évaluation du portefeuille, capitaux propres, taux de capitalisation et rendement par bâtiment',
    'record_valuation': 'Enregistrer une évaluation',
    'total_portfolio_value': 'Valeur du portefeuille',
    'annualized_amount': '{{amount}} annualisé',
    'avg_cap_rate': 'Taux de capitalisation moyen',
    'annualized': 'Annualisé',
    'avg_gross_yield': 'Rendement brut moyen',
    'gross_rent_on_value': 'Loyer brut / valeur',
    'portfolio_step1': 'Cliquez sur "Enregistrer une évaluation" pour saisir la valeur marchande actuelle d\'un bâtiment',
    'portfolio_step2': 'Taux de cap. = NOI annuel ÷ Valeur foncière × 100',
    'portfolio_step3': 'Rendement brut = Loyer brut annuel ÷ Valeur foncière × 100',
    'portfolio_step4': 'Les données NOI proviennent du tableau de bord KPI — effectuez d\'abord un instantané',
    'per_building_breakdown': 'Répartition par bâtiment',
    'no_portfolio_data': 'Aucune donnée de portefeuille — effectuez d\'abord un instantané KPI, puis enregistrez les évaluations',
    'last_valuation': 'Dernière évaluation',
    'occupied_short': 'occ.',
    'no_valuation': 'Aucune évaluation',
    'update_value': 'Mettre à jour la valeur',
    'record_valuation_subtitle': 'Enregistrer la valeur marchande actuelle d\'un bâtiment',
    'appraised_value': 'Valeur expertisée',
    'valuation_date': 'Date',
    'method': 'Méthode',
    'record': 'Enregistrer',
    'error_loading_accounts': 'Échec du chargement des comptes',
    'error_loading_journal_entries': 'Échec du chargement des écritures de journal',
    'error_loading_trial_balance': 'Échec du chargement de la balance de vérification',
    'error_loading_pnl': 'Échec du chargement du compte de résultat',
    'gl_account_required_fields': 'Le code, le nom et le type sont obligatoires',
    'account_created': 'Compte créé',
    'journal_min_lines_error': 'Au moins 2 lignes sont requises',
    'entry_out_of_balance_error': 'Écriture déséquilibrée : débits {{debits}} ≠ crédits {{credits}}',
    'journal_account_required_error': 'Toutes les lignes doivent avoir un compte sélectionné',
    'journal_entry_posted': 'Écriture de journal comptabilisée',
    'reason_for_reversal_prompt': 'Motif d\'extourne :',
    'entry_reversed': 'Écriture extournée',
    'reversal_failed': 'Échec de l\'extourne',
    'chart_of_accounts': 'Plan comptable',
    'journal_entries': 'Écritures de journal',
    'trial_balance': 'Balance de vérification',
    'pnl_statement': 'Compte de résultat',
    'general_ledger': 'Grand livre',
    'gl_subtitle': 'Plan comptable, écritures, balance de vérification et résultat',
    'new_gl_account': 'Nouveau compte comptable',
    'normal_balance': 'Solde normal',
    'no_accounts_found': 'Aucun compte trouvé',
    'all_sources': 'Toutes les sources',
    'new_entry': 'Nouvelle écriture',
    'new_journal_entry': 'Nouvelle écriture de journal',
    'select_account': 'Sélectionner un compte...',
    'line_description_placeholder': 'Description de la ligne',
    'balanced_msg': '✓ Équilibré',
    'out_of_balance_amount': 'Déséquilibre de {{amount}}',
    'add_line': '+ Ajouter une ligne',
    'post_entry': 'Comptabiliser l\'écriture',
    'posting': 'Comptabilisation...',
    'no_journal_entries_found': 'Aucune écriture de journal trouvée',
    'reversed': 'Extourné',
    'posted': 'Comptabilisé',
    'draft': 'Brouillon',
    'lines_count': '{{count}} lignes',
    'as_of_date': 'À la date du',
    'balanced': 'Équilibré',
    'out_of_balance': 'Déséquilibré',
    'net': 'Net',
    'total_revenue': 'Total des revenus',
    'total_expenses': 'Total des dépenses',
    'net_income': 'Résultat net',
    'no_revenue_entries': 'Aucune écriture de revenu',
    'no_expense_entries': 'Aucune écriture de dépense',
    'select_date_range_run_msg': 'Sélectionnez une période et cliquez sur Exécuter',
    'asset': 'Actif',
    'liability': 'Passif',
    'revenue': 'Produit',
    'expense': 'Charge',
    'market': 'Marché',
    'income': 'Revenu',
    'cost': 'Coût',
    'broker_opinion': 'Avis de courtier',
    'appraisal': 'Expertise',
    'waive_confirm_hint': 'Exonération des frais de retard pour {{name}}. Cela ajoute une écriture de crédit à son grand livre — le débit initial est conservé pour l\'audit.',
    'enter_reason_error': 'Veuillez saisir un motif',
    'enter_valid_amount_error': 'Saisissez un montant valide',
    'confirm_manual_assess': 'Évaluer manuellement les frais de retard pour {{name}} ?',
    'search_late_fees': 'Rechercher par locataire, unité, bâtiment...',
    'page_info': 'Page {{current}} sur {{total}}',

    'reports': 'Rapports',
    'reports_dashboard': 'Tableau de Bord des Rapports',
    'revenue_report': 'Rapport de Revenus',
    'payment_logs': 'Journaux de Paiement',
    'occupancy_report': 'Rapport d\'Occupation',
    'tenant_payments': 'Paiements des Locataires',
    'building_revenue': 'Revenu du Bâtiment',
    'owner_revenue': 'Revenu du Propriétaire',

    'activity_logs': 'Journaux d\'Activité',
    'all_activities': 'Toutes les Activités',
    'tenant_activities': 'Activités des Locataires',
    'monthly_revenue': 'Revenu Mensuel',

    'settings': 'Paramètres',
    'profile_settings': 'Paramètres du Profil',
    'system_settings': 'Paramètres du Système',

    'logout': 'Déconnexion',
    'sales': 'Ventes',
    'inspections': 'Inspections',
    'maintenance_hub': 'Centre de maintenance',
    'vendors': 'Fournisseurs',
    'finance': 'Finance',
    'transactions': 'Transactions',
    'service_charges': 'Charges de service',
    'owner_installments': 'Versements du propriétaire',
    'financial_matrix': 'Matrice financière',
    'cash_flow_forecast': 'Prévisions sur 7 jours',
    'receivables': 'Créances',
    'receivables_sub': 'Argent qui vous est dû, par ancienneté.',
    'no_receivables': 'Personne ne doit rien.',
    'books_need_attention': 'La comptabilité nécessite une attention',
    'books_tie_out': 'Les créances correspondent au grand livre',
    'ar_gl_drift': 'Les créances ne correspondent pas au grand livre',
    'unmirrored_charges': 'frais',
    'unmirrored_payments': 'paiements',
    'not_in_receivables': 'pas encore dans les créances',
    'closed_periods': 'période(s) clôturée(s)',
    'fix_now': 'Corriger',
    'fixing': 'Correction…',
    'accounting_statement': 'Relevé →',
    'statement': 'relevé',
    'open_full_record': 'Ouvrir la fiche complète →',
    'credit_on_account': 'crédit sur le compte',
    'opening_balance': 'Solde d’ouverture',
    'closing_balance': 'Solde de clôture',
    'no_activity': 'Aucune activité sur cette période.',
    'charge': 'Frais',
    'kind_rent': 'Loyer',
    'kind_service': 'Frais de service',
    'kind_late_fee': 'Pénalité de retard',
    'kind_utility': 'Charges',
    'kind_parking': 'Parking',
    'kind_deposit': 'Dépôt',
    'kind_sale_installment': 'Échéance de vente',
    'kind_management_fee': 'Frais de gestion',
    'kind_maintenance_fee': 'Frais d’entretien',
    'kind_payment': 'Paiement',
    'ledger_activity_report': 'Activité du grand livre',
    'management_fee_report': 'Frais de gestion',
    'messages': 'Messages',
    'announcements_manager': 'Gestionnaire d\'annonces',
    'all_announcements': 'Toutes les annonces',
    'subscription': 'Abonnement',
    'contract_templates': 'Modèles de contrat',
    'whatsapp_and_sms': 'WhatsApp & SMS',
    'late_fees_org_config': 'Frais de retard & Config Org',
    'building_amenities': 'Équipements du bâtiment',
    'parking_spaces': 'Places de parking',
    'amenity_bookings': 'Réservations d\'équipements',
    'pm_schedules': 'Horaires PM',
    'work_orders': 'Bons de travail',
    'security_deposits': 'Dépôts de garantie',
    'expenses': 'Dépenses',
    'late_fees': 'Frais de retard',
    'bulk_owner_payout': 'Paiement groupé aux propriétaires',
    'utilities': 'Services publics',
    'kpi_dashboard': 'Tableau de bord KPI',
    'portfolio': 'Portefeuille',
    'general_ledger': 'Grand livre général',
    'reports_1099': 'Rapports 1099',
    'notification_log': 'Journal des notifications',
    'all_messages': 'Tous les messages',
    'notification_log': 'Journal des notifications',

    // AI Intelligence & Sidebar
    'ai_intelligence': 'Intelligence Artificielle',
    'rent_pricing_ai': 'Tarification Locative IA',
    'churn_prediction': 'Prédiction de Churn',
    'showings': 'Visites',
    'tenant_surveys': 'Enquêtes Locataires',
    'insurance': 'Assurance',
    'vendor_1099': 'Fournisseur 1099',
    'rent_roll': 'Registre des Loyers',
    'ar_aging': 'Balance Âgée',
    'webhooks': 'Webhooks',

    // AI Rent Pricing Page
    'ai_rent_pricing': 'Tarification Locative IA',
    'ai_rent_pricing_desc': 'Obtenez des suggestions de loyer basées sur l\'IA selon vos comparables de portefeuille, l\'occupation et les tendances de renouvellement',
    'select_unit_to_analyze': 'Sélectionner l\'unité à analyser',
    'choose_an_apartment': 'Choisir un appartement...',
    'analyze': 'Analyser',
    'analyzing': 'Analyse en cours...',
    'ai_recommended_rent': 'Loyer Recommandé par l\'IA',
    'range': 'Plage',
    'high_confidence': 'Haute',
    'medium_confidence': 'Moyenne',
    'low_confidence': 'Faible',
    'confidence_suffix': 'confiance',
    'comparable_units_found': 'Unités Comparables ({{count}} trouvées)',
    'avg_comparable_rent': 'Moyenne : {{amount}}/mois',
    'vs_suggestion': 'vs suggestion',
    'select_unit_analyze_desc': 'Sélectionnez une unité et cliquez sur Analyser',
    'claude_analyze_desc': 'L\'IA analysera les comparables, l\'occupation et les tendances pour suggérer le loyer optimal',

    // Churn Prediction Page
    'churn_prediction_desc': 'Probabilité de renouvellement par l\'IA pour tous les locataires actifs',
    'run_ai_scoring': 'Lancer le Scoring IA',
    'running': 'En cours...',
    'high_churn_risk': 'Risque de Départ Élevé',
    'medium_risk': 'Risque Moyen',
    'likely_to_renew': 'Probable de Renouveler',
    'no_churn_scores': 'Pas encore de scores de churn',
    'run_scoring_desc': 'Cliquez sur "Lancer le Scoring IA" pour analyser tous les locataires actifs',
    'run_scoring_now': 'Lancer le Scoring Maintenant',
    'renewal_score': 'Score de Renouvellement',
    'risk_level': 'Niveau de Risque',
    'lease_ends': 'Fin du Bail',
    'key_factors': 'Facteurs Clés',
    'send_offer': 'Envoyer Offre',
    'late_payments_6m': '{{count}} paiements en retard',
    'current_balance_factor': 'Solde de ${{amount}}',
    'prior_renewals_factor': '{{count}} renouvellements',

    // Showings Page
    'showings_desc': 'Planifier et suivre les visites de propriétés pour les prospects',
    'schedule_showing': 'Planifier une Visite',
    'upcoming': 'À venir',
    'today': 'Aujourd\'hui',
    'no_shows': 'Absences',
    'all': 'Tout',
    'no_showings_found': 'Aucune visite trouvée',
    'schedule_first_showing': 'Planifier la Première Visite',
    'prospect': 'Prospect',
    'unit': 'Unité',
    'date_and_time': 'Date et Heure',
    'scheduled': 'Planifié',
    'completed': 'Terminé',
    'cancelled': 'Annulé',
    'no_show': 'Absence',
    'edit_showing': 'Modifier la Visite',
    'prospect_name': 'Nom du Prospect',
    'prospect_phone': 'Téléphone',
    'prospect_email': 'Email',
    'start_time': 'Heure de Début',
    'end_time': 'Heure de Fin',
    'assigned_to': 'Assigné à',
    'notes': 'Notes',

    // Insurance Page
    'insurance_tracking': 'Suivi des Assurances',
    'insurance_desc': 'Gérer les polices d\'assurance locataire, propriétaire et bâtiment',
    'add_policy': 'Ajouter une Police',
    'expiring_30d': 'Expire dans 30j',
    'total_coverage': 'Couverture Totale',
    'all_status': 'Tous les Statuts',
    'all_types': 'Tous les Types',
    'no_policies_found': 'Aucune police trouvée',
    'add_first_policy': 'Ajouter la Première Police',
    'entity': 'Entité',
    'insurer': 'Assureur',
    'policy_type': 'Type de Police',
    'coverage': 'Couverture',
    'expiry': 'Expiration',
    'expired_days_ago': 'Expiré il y a {{days}}j',
    'days_left': '{{days}}j restants',
    'edit_policy': 'Modifier la Police',
    'entity_type': 'Type d\'Entité',
    'policy_number': 'Numéro de Police',
    'coverage_amount': 'Montant de Couverture',
    'annual_premium': 'Prime Annuelle',
    'start_date': 'Date de Début',
    'expiry_date': 'Date d\'Expiration',
    'document_url': 'URL du Document (Lien COI)',

    // Survey Results Page
    'tenant_surveys_desc': 'Évaluations CSAT et commentaires des locataires',
    'overall_rating': 'Note Globale',
    'distribution': 'Distribution',
    'by_category': 'Par Catégorie',
    'no_surveys_yet': 'Pas encore d\'enquêtes',
    'tenants_submit_feedback_desc': 'Les locataires peuvent soumettre leurs commentaires via leur portail',

    // Financial Matrix
    'financial_matrix_subtitle': 'Vue unifiée de toute l\'activité financière pour toutes les unités',
    'total_charged': 'Total facturé',
    'total_collected': 'Total collecté',
    'overdue_balance': 'Solde en retard',
    'partial_balance': 'Solde partiel',
    'all_floors': 'Tous les étages',
    'floor_label': 'Étage',
    'legend_paid': 'Payé',
    'legend_partial': 'Partiel',
    'legend_overdue': 'En retard',
    'legend_upcoming': 'À venir',
    'legend_no_charges': 'Pas de charges',
    'table_unit': 'Unité',
    'table_now': 'maintenant',
    'no_apartments_found_building': 'Aucun appartement trouvé pour ce bâtiment.',
    'view_all': 'Tout',
    'view_rent': 'Loyer',
    'view_service': 'Service',
    'view_sales': 'Ventes',

    // Cash Flow Forecast
    'cash_flow_subtitle': 'Prochains paiements attendus des locataires et propriétaires',
    'expected_this_period': 'Attendu cette période',
    'total_overdue_balance': 'Solde total en retard',
    'collected_today': 'Collecté aujourd\'hui',
    'no_upcoming_payments': 'Aucun paiement à venir pour cette période.',
    'today': 'Aujourd\'hui',
    'overdue_label': 'EN RETARD',
    'expected_label': 'attendu',

    // Quick Pay
    'quick_pay': 'Paiement rapide',
    'recording': 'Enregistrement...',
    'record_payment_btn': 'Enregistrer le paiement de {{amount}}',
    'no_active_tenant_error': 'Aucun locataire actif — le paiement ne peut pas être enregistré ici.',
    'view_full_ledger': 'Voir le grand livre complet pour {{name}}',
    'full_payment_form': 'Formulaire de paiement complet',
    'enter_valid_amount': 'Entrez un montant valide',
    'no_active_tenant_found': 'Aucun locataire actif trouvé pour cette unité',
    'payment_recorded_success': 'Paiement enregistré avec succès',
    'treasury_quick_pay': 'Paiement Rapide Trésorerie',
    'payment_amount': 'Montant du paiement',
    'memo': 'Mémo / Référence',
    'add_a_note_about_this_treasury_event': 'Ajouter une note sur cet événement...',
    'view_owner_file_and_distribution': 'Voir le dossier propriétaire',
    'view_resident_ledger': 'Voir le grand livre résident',
    'processing': 'Traitement...',
    'confirm_and_record': 'Confirmer & Enregistrer',
    'no_entity_found': 'Aucun locataire ou propriétaire trouvé pour cette unité',
    'owner_view': 'Propriétaire',
    'tenant_view': 'Locataire',
    'search_owner_unit_building': 'Rechercher propriétaire, unité, immeuble...',
    'showing_all_installments': 'Affichage de toutes les {{count}} échéances',
    'showing_overdue_within_days': 'Affichage des en retard + dus dans {{days}} jours · {{hidden}} échéances futures masquées',
    'hide_future_count': 'Masquer les futurs ({{count}})',
    'show_all_future_count': 'Afficher tous les futurs ({{count}})',
    'no_overdue_upcoming_all_clear': 'Aucun paiement en retard ou à venir — tout est en ordre !',
    'no_records_match_search': 'Aucun enregistrement ne correspond à votre recherche.',

    // Months Short
    'jan_short': 'Jan', 'feb_short': 'Fév', 'mar_short': 'Mar', 'apr_short': 'Avr', 'may_short': 'Mai', 'jun_short': 'Jun',
    'jul_short': 'Jul', 'aug_short': 'Août', 'sep_short': 'Sep', 'oct_short': 'Oct', 'nov_short': 'Nov', 'dec_short': 'Déc',

    // Months Full
    'january': 'Janvier', 'february': 'Février', 'march': 'Mars', 'april': 'Avril', 'may': 'Mai', 'june': 'Juin',
    'july': 'Juillet', 'august': 'Août', 'september': 'Septembre', 'october': 'Octobre', 'november': 'Novembre', 'december': 'Décembre',

    // AI Assistant
    'ai_assistant': 'Assistant IA',
    'ask_ai': 'Demander à l\'IA',
    'ai_greeting': "Bonjour ! Je suis votre analyste financier IA. Comment puis-je vous aider aujourd'hui ?",
    'ai_error': "Désolé, je n'ai pas pu traiter cela. Veuillez réessayer.",
    'analyzing_data': 'Analyse des données...',
    'ai_placeholder': 'Que souhaitez-vous savoir ?',
    'overdue_tenants_q': 'Quels locataires sont en retard ?',
    'revenue_30d_q': 'Revenus des 30 derniers jours ?',
    'expenses_month_q': 'Dépenses ce mois-ci ?',
    'utility_pending_q': 'Factures de services publics en attente ?',
    'kpi_noi_summary_q': 'Résumé KPI & NOI ?',
    'security_deposits_q': 'Dépôts de garantie détenus ?',
    'late_fees_q': 'Frais de retard facturés ?',
    'owner_payouts_q': 'Paiements aux propriétaires ce mois-ci ?',

    // Apartment Detail View
    'loading_apartment_details': 'Chargement des détails de l\'appartement...',
    'error_loading_apartment': 'Erreur lors du Chargement de l\'Appartement',
    'try_again': 'Réessayer',
    'back_to_apartments': 'Retour aux Appartements',
    'apartment_not_found': 'Appartement Non Trouvé',
    'apartment_not_found_message': 'L\'appartement que vous recherchez n\'existe pas ou a été supprimé.',

    'building_and_location': 'Bâtiment & Emplacement',
    'building': 'Bâtiment',
    'floor': 'Étage',
    'address': 'Adresse',

    'apartment_details': 'Détails de l\'Appartement',
    'apartment_type': 'Type',
    'size': 'Taille',
    'furnished': 'Meublé',

    'owner_information': 'Informations sur le Propriétaire',
    'owner_name': 'Nom',
    'owner_contact': 'Contact',

    'additional_information': 'Informations Supplémentaires',
    'created_at': 'Créé Le',
    'updated_at': 'Dernière Mise à Jour',

    'status_management': 'Gestion des Statuts',
    'status_vacant': 'Vacant',
    'status_occupied': 'Occupé',
    'status_maintenance': 'En Maintenance',
    'status_vacant_description': 'Disponible à la location ou au bail',
    'status_occupied_description': 'Actuellement loué à un locataire',
    'status_maintenance_description': 'En maintenance ou rénovation',
    'change_status': 'Changer le Statut En',

    'quick_actions': 'Actions Rapides',
    'create_lease': 'Créer un Bail',
    'view_tenant_info': 'Voir les Infos du Locataire',
    'mark_maintenance_complete': 'Marquer la Maintenance comme Terminée',
    'view_building': 'Voir le Bâtiment',
    'edit_apartment': 'Modifier l\'Appartement',

    'same_building_apartments': 'Même Bâtiment',
    'view_all_apartments_in_building': 'Voir Tous les Appartements du Bâtiment',
    'view_vacant_apartments': 'Voir les Appartements Vacants',

    // Delete confirmation
    'delete_apartment_confirmation': 'Êtes-vous sûr de vouloir supprimer l\'appartement "{{name}}" ? Cette action est irréversible.',

    // Apartment Form
    'loading_apartment_data': 'Chargement des données de l\'appartement...',
    'edit_apartment': 'Modifier l\'Appartement',
    'add_new_apartment': 'Ajouter un Nouvel Appartement',

    'basic_information': 'Informations de Base',
    'apartment_number': 'Numéro d\'Appartement',
    'enter_apartment_number': 'Entrez le numéro d\'appartement',
    'floor_number': 'Numéro d\'Étage',
    'enter_floor_number': 'Entrez le numéro d\'étage',
    'size_sqm': 'Taille (m²)',
    'enter_size': 'Entrez la taille en mètres carrés',
    'apartment_type': 'Type d\'Appartement',
    'select_apartment_type': 'Sélectionnez le type d\'appartement',
    'select_building': 'Sélectionnez le bâtiment',
    'furnished': 'Meublé',

    // Validation messages
    'floor_required': 'L\'étage est requis',
    'apartment_number_required': 'Le numéro d\'appartement est requis',
    'size_required': 'La taille est requise',
    'type_required': 'Le type est requis',
    'building_required': 'Le bâtiment est requis',
    'invalid_size': 'La taille doit être supérieure à 0',

    // Form actions
    'update': 'Mettre à Jour',
    'save': 'Enregistrer',
    'saving': 'Enregistrement...',

    // Apartment List
    'apartments': 'Appartements',
    'search_apartments': 'Rechercher des appartements...',
    'filter': 'Filtrer',
    'grid_view': 'Grille',
    'list_view': 'Liste',
    'add_apartment': 'Ajouter un Appartement',
    'all_buildings': 'Tous les Bâtiments',
    'all_types': 'Tous les Types',
    'all_statuses': 'Tous les Statuts',
    'all': 'Tout',
    'vacant_apartments': 'Appartements Vacants',
    'occupied_apartments': 'Appartements Occupés',
    'maintenance_apartments': 'En Maintenance',
    'loading_apartments': 'Chargement des appartements...',
    'error_loading_apartments': 'Erreur lors du Chargement des Appartements',
    'no_apartments_found': 'Aucun Appartement Trouvé',
    'no_apartments_message': 'Il n\'y a pas encore d\'appartements dans le système.',
    'create_first_apartment': 'Créer le Premier Appartement',
    'showing_filtered_results': 'Affichage de {{showing}} sur {{total}} appartements',

    // Statuses
    'vacant': 'Vacant',
    'occupied': 'Occupé',
    'maintenance': 'En Maintenance',

    // Apartment card
    'furnished': 'Meublé',

    // Delete confirmation
    'delete_apartment_confirmation': 'Êtes-vous sûr de vouloir supprimer l\'appartement "{{name}}" ? Cette action est irréversible.',
    'deleting': 'Suppression...',

    // Bulk Apartment Creator
    'bulk_apartment_creation': 'Création d\'Appartements en Masse',
    'preview': 'Aperçu',
    'apartment_number_format': 'Format du Numéro d\'Appartement',
    'format_pattern': 'Modèle de Format',
    'format_pattern_help': 'Utilisez {floor} pour le numéro d\'étage et {unit} pour le numéro d\'unité. Exemple : {floor}{unit} = 0201',
    'preview_example': 'Exemple d\'Aperçu',
    'floor_plans': 'Plans d\'Étage',
    'add_floor_plan': 'Ajouter un Plan d\'Étage',
    'floor_plan_number': 'Plan d\'Étage {number}',
    'floors_comma_separated': 'Étages (séparés par des virgules)',
    'unit_types': 'Types d\'Unités',
    'add_unit_type': 'Ajouter un Type d\'Unité',
    'unit_type_number': 'Type d\'Unité {number}',
    'name': 'Nom',
    'quantity': 'Quantité',
    'type': 'Type',
    'area_sqm': 'Surface (m²)',
    'furnished': 'Meublé',
    'apartment_preview_count': 'Aperçu des Appartements ({count} unités)',
    'floor_unit_type': 'Étage {floor} • {type}',
    'close': 'Fermer',
    'create_apartments': 'Créer les Appartements',
    'create_apartments_count': 'Créer {count} Appartements',
    'creating_apartments': 'Création des Appartements...',
    'add_at_least_one_floor_plan': 'Veuillez ajouter au moins un plan d\'étage',
    'no_apartments_to_create': 'Aucun appartement à créer',

    'building_name_required': 'Le nom du bâtiment est requis',
    'building_address_required': 'L\'adresse du bâtiment est requise',
    'invalid_floors': 'Le nombre total d\'étages doit être d\'au moins 1',
    'invalid_apartments': 'Le nombre total d\'appartements doit être d\'au moins 0',
    'loading_building_data': 'Chargement des données du bâtiment...',
    'edit_building': 'Modifier le Bâtiment',
    'add_new_building': 'Ajouter un Nouveau Bâtiment',
    'basic_information': 'Informations de Base',
    'building_name': 'Nom du Bâtiment',
    'enter_building_name': 'Entrez le nom du bâtiment',
    'total_floors': 'Nombre Total d\'Étages',
    'number_of_floors': 'Nombre d\'étages',
    'total_apartments': 'Nombre Total d\'Appartements',
    'number_of_apartments': 'Nombre d\'appartements',
    'address': 'Adresse',
    'enter_complete_building_address': 'Entrez l\'adresse complète du bâtiment',
    'cancel': 'Annuler',
    'saving': 'Enregistrement...',
    'update': 'Mettre à Jour',
    'save': 'Enregistrer',

    'buildings': 'Bâtiments',
    'search_buildings': 'Rechercher des bâtiments...',
    'bulk_add_apartments': 'Ajout en Masse d\'Appartements',
    'add_building': 'Ajouter un Bâtiment',
    'loading_buildings': 'Chargement des bâtiments...',
    'error_loading_buildings': 'Erreur lors du Chargement des Bâtiments',
    'try_again': 'Réessayer',
    'no_buildings_found': 'Aucun Bâtiment Trouvé',
    'no_buildings_yet': 'Pas Encore de Bâtiments',
    'no_buildings_match_search': 'Aucun bâtiment ne correspond à "{{search}}"',
    'no_buildings_message': 'Il n\'y a pas encore de bâtiments dans le système. Ajoutez votre premier bâtiment pour commencer.',
    'create_first_building': 'Créer le Premier Bâtiment',
    'showing_filtered_results': 'Affichage de {{showing}} sur {{total}} bâtiments',
    'floors': 'Étages',
    'apartments': 'Appartements',
    'occupancy': 'Occupation',
    'vacant': 'Vacant',
    'occupied': 'Occupé',
    'no_apartments_yet': 'Pas encore d\'appartements',
    'add_apartments': '+ Ajouter des Appartements',
    'confirm_deletion': 'Confirmer la Suppression',
    'delete_building_confirmation': 'Êtes-vous sûr de vouloir supprimer le bâtiment "{{name}}" ? Cette action est irréversible.',
    'cancel': 'Annuler',
    'deleting': 'Suppression...',
    'delete': 'Supprimer',
    'create_building_first': 'Veuillez d\'abord créer un bâtiment',
    'create': 'Créer des Appartements',
    'unnamed_building': 'Bâtiment Sans Nom',
    'no_address_provided': 'Aucune adresse fournie',

    'select_building_for_bulk_creation': 'Sélectionnez un Bâtiment pour la Création en Masse d\'Appartements',

    'loading_building_details': 'Chargement des détails du bâtiment...',
    'error_loading_building': 'Erreur lors du Chargement du Bâtiment',
    'try_again': 'Réessayer',
    'back_to_buildings': 'Retour aux Bâtiments',
    'building_not_found': 'Bâtiment Non Trouvé',
    'building_not_found_message': 'Le bâtiment que vous recherchez n\'existe pas ou a été supprimé.',
    'add_apartment': 'Ajouter un Appartement',
    'edit_building': 'Modifier le Bâtiment',
    'generate_reports': 'Générer des Rapports',
    'total_apartments': 'Total des Appartements',
    'units': 'unités',
    'across_floors': 'Sur {{floors}} étages',
    'vacant_apartments': 'Vacant',
    'available_for_rent': 'Disponible à la location',
    'no_vacancies': 'Aucune vacance',
    'occupancy_rate': 'Taux d\'Occupation',
    'occupied_units': 'unités occupées',
    'maintenance_apartments': 'Maintenance',
    'needs_attention': 'Nécessite de l\'attention',
    'average_apartment_size': 'Taille Moyenne',
    'furnished_apartments': 'Meublé',
    'utility_status': 'Statut des Services Publics',
    'water': 'Eau',
    'electricity': 'Électricité',
    'internet': 'Internet',
    'hide_details': 'Masquer les Détails',
    'show_details': 'Afficher les Détails',
    'search_apartments': 'Rechercher des appartements, propriétaires, locataires...',
    'all_statuses': 'Tous les Statuts',
    'vacant': 'Vacant',
    'occupied': 'Occupé',
    'maintenance': 'Maintenance',
    'top_floor_first': 'Dernier Étage en Premier',
    'ground_floor_first': 'Rez-de-chaussée en Premier',
    'showing_results': 'Affichage de {{count}} sur {{total}} appartements',
    'matching': 'correspondant',
    'with_status': 'avec le statut',
    'no_apartments_found': 'Aucun Appartement Trouvé',
    'no_apartments_match_filters': 'Aucun appartement ne correspond à vos filtres actuels.',
    'clear_filters': 'Effacer les Filtres',
    'floor_number': 'Étage {{number}}',
    'apartments': 'appartements',
    'owner': 'Propriétaire',
    'status': 'Statut',
    'vacant_status': 'Disponible',
    'maintenance_status': 'En Maintenance',
    'furnished': 'Meublé',
    'unfurnished': 'Non Meublé',
    'no_matching_apartments_on_floor': 'Aucun appartement à l\'étage {{floor}} ne correspond à vos filtres actuels.',
    'construction_year': 'Année de Construction : {{year}}',

    'activity_logs': 'Journaux d\'Activité',
    'track_all_system_activities': 'Suivez toutes les activités et modifications du système',
    'filter': 'Filtrer',
    'export_to_excel': 'Exporter vers Excel',
    'exporting': 'Exportation...',
    'filter_logs': 'Filtrer les Journaux',
    'action_type': 'Type d\'Action',
    'all_actions': 'Toutes les Actions',
    'entity_type': 'Type d\'Entité',
    'all_entities': 'Toutes les Entités',
    'entries_per_page': 'Entrées Par Page',
    'start_date': 'Date de Début',
    'end_date': 'Date de Fin',
    'reset': 'Réinitialiser',
    'apply_filter': 'Appliquer le Filtre',
    'previous': 'Précédent',
    'next': 'Suivant',
    'tenant_activity_logs': 'Journaux d\'Activité Locataires',
    'payment_activity_logs': 'Journaux d\'Activité Paiements',
    'building_activity_logs': 'Journaux d\'Activité Bâtiments',
    'apartment_activity_logs': 'Journaux d\'Activité Appartements',
    'owner_activity_logs': 'Journaux d\'Activité Propriétaires',
    'user_activity_logs': 'Journaux d\'Activité Utilisateurs',
    'system_activity_logs': 'Journaux d\'Activité Système',

    'monthly_revenue_by_user': 'Revenu Mensuel par Utilisateur',
    'export_to_excel': 'Exporter vers Excel',
    'exporting': 'Exportation...',
    'total_revenue': 'Revenu Total',
    'total_payments': 'Total des Paiements',
    'recorded_by': 'Enregistré par',
    'average_payment': 'Paiement Moyen',
    'per_transaction': 'Par transaction',
    'revenue_by_user': 'Revenu par Utilisateur',
    'no_revenue_data': 'Aucune Donnée de Revenu',
    'no_revenue_data_message': 'Aucun enregistrement de paiement trouvé pour {{month}} {{year}}. Essayez de sélectionner un autre mois ou une autre année.',

    'loading_owner_data': 'Chargement des données du propriétaire...',
    'error_loading_owner': 'Erreur lors du Chargement du Propriétaire',
    'back_to_owners': 'Retour aux Propriétaires',
    'send_reminder': 'Envoyer un Rappel',
    'edit': 'Modifier',
    'overview': 'Aperçu',
    'properties': 'Appartements',
    'payments': 'Paiements',
    'contracts': 'Contrats',
    'outstanding': 'Impayé',
    'financial_overview': 'Aperçu Financier',
    'portfolio_summary': 'Résumé du Portefeuille',
    'financial_ledger': 'Livre Financier',
    'no_installments': 'Aucun versement trouvé dans votre livre.',
    'total_outstanding': 'Total Impayé',
    'management_agreement': 'Accord de Gestion',
    'my_agreements': 'Mes Accords',
    'active_agreements': 'Accords Actifs',
    'no_active_agreements': 'Aucun Accord Actif',
    'remaining': 'Restant',
    'total_value': 'Valeur Totale',
    'contact_information': 'Informations de Contact',
    'property_overview': 'Aperçu de la Propriété',
    'add_apartment': 'Ajouter un Appartement',
    'no_properties': 'Aucun Appartement',
    'no_properties_message': 'Ce propriétaire n\'a pas encore d\'appartements.',
    'add_first_property': 'Ajouter le Premier Appartement',
    'view_details': 'Voir les Détails',
    'payment_history': 'Historique des Paiements',
    'no_payments': 'Aucun Paiement',
    'no_payments_message': 'Aucun paiement n\'a encore été enregistré.',
    'outstanding_fees': 'Frais Impayés',
    'no_outstanding_fees': 'Aucun Frais Impayé',
    'all_fees_paid': 'Tous les frais sont à jour.',
    'total_outstanding': 'Total Impayé',
    'add_payment': 'Ajouter un Paiement',
    'property': 'Appartement',
    'select_property': 'Sélectionner un Appartement',
    'amount': 'Montant',
    'payment_date': 'Date de Paiement',
    'payment_method': 'Méthode de Paiement',
    'cash': 'Espèces',
    'bank_transfer': 'Virement Bancaire',
    'check': 'Chèque',
    'credit_card': 'Carte de Crédit',
    'online_payment': 'Paiement en Ligne',
    'reference_number': 'Numéro de Référence',
    'notes': 'Notes',
    'cancel': 'Annuler',

    'owner_information': 'Informations sur le Propriétaire',
    'name': 'Nom',
    'phone': 'Téléphone',
    'owner_lives_property': 'Le propriétaire vit sur la propriété',
    'select_apartments': 'Sélectionner des Appartements',
    'available_apartments': 'appartements disponibles',
    'no_apartments_available': 'Aucun appartement disponible. Tous les appartements ont déjà des propriétaires.',
    'apartment_number': 'Appartement {{number}}',
    'floor': 'Étage',
    'size': 'Taille',
    'type': 'Type',
    'status': 'Statut',
    'cancel': 'Annuler',
    'saving': 'Enregistrement...',
    'update_owner': 'Mettre à Jour le Propriétaire',
    'create_owner': 'Créer un Propriétaire',
    'edit_property_owner': 'Modifier le Propriétaire Immobilier',
    'add_property_owner': 'Ajouter un Propriétaire Immobilier',

    'property_owners': 'Propriétaires',
    'add_owner': 'Ajouter un Propriétaire',
    'search_owners': 'Rechercher des propriétaires...',
    'filter': 'Filtrer',
    'list_view': 'Liste',
    'grid_view': 'Grille',
    'export': 'Exporter',
    'exporting': 'Exportation...',

    // Owner Contracts & Installments - NEW
    'owner_contracts': 'Contrats des Propriétaires',
    'contracts': 'Contrats',
    'add_contract': 'Ajouter un Contrat',
    'contract_details': 'Détails du Contrat',
    'installments': 'Versements',
    'installment_details': 'Détails du Versement',
    'pay_now': 'Payer Maintenant',
    'contract_type': 'Type de Contrat',
    'purchase_agreement': 'Contrat d\'Achat',
    'service_agreement': 'Contrat de Service',
    'next_installment': 'Prochain Versement',
    'outstanding_balance': 'Solde Impayé',
    'total_contract_value': 'Valeur Totale du Contrat',
    'installment_plan': 'Plan de Versement',
    'payment_successful': 'Paiement réussi ! Vos dossiers seront mis à jour sous peu.',
    'payment_canceled': 'Le paiement a été annulé.',
    'redirecting_to_payment': 'Redirection vers le paiement sécurisé...',
    'no_contracts_found': 'Aucun contrat trouvé.',
    'no_installments_found': 'Aucun versement trouvé.',

    'living_status': 'Statut de Résidence',
    'all': 'Tous',
    'living_on_property': 'Vivant sur la Propriété',
    'not_living_on_property': 'Ne Vivant Pas sur la Propriété',
    'country': 'Pays',
    'all_countries': 'Tous les Pays',
    'apartment_status': 'Statut de l\'Appartement',
    'all_statuses': 'Tous les Statuts',
    'with_vacant': 'Avec Appartements Vacants',
    'fully_occupied': 'Entièrement Occupé',
    'with_maintenance': 'Avec Maintenance',
    'min_apartments': 'Min. Appartements',
    'max_apartments': 'Max. Appartements',
    'min_occupancy_rate': 'Taux d\'Occupation Min. (%)',
    'clear_filters': 'Effacer les Filtres',
    'apply_filters': 'Appliquer les Filtres',
    'total_owners': 'Total des Propriétaires',
    'resident_owners': 'Propriétaires Résidents',
    'with_apartments': 'Avec Appartements',
    'without_apartments': 'Sans Appartements',
    'loading_owners': 'Chargement des propriétaires...',
    'error_loading_owners': 'Erreur lors du Chargement des Propriétaires',
    'try_again': 'Réessayer',
    'no_owners_found': 'Aucun Propriétaire Trouvé',
    'no_owners_message': 'Il n\'y a pas encore de propriétaires dans le système. Cliquez sur le bouton \'Ajouter un Propriétaire\' pour créer votre premier propriétaire.',
    'create_first_owner': 'Créer le Premier Propriétaire',
    'showing_filtered_results': 'Affichage de {showing} sur {total} propriétaires',
    'confirm_deletion': 'Confirmer la Suppression',
    'delete_owner_confirmation': 'Êtes-vous sûr de vouloir supprimer le propriétaire "{name}" ? Cette action est irréversible.',
    'cancel': 'Annuler',
    'delete': 'Supprimer',
    'deleting': 'Suppression...',

    'resident_owner': 'Propriétaire Résident',
    'apartments_count': 'Nombre d\'Appartements',
    'show_apartments': 'Afficher les Appartements',
    'hide_apartments': 'Masquer les Appartements',
    'size_unit_sqm': 'Taille de l\'unité (m²)',

    "loading": "Chargement...",
    "edit_property_owner": "Modifier le Propriétaire Immobilier",
    "add_property_owner": "Ajouter un Propriétaire Immobilier",
    "owner_information": "Informations sur le Propriétaire",
    "name": "Nom",
    "phone": "Téléphone",
    "owner_lives_on_property": "Le propriétaire vit sur la propriété",
    "select_apartments": "Sélectionner des Appartements ({{count}})",
    "available_apartments": "{{count}} appartements disponibles",
    "no_apartments_available": "Aucun appartement disponible. Tous les appartements ont déjà des propriétaires.",
    "floor": "Étage",
    "size": "Taille",
    "size_unit_sqm": "m²",
    "type": "Type",
    "status": "Statut",
    "cancel": "Annuler",
    "saving": "Enregistrement...",
    "update_owner": "Mettre à Jour le Propriétaire",
    "create_owner": "Créer un Propriétaire",
    "failed_to_load_data": "Échec du chargement des données",
    "failed_to_save_owner": "Échec de l'enregistrement du propriétaire",

    "activity_logs": "Journaux d'Activité",
    "tenant_activity_logs": "Journaux d'Activité Locataires",
    "payment_activity_logs": "Journaux d'Activité Paiements",
    "building_activity_logs": "Journaux d'Activité Bâtiments",
    "apartment_activity_logs": "Journaux d'Activité Appartements",
    "owner_activity_logs": "Journaux d'Activité Propriétaires",
    "user_activity_logs": "Journaux d'Activité Utilisateurs",
    "system_activity_logs": "Journaux d'Activité Système",
    "track_all_system_activities": "Suivez toutes les activités et modifications du système",
    "filter": "Filtrer",
    "export_to_excel": "Exporter vers Excel",
    "exporting": "Exportation...",
    "search_logs_placeholder": "Rechercher des journaux par nom, utilisateur ou détails...",
    "showing_entries": "Affichage de {{showing}} sur {{total}} entrées",
    "filter_logs": "Filtrer les Journaux",
    "action_type": "Type d'Action",
    "all_actions": "Toutes les Actions",
    "entity_type": "Type d'Entité",
    "all_entities": "Toutes les Entités",
    "entries_per_page": "Entrées Par Page",
    "start_date": "Date de Début",
    "end_date": "Date de Fin",
    "reset": "Réinitialiser",
    "apply_filter": "Appliquer le Filtre",
    "time": "Heure",
    "user": "Utilisateur",
    "action": "Action",
    "entity": "Entité",
    "details": "Détails",
    "view": "Voir",
    "system": "Système",
    "view_entity_details": "Voir les détails de {{type}}",
    "no_logs_matching_search": "Aucun journal d'activité ne correspond à vos critères de recherche",
    "no_logs_for_filters": "Aucun journal d'activité trouvé pour les filtres sélectionnés",
    "showing_range": "Affichage de {{start}} à {{end}} sur {{total}} entrées",
    "previous": "Précédent",
    "next": "Suivant",
    "failed_to_load_logs": "Échec du chargement des journaux d'activité",
    "failed_to_export_logs": "Échec de l'exportation des journaux vers Excel",

    "tenant": "Locataire",
    "payment": "Paiement",
    "building": "Bâtiment",
    "apartment": "Appartement",
    "owner": "Propriétaire",
    "user": "Utilisateur",
    "system": "Système",

    "created": "Créé",
    "updated": "Mis à jour",
    "deleted": "Supprimé",
    "viewed": "Consulté",
    "login": "Connexion",
    "logout": "Déconnexion",
    "payment_made": "Paiement Effectué",
    "payment_received": "Paiement Reçu",
    "status_changed": "Statut Modifié",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "maintenance_request": "Demande de Maintenance",
    "maintenance_completed": "Maintenance Terminée",

    "loading_payment_data": "Chargement des données de paiement...",
    "error_loading_payment": "Erreur lors du Chargement du Paiement",
    "payment_not_found": "Paiement non trouvé",
    "back_to_payments": "Retour aux Paiements",
    "confirm_deletion": "Confirmer la Suppression",
    "delete_payment_confirmation": "Êtes-vous sûr de vouloir supprimer ce paiement de {{amount}} ? Cette action est irréversible.",
    "cancel": "Annuler",
    "deleting": "Suppression...",
    "delete": "Supprimer",
    "print_receipt": "Imprimer le Reçu",
    "edit": "Modifier",
    "tenant": "Locataire",
    "unknown_tenant": "Locataire Inconnu",
    "apartment": "Appartement",
    "apt": "Appart",
    "none": "Aucun",
    "payment_period": "Période de Paiement",
    "payment_details": "Détails du Paiement",
    "tenant_information": "Informations du Locataire",
    "payment_information": "Informations du Paiement",
    "amount": "Montant",
    "payment_date": "Date de Paiement",
    "payment_type": "Type de Paiement",
    "created": "Créé",
    "last_updated": "Dernière Mise à Jour",
    "notes": "Notes",
    "view_tenant": "Voir le Locataire",
    "unknown_period": "Période inconnue",
    "to": "à",
    "invalid_period_data": "Données de période invalides",
    "unknown_type": "Type Inconnu",
    "unknown": "Inconnu",
    "failed_to_load_payment_data": "Échec du chargement des données de paiement",
    "failed_to_delete_payment": "Échec de la suppression du paiement",

    "rent": "Loyer",
    "service": "Frais de Service",
    "deposit": "Caution",
    "maintenance": "Maintenance",
    "other": "Autre",

    "generate": "Générer",
    "generated": "Généré",
    "generate_payment_for": "Générer un Paiement pour",
    "payment_amount": "Montant du Paiement",
    "enter_amount": "Entrer le montant",
    "mark_as_paid_immediately": "Marquer comme payé immédiatement",
    "notes": "Notes",
    "payment_notes": "Notes de paiement",
    "required_fields": "Champs requis",
    "cancel": "Annuler",
    "generate_payment": "Générer le Paiement",

    "loading": "Chargement...",
    "edit_payment": "Modifier le Paiement",
    "record_payment": "Enregistrer un Paiement",
    "payment_information": "Informations du Paiement",
    "tenant": "Locataire",
    "select_tenant": "Sélectionner un Locataire",
    "apt": "Appart",
    "no_apartment": "Pas d'Appartement",
    "amount": "Montant",
    "payment_date": "Date de Paiement",
    "payment_type": "Type de Paiement",
    "payment_period": "Période de Paiement",
    "period_start": "Début de la Période",
    "period_end": "Fin de la Période",
    "additional_information": "Informations Supplémentaires",
    "notes": "Notes",
    "notes_placeholder": "Toutes notes supplémentaires concernant ce paiement...",
    "cancel": "Annuler",
    "saving": "Enregistrement...",
    "update_payment": "Mettre à Jour le Paiement",
    "failed_to_load_tenants_format": "Échec du chargement des locataires : format de données inattendu",
    "failed_to_load_tenants": "Échec du chargement des locataires. Veuillez réessayer.",
    "failed_to_load_payment_data": "Échec du chargement des données de paiement",
    "failed_to_save_payment": "Échec de l'enregistrement du paiement",

    "rent": "Loyer",
    "service": "Frais de Service",
    "deposit": "Caution",
    "maintenance": "Maintenance",
    "other": "Autre",

    "payments": "Paiements",
    "refresh": "Actualiser",
    "refresh_payments": "Actualiser les paiements",
    "stats": "Stats",
    "toggle_statistics": "Basculer la vue des statistiques",
    "search_payments": "Rechercher des paiements...",
    "filter": "Filtrer",
    "record_payment": "Enregistrer un Paiement",
    "confirm_deletion": "Confirmer la Suppression",
    "confirm_delete_payment": "Êtes-vous sûr de vouloir supprimer le paiement de {amount} pour {tenantName} ? Cette action est irréversible.",
    "cancel": "Annuler",
    "deleting": "Suppression...",
    "delete": "Supprimer",
    "filter_payments": "Filtrer les Paiements",
    "reset_all": "Tout Réinitialiser",
    "payment_type": "Type de Paiement",
    "all_types": "Tous les Types",
    "payment_type_rent": "Loyer",
    "payment_type_service": "Service",
    "payment_type_deposit": "Caution",
    "payment_type_other": "Autre",

    "payment_type_commission": "Commission",
    "payment_type_security_deposit": "Dépôt de garantie",    "building": "Bâtiment",
    "all_buildings": "Tous les Bâtiments",
    "from_date": "Date de Début",
    "to_date": "Date de Fin",
    "total_payments": "Total des Paiements",
    "payment": "paiement",
    "payments": "paiements",
    "recorded": "enregistré(s)",
    "rent_payments": "Paiements de Loyer",
    "service_payments": "Paiements de Services",
    "payment_statistics": "Statistiques de Paiement",
    "payments_by_month": "Paiements par Mois",
    "payment_types_distribution": "Répartition des Types de Paiement",
    "recent_activity": "Activité Récente",
    "close_statistics": "Fermer les Statistiques",
    "loading_payments": "Chargement des paiements...",
    "this_may_take_moment": "Cela peut prendre un moment",
    "error_loading_payments": "Erreur lors du Chargement des Paiements",
    "try_again": "Réessayer",
    "no_payments_found": "Aucun Paiement Trouvé",
    "no_payments_match_filters": "Aucun paiement ne correspond à vos filtres actuels. Essayez d'ajuster vos critères de filtre pour voir plus de résultats.",
    "no_payments_in_system": "Il n'y a pas encore de paiements dans le système. Commencez par enregistrer votre premier paiement.",
    "reset_filters": "Réinitialiser les Filtres",
    "record_first_payment": "Enregistrer le Premier Paiement",
    "unknown_period": "Période inconnue",
    "to": "à",
    "invalid_period_data": "Données de période invalides",
    "unknown_type": "Type Inconnu",
    "apt": "Appart",
    "print_receipt": "Imprimer le reçu",
    "view_details": "Voir les détails",
    "edit_payment": "Modifier le paiement",
    "delete_payment": "Supprimer le paiement",
    "showing_payments": "Affichage des paiements {{start}}-{{end}} sur {{total}}",
    "showing_filtered_payments": "Affichage de {{filtered}} sur {{total}} paiements d'après votre recherche",
    "authentication_required": "Authentification requise",
    "failed_load_payments": "Échec du chargement des données de paiements",
    "auth_failed_login_again": "Échec de l'authentification. Veuillez vous reconnecter.",
    "access_denied_admin_required": "Accès refusé. Rôle d'administrateur requis.",
    "server_error_check_backend": "Erreur serveur. Veuillez vérifier si le backend est en cours d'exécution.",
    "cannot_connect_server": "Impossible de se connecter au serveur. Veuillez vérifier si le backend est en cours d'exécution.",
    "error_fetching_payments": "Erreur lors de la récupération des paiements",
    "error_deleting_payment": "Erreur lors de la suppression du paiement",
    "failed_delete_payment": "Échec de la suppression du paiement",

    "occupancy_report": "Rapport d'Occupation",
    "loading": "Chargement...",
    "refresh": "Actualiser",
    "back": "Retour",
    "error_fetching_occupancy": "Erreur lors de la récupération des données d'occupation",
    "failed_load_occupancy": "Échec du chargement des données d'occupation",
    "occupied": "Occupé",
    "vacant": "Vacant",
    "maintenance": "Maintenance",
    "apartments": "appartements",
    "occupancy_rate": "Taux d'Occupation",
    "of": "de",
    "vacant_apartments": "Appartements Vacants",
    "of_total": "du total",
    "maintenance_apartments": "En Maintenance",
    "potential_income": "Revenu Mensuel Potentiel",
    "buildings": "bâtiments",
    "occupancy_distribution": "Répartition de l'Occupation",
    "occupancy_by_building": "Occupation par Bâtiment",
    "building": "Bâtiment",
    "total_apartments": "Total des Appartements",
    "print_report": "Imprimer le Rapport",
    "export_report": "Exporter le Rapport",

    "rent": "Loyer",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Assurance",
    "total": "Total",
    "occupied": "Occupé",
    "vacant": "Vacant",
    "maintenance": "Maintenance",
    "apartments": "appartements",
    "of": "de",
    "excellent": "Excellent",
    "good": "Bon",
    "needs_improvement": "Nécessite des Améliorations",
    "error_fetching_occupancy": "Erreur lors de la récupération des données d'occupation",
    "failed_load_occupancy": "Échec du chargement des données d'occupation",

    "overdue": "En Retard",
    "pending": "En Attente",
    "paid": "Payé",
    "no_overdue_payments": "Aucun paiement en retard trouvé",
    "apt": "Appart",
    "days_overdue": "jours de retard",
    "more_overdue_tenants": "plus de locataires en retard...",
    "error_fetching_tenant_status": "Erreur lors de la récupération du statut de paiement des locataires",
    "failed_load_tenant_status": "Échec du chargement du statut de paiement des locataires",

    "rent": "Loyer",
    "service": "Service",
    "deposit": "Caution",
    "no_recent_payments": "Aucun paiement récent trouvé",
    "error_fetching_payments": "Erreur lors de la récupération des paiements récents",
    "failed_load_payments": "Échec du chargement des paiements récents",

    "payment_logs": "Journaux de Paiement",
    "filter": "Filtrer",
    "back": "Retour",
    "search_payment_logs_placeholder": "Rechercher dans les journaux de paiement...",
    "showing_entries": "Affichage de {{showing}} sur {{total}} entrées",
    "filter_payments": "Filtrer les Paiements",
    "time_period": "Période",
    "start_date": "Date de Début",
    "end_date": "Date de Fin",
    "payment_type": "Type de Paiement",
    "all_types": "Tous les Types",
    "entries_per_page": "Entrées Par Page",
    "reset": "Réinitialiser",
    "apply_filter": "Appliquer le Filtre",
    "payment_id": "ID de Paiement",
    "date": "Date",
    "tenant": "Locataire",
    "building": "Bâtiment",
    "type": "Type",
    "amount": "Montant",
    "actions": "Actions",
    "print_receipt": "Imprimer le Reçu",
    "view_details": "Voir les Détails",
    "no_logs_matching_search": "Aucun journal de paiement ne correspond à vos critères de recherche",
    "no_logs_for_period": "Aucun journal de paiement disponible pour la période sélectionnée",
    "showing_range": "Affichage de {{start}} à {{end}} sur {{total}} entrées",
    "previous": "Précédent",
    "next": "Suivant",
    "print_report": "Imprimer le Rapport",
    "export_to_excel": "Exporter vers Excel",
    "failed_to_load_payment_logs": "Échec du chargement des journaux de paiement",

    "current_month": "Mois en Cours",
    "last_month": "Mois Dernier",
    "current_quarter": "Trimestre en Cours",
    "current_year": "Année en Cours",
    "custom": "Plage Personnalisée",

    "rent": "Loyer",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Assurance",
    "other": "Autre",

    "reports_dashboard": "Tableau de Bord des Rapports",
    "overview_of_financial_performance": "Aperçu des performances financières et statistiques immobilières",
    "view_all_reports": "Voir Tous les Rapports",
    "failed_to_load_report_data": "Échec du chargement des données du rapport",
    "total_revenue": "Revenu Total",
    "total_payments_count": "{{count}} paiements",
    "total_tenants": "Total des Locataires",
    "new_tenants_this_year": "{{count}} nouveaux cette année",
    "total_properties": "Total des Propriétés",
    "total_buildings_count": "{{count}} bâtiments",
    "total_owners": "Total des Propriétaires",
    "ended_contracts_count": "{{count}} contrats terminés",
    "monthly_revenue_year": "Revenu Mensuel - {{year}}",
    "view_details": "Voir les Détails",
    "occupancy_rate": "Taux d'Occupation",
    "recent_payments": "Paiements Récents",
    "view_all": "Voir Tout",
    "overdue_payments": "Paiements en Retard",
    "quick_reports": "Rapports Rapides",
    "annual_revenue": "Revenu Annuel",
    "yearly_breakdown": "Répartition annuelle de tous les revenus",
    "building_revenue": "Revenu du Bâtiment",
    "revenue_by_building": "Répartition des revenus par bâtiment",
    "owner_revenue": "Revenu du Propriétaire",
    "revenue_by_owner": "Répartition des revenus par propriétaire immobilier",
    "payment_logs": "Journaux de Paiement",
    "detailed_payment_history": "Historique détaillé des paiements et journaux",

    "revenue_report": "Rapport de Revenus",
    "filter": "Filtrer",
    "loading": "Chargement...",
    "refresh": "Actualiser",
    "back": "Retour",
    "filter_report": "Filtrer le Rapport",
    "time_period": "Période",
    "start_date": "Date de Début",
    "end_date": "Date de Fin",
    "cancel": "Annuler",
    "apply_filter": "Appliquer le Filtre",
    "failed_to_load_revenue_data": "Échec du chargement des données de revenus",
    "total_revenue": "Revenu Total",
    "total_payments_count": "{{count}} paiements",
    "rent_revenue": "Revenus de Loyer",
    "percent_of_total": "{{percent}}% du total",
    "service_revenue": "Revenus de Service",
    "unique_tenants": "Locataires Uniques",
    "avg_per_tenant": "Moyenne de {{amount}} par locataire",
    "revenue_by_building": "Revenus par Bâtiment",
    "view_details": "Voir les Détails",
    "building": "Bâtiment",
    "tenants": "Locataires",
    "no_building_revenue_data": "Aucune donnée de revenus par bâtiment disponible",
    "revenue_by_owner": "Revenus par Propriétaire",
    "owner": "Propriétaire",
    "apartments": "Appartements",
    "no_owner_revenue_data": "Aucune donnée de revenus par propriétaire disponible",
    "print_report": "Imprimer le Rapport",
    "export_report": "Exporter le Rapport",

    "current_month": "Mois en Cours",
    "last_month": "Mois Dernier",
    "current_quarter": "Trimestre en Cours",
    "current_year": "Année en Cours",
    "custom": "Plage Personnalisée",

    "service_payments_management": "Gestion des Paiements de Services",
    "refresh": "Actualiser",
    "back_to_dashboard": "Retour au Tableau de Bord",
    "building": "Bâtiment",
    "select_building": "Sélectionner un Bâtiment",
    "year": "Année",
    "search": "Rechercher",
    "search_apartments_tenants": "Rechercher des appartements, locataires...",
    "generate_payments": "Générer des Paiements",
    "view_statistics": "Voir les Statistiques",
    "filter_by_status": "Filtrer par statut",
    "all": "Tous",
    "paid": "Payé",
    "unpaid": "Non Payé",
    "clear_filters": "Effacer les Filtres",
    "loading_service_data": "Chargement des données de paiement de services...",
    "no_building_selected": "Aucun Bâtiment Sélectionné",
    "please_select_building": "Veuillez sélectionner un bâtiment pour voir les paiements de services.",
    "no_search_results": "Aucun Résultat de Recherche",
    "no_matching_apartments": "Aucun appartement ou locataire ne correspond à vos critères de recherche.",
    "service_payments_for_building_year": "Paiements de Services pour {{building}} - {{year}}",
    "floor_number": "Étage {{number}}",
    "apartments": "Appartements",
    "rate": "Taux",
    "tenant_owner": "Locataire/Propriétaire",
    "vacant": "Vacant",
    "mark_as_paid": "Marquer comme Payé",
    "mark_as_unpaid": "Marquer comme Non Payé",
    "view_details": "Voir les Détails",
    "summary": "Résumé",
    "floor_apartment_count": "{{floors}} étages, {{apartments}} appartements",
    "no_floors_available": "Aucun Étage Disponible",
    "no_floors_message": "Il n'y a pas d'étages avec des appartements dans ce bâtiment, ou aucun paiement de service n'a encore été généré.",
    "failed_to_load_buildings": "Échec du chargement des bâtiments. Veuillez réessayer.",
    "failed_to_load_floors": "Échec du chargement des étages",
    "failed_to_load_building_floors": "Échec du chargement des étages du bâtiment",
    "failed_to_load_floor_data": "Échec du chargement des données de l'étage",
    "data_refreshed_successfully": "Données actualisées avec succès.",
    "failed_to_refresh_data": "Échec de l'actualisation des données",
    "marked_as_paid_via_service_management": "Marqué comme payé via la gestion des services",
    "marked_as_unpaid_via_service_management": "Marqué comme non payé via la gestion des services",
    "payment_marked_as_paid": "Paiement marqué comme payé avec succès.",
    "payment_marked_as_unpaid": "Paiement marqué comme non payé avec succès.",
    "failed_to_update_payment": "Échec de la mise à jour du paiement",
    "payment_details": "Détails du Paiement",
    "payment_due": "Paiement Dû",
    "amount": "Montant",
    "status": "Statut",
    "paid_on": "Payé le",
    "no_apartments_on_floor": "Aucun appartement trouvé à cet étage.",

    "month_1": "Janvier",
    "month_2": "Février",
    "month_3": "Mars",
    "month_4": "Avril",
    "month_5": "Mai",
    "month_6": "Juin",
    "month_7": "Juillet",
    "month_8": "Août",
    "month_9": "Septembre",
    "month_10": "Octobre",
    "month_11": "Novembre",
    "month_12": "Décembre",

    "service_payment_details": "Détails du Paiement de Service",
    "print_receipt": "Imprimer le Reçu",
    "loading": "Chargement...",
    "failed_to_load_payment_details": "Échec du chargement des détails du paiement",
    "api_endpoint_missing_message": "Cette erreur indique un point de terminaison API manquant sur votre serveur backend. Pour résoudre ce problème, ajoutez une route pour GET /api/services/:id dans votre fichier serviceRoutes.js.",
    "payment_information": "Informations du Paiement",
    "apartment": "Appartement",
    "period": "Période",
    "amount": "Montant",
    "status": "Statut",
    "tenant": "Locataire",
    "owner": "Propriétaire",
    "payment_date": "Date de Paiement",
    "paid_by": "Payé Par",
    "notes": "Notes",
    "update_payment": "Mettre à Jour le Paiement",
    "mark_as_paid": "Marquer comme Payé",
    "currency": "Devise",
    "select_payer": "Sélectionner le Payeur",
    "management": "Gestion",
    "other": "Autre",
    "payment_notes_placeholder": "Entrez des notes supplémentaires concernant ce paiement...",
    "cancel": "Annuler",
    "saving": "Enregistrement...",
    "payment_history": "Historique des Paiements",
    "date": "Date",
    "action": "Action",
    "by": "Par",
    "paid": "Payé",
    "unpaid": "Non Payé",
    "payment_marked_as_paid": "Paiement marqué comme payé avec succès.",
    "payment_marked_as_unpaid": "Paiement marqué comme non payé avec succès.",
    "failed_to_update_payment": "Échec de la mise à jour du paiement",
    "service_payment_receipt": "Reçu de Paiement de Service",
    "property_management": "Gestion Immobilière",
    "receipt_generated": "Ce reçu a été généré le {{date}} à {{time}}",
    "automated_receipt_notice": "Ceci est un reçu généré automatiquement et ne nécessite pas de signature.",
    "us_dollar": "Dollar Américain",
    "iraqi_dinar": "Dinar Irakien",
    "euro": "Euro",

    "month_1": "Janvier",
    "month_2": "Février",
    "month_3": "Mars",
    "month_4": "Avril",
    "month_5": "Mai",
    "month_6": "Juin",
    "month_7": "Juillet",
    "month_8": "Août",
    "month_9": "Septembre",
    "month_10": "Octobre",
    "month_11": "Novembre",
    "month_12": "Décembre",

    "tenant": "locataire",
    "owner": "propriétaire",
    "management": "gestion",
    "other": "autre",

    "generate_service_payments": "Générer des Paiements de Services",
    "recipients": "Destinataires",
    "entire_building": "Bâtiment Entier",
    "generate_for_all_apartments": "Générer pour tous les appartements d'un bâtiment",
    "specific_tenants": "Locataires Spécifiques",
    "generate_for_selected_tenants": "Générer pour les locataires sélectionnés uniquement",
    "specific_owners": "Propriétaires Spécifiques",
    "generate_for_selected_owners": "Générer pour les propriétaires sélectionnés uniquement",
    "select_building": "Sélectionner un Bâtiment",
    "include_vacant_apartments": "Inclure les appartements vacants",
    "selected_tenants": "Locataires Sélectionnés",
    "selected_owners": "Propriétaires Sélectionnés",
    "select_tenants": "Sélectionner des Locataires",
    "select_owners": "Sélectionner des Propriétaires",
    "no_tenants_selected": "Aucun locataire sélectionné",
    "no_owners_selected": "Aucun propriétaire sélectionné",
    "payment_details": "Détails du Paiement",
    "amount": "Montant",
    "currency": "Devise",
    "us_dollar": "Dollar Américain",
    "iraqi_dinar": "Dinar Irakien",
    "euro": "Euro",
    "initial_status": "Statut Initial",
    "unpaid": "Non Payé",
    "paid": "Payé",
    "notes": "Notes",
    "payment_notes_placeholder": "Entrez des notes supplémentaires concernant ces paiements...",
    "time_period": "Période",
    "generation_type": "Type de Génération",
    "single_month": "Mois Unique",
    "multiple_months": "Mois Multiples",
    "month_range": "Plage de Mois",
    "year": "Année",
    "month": "Mois",
    "select_months": "Sélectionner les Mois",
    "from": "De",
    "to": "À",
    "selected_months": "Mois Sélectionnés",
    "payment_generation_summary": "Résumé de Génération des Paiements",
    "all_apartments_in": "Tous les appartements dans",
    "selected_building": "bâtiment sélectionné",
    "tenants": "locataires",
    "owners": "propriétaires",
    "cancel": "Annuler",
    "generating": "Génération...",
    "generate_payments": "Générer des Paiements",
    "search": "Rechercher",
    "search_by_tenant_name_or_phone": "Rechercher par nom de locataire, téléphone ou numéro d'appartement...",
    "search_by_owner_name_or_phone": "Rechercher par nom de propriétaire ou téléphone...",
    "no_results_found": "Aucun résultat trouvé",
    "selected": "sélectionné(s)",
    "done": "Terminé",
    "no_tenants_available": "Aucun locataire disponible. Veuillez d'abord ajouter des locataires.",
    "no_owners_available": "Aucun propriétaire disponible. Veuillez d'abord ajouter des propriétaires.",
    "apt": "Appart",
    "january": "Janvier",
    "february": "Février",
    "march": "Mars",
    "april": "Avril",
    "may": "Mai",
    "june": "Juin",
    "july": "Juillet",
    "august": "Août",
    "september": "Septembre",
    "october": "Octobre",
    "november": "Novembre",
    "december": "Décembre",
    "failed_to_load_buildings": "Échec du chargement des bâtiments. Veuillez réessayer.",
    "failed_to_load_tenants": "Échec du chargement des locataires. Veuillez réessayer.",
    "failed_to_load_owners": "Échec du chargement des propriétaires. Veuillez réessayer.",
    "please_select_building": "Veuillez sélectionner un bâtiment",
    "please_select_at_least_one_recipient": "Veuillez sélectionner au moins un {{recipient}}",
    "please_enter_valid_amount": "Veuillez entrer un montant valide",
    "please_select_month": "Veuillez sélectionner un mois",
    "please_select_at_least_one_month": "Veuillez sélectionner au moins un mois",
    "end_month_must_be_after_start_month": "Le mois de fin doit être après le mois de début",
    "successfully_generated_payments": "Génération réussie de {{count}} paiements de services sur {{months}} mois. {{skipped}} paiements étaient déjà générés.",
    "failed_to_generate_service_payments": "Échec de la génération des paiements de services",
    "tenant": "locataire",
    "owner": "propriétaire",

    "service_payment_statistics": "Statistiques des Paiements de Services",
    "back_to_services": "Retour aux Services",
    "building": "Bâtiment",
    "year": "Année",
    "loading_statistics": "Chargement des statistiques...",
    "no_building_selected": "Aucun Bâtiment Sélectionné",
    "please_select_building_statistics": "Veuillez sélectionner un bâtiment pour voir les statistiques des paiements de services.",
    "overall_statistics": "Statistiques Globales",
    "total_collection": "Collecte Totale",
    "of": "sur",
    "payment_rate": "Taux de Paiement",
    "payments": "paiements",
    "outstanding_amount": "Montant Impayé",
    "unpaid_payments": "paiements non payés",
    "monthly_statistics": "Statistiques Mensuelles",
    "no_monthly_data": "Aucune donnée mensuelle disponible pour l'année sélectionnée.",
    "month": "Mois",
    "total_amount": "Montant Total",
    "collected": "Collecté",
    "outstanding": "Impayé",
    "progress": "Progression",
    "failed_to_load_service_statistics": "Échec du chargement des statistiques de services",

    "loading_tenant_data": "Chargement des données du locataire...",
    "error_loading_tenant": "Erreur lors du Chargement du Locataire",
    "tenant_not_found": "Locataire non trouvé",
    "back_to_tenants": "Retour aux Locataires",
    "record_payment": "Enregistrer un Paiement",
    "edit": "Modifier",
    "status_unknown": "Statut Inconnu",
    "apartment": "Appartement",
    "apt": "Appart",
    "none": "Aucun",
    "monthly_rent": "Loyer Mensuel",
    "payment_date": "Date de Paiement",
    "overview": "Aperçu",
    "leases": "Baux",
    "payments": "Paiements",
    "contact_information": "Informations de Contact",
    "lease_information": "Informations sur le Bail",
    "contract_period": "Période de Contrat",
    "rent": "Loyer",
    "discount": "Remise",
    "rent_after_discount": "Loyer Après Remise",
    "additional_fees": "Frais Supplémentaires",
    "service_fee": "Frais de Service",
    "office_commission": "Commission d'Agence",
    "insurance": "Assurance",
    "notes": "Notes",
    "no_leases": "Aucun Bail",
    "no_leases_message": "Ce locataire n'a pas encore d'appartement assigné.",
    "active_leases": "Baux Actifs",
    "inactive_leases": "Baux Inactifs",
    "active": "Actif",
    "ended": "Terminé",
    "expiring_soon": "Expire Bientôt",
    "end_lease": "Mettre Fin au Bail",
    "start_date": "Date de Début",
    "end_date": "Date de Fin",
    "duration": "Durée",
    "remaining": "Restant",
    "months": "mois",
    "security_deposit": "Dépôt de Garantie",
    "total_value": "Valeur Totale",
    "no_payments": "Aucun Paiement",
    "no_payments_message": "Ce locataire n'a pas encore de paiements enregistrés.",
    "record_first_payment": "Enregistrer le Premier Paiement",
    "payment_period": "Période de Paiement",
    "reference": "Référence",
    "payment_type": "Type de Paiement",
    "rent_payment": "Paiement du Loyer",
    "additional_fee": "Frais Supplémentaires",
    "utility_payment": "Paiement des Charges",
    "other_payment": "Autre Paiement",
    "start": "Début",
    "end": "Fin",
    "reference_number": "Numéro de Référence",
    "cancel": "Annuler",
    "unknown_period": "Période inconnue",
    "invalid_period_format": "Format de période invalide",
    "to": "à",
    "invalid_period_data": "Données de période invalides",
    "please_enter_valid_payment_amount": "Veuillez entrer un montant de paiement valide",
    "end_date_must_be_after_start_date": "La date de fin doit être après la date de début",
    "failed_to_add_payment": "Échec de l'ajout du paiement",
    "maintenance_requests_not_supported": "Les demandes de maintenance ne sont pas prises en charge dans la structure actuelle de la base de données",
    "failed_to_create_maintenance_request": "Échec de la création de la demande de maintenance",
    "confirm_end_lease": "Êtes-vous sûr de vouloir mettre fin à ce bail ? Cette action est irréversible.",
    "lease_ended_by_administrator": "Bail résilié par l'administrateur",
    "failed_to_end_lease": "Échec de la résiliation du bail",
    "failed_to_load_tenant_data": "Échec du chargement des données du locataire",
    "actual_end_date": "Date de Fin Réelle",

    "edit_tenant": "Modifier le Locataire",
    "add_tenant": "Ajouter un Locataire",
    "basic_information": "Informations de Base",
    "first_name": "Prénom",
    "last_name": "Nom",
    "email": "E-mail",
    "phone": "Téléphone",
    "apartment": "Appartement",
    "select_apartment": "Sélectionner un Appartement",
    "floor": "Étage",
    "rent_amount": "Montant du Loyer",
    "discount": "Remise",
    "service_fee": "Frais de Service",
    "office_commission": "Commission d'Agence",
    "insurance": "Assurance",
    "contract_start_date": "Date de Début de Contrat",
    "contract_end_date": "Date de Fin de Contrat",
    "payment_date": "Date de Paiement",
    "payment_end_date": "Date de Fin de Paiement",
    "rent_status": "Statut du Loyer",
    "additional_information": "Informations Supplémentaires",
    "notes": "Notes",
    "tenant_notes_placeholder": "Toutes notes supplémentaires concernant ce locataire...",
    "cancel": "Annuler",
    "saving": "Enregistrement...",
    "update_tenant": "Mettre à Jour le Locataire",
    "create_tenant": "Créer un Locataire",
    "loading": "Chargement...",
    "failed_to_load_tenant_data": "Échec du chargement des données du locataire",
    "failed_to_save_tenant": "Échec de l'enregistrement du locataire",
    "pending": "En Attente",
    "paid": "Payé",
    "late": "En Retard",
    "overdue": "Échu",
    "unpaid": "Non Payé",

    "tenants": "Locataires",
    "refresh_tenants": "Actualiser les locataires",
    "selected": "sélectionné(s)",
    "delete_selected_tenants": "Supprimer les locataires sélectionnés",
    "search_tenants": "Rechercher des locataires...",
    "filter": "Filtrer",
    "switch_to_list_view": "Passer en Vue Liste",
    "switch_to_grid_view": "Passer en Vue Grille",
    "list_view": "Liste",
    "grid_view": "Grille",
    "hide_inactive_tenants": "Masquer les locataires inactifs",
    "show_inactive_tenants": "Afficher les locataires inactifs",
    "hide_inactive": "Masquer les Inactifs",
    "show_inactive": "Afficher les Inactifs",
    "add_tenant": "Ajouter un Locataire",
    "rent_status": "Statut du Loyer",
    "all_statuses": "Tous les Statuts",
    "all_buildings": "Tous les Bâtiments",
    "all_apartments": "Tous les Appartements",
    "min_rent": "Loyer Min",
    "max_rent": "Loyer Max",
    "unlimited": "Illimité",
    "contracts_ending_before": "Contrats Se Terminant Avant",
    "clear_filters": "Effacer les Filtres",
    "apply_filters": "Appliquer les Filtres",
    "active_tenants": "Locataires Actifs",
    "inactive_tenants": "Locataires Inactifs",
    "with_apartments": "Avec Appartements",
    "without_apartments": "Sans Appartements",
    "loading_tenants": "Chargement des locataires...",
    "error_loading_tenants": "Erreur lors du Chargement des Locataires",
    "try_again": "Réessayer",
    "no_tenants_found": "Aucun Locataire Trouvé",
    "no_tenants_message": "Il n'y a pas encore de locataires dans le système. Cliquez sur le bouton 'Ajouter un Locataire' pour créer votre premier locataire.",
    "create_first_tenant": "Créer le Premier Locataire",
    "page": "page",
    "showing_items": "Affichage de {start}-{end} sur {total}",
    "first_page": "Première Page",
    "previous_page": "Page Précédente",
    "next_page": "Page Suivante",
    "last_page": "Dernière Page",
    "showing_filtered_results": "Affichage de {showing} sur {total} locataires",
    "confirm_deletion": "Confirmer la Suppression",
    "delete_tenant_confirmation": "Êtes-vous sûr de vouloir supprimer le locataire \"{name}\" ? Cette action est irréversible.",
    "cancel": "Annuler",
    "deleting": "Suppression...",
    "delete": "Supprimer",
    "tenant": "Locataire",
    "apartment": "Appartement",
    "rent": "Loyer",
    "contract": "Contrat",
    "status": "Statut",
    "actions": "Actions",
    "apt": "Appart",
    "unknown_building": "Bâtiment Inconnu",
    "no_apartment_assigned": "Aucun appartement assigné",
    "status_unknown": "Statut Inconnu",
    "monthly_rent": "Loyer Mensuel",
    "after_discount": "Après Remise",
    "payment_date": "Date de Paiement",
    "not_set": "Non défini",
    "contract_start": "Début de Contrat",
    "contract_end": "Fin de Contrat",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Assurance",
    "hide_owner_details": "Masquer les Détails du Propriétaire",
    "show_owner_details": "Afficher les Détails du Propriétaire",
    "apartment_owner": "Propriétaire de l'Appartement",
    "loading_owner_details": "Chargement des détails du propriétaire...",
    "no_owner_information": "Aucune information de propriétaire disponible",
    "lives_on_property": "Vit sur la Propriété",
    "yes": "Oui",
    "no": "Non",
    "total_apartments": "Total des Appartements",
    "apartment_details": "Détails de l'Appartement",
    "apartment_number": "N° Appartement",
    "unknown": "Inconnu",
    "floor": "Étage",
    "apartment_type": "Type d'Appartement",
    "standard": "Standard",
    "furnished": "Meublé",
    "view_owner_profile": "Voir le Profil du Propriétaire",
    "mark_as_inactive": "Marquer comme inactif",
    "mark_as_active": "Marquer comme actif",
    "record_payment": "Enregistrer un paiement",
    "view_details": "Voir les détails",
    "edit_tenant": "Modifier le locataire",
    "delete_tenant": "Supprimer le locataire",
    "to": "À",
    "payment": "Paiement",
    "apartment_financial_details": "Détails de l'Appartement & Financiers",
    "not_authenticated": "Non authentifié. Veuillez vous connecter.",
    "authentication_required": "Authentification requise",
    "authentication_failed": "Échec de l'authentification. Veuillez vous reconnecter.",
    "access_denied": "Accès refusé. Rôle d'administrateur requis.",
    "server_error": "Erreur serveur. Veuillez vérifier si le backend est en cours d'exécution.",
    "cannot_connect_to_server": "Impossible de se connecter au serveur. Veuillez vérifier si le backend s'exécute sur le port 3000.",
    "failed_to_load_tenants_data": "Échec du chargement des données des locataires",
    "unknown_error": "Erreur inconnue",
    "failed_to_delete_tenant": "Échec de la suppression du locataire",
    "confirm_bulk_delete": "Êtes-vous sûr de vouloir supprimer {count} locataires ? Cette action est irréversible.",
    "failed_to_delete_tenants": "Échec de la suppression des locataires",
    "failed_to_update_tenant_status": "Échec de la mise à jour du statut du locataire",
    "pending": "En Attente",
    "paid": "Payé",
    "late": "En Retard",
    "overdue": "Échu",

    'add_new_user': 'Ajouter un Nouvel Utilisateur',
    'search_users': 'Rechercher des Utilisateurs',
    'total_users': 'Total des Utilisateurs',
    'active_users': 'Utilisateurs Actifs',
    'inactive_users': 'Utilisateurs Inactifs',
    'financial_summary': 'Résumé Financier',
    'filters': 'Filtres',
    'search_tenants_by_name_phone_or_apartment': 'Rechercher un locataire par nom, téléphone ou appartement',
    'view_profile': 'Voir le Profil',

    // WhatsApp Settings
    'whatsapp_settings': 'Paramètres WhatsApp',
    'whatsapp_settings_description': 'Notifications WhatsApp automatisées pour locataires et propriétaires',
    'whatsapp_enable': 'Activer les Notifications WhatsApp',
    'whatsapp_enable_sub': 'Activer ou désactiver tous les messages WhatsApp automatisés',
    'general_settings': 'Paramètres Généraux',
    'default_country_code': 'Indicatif de Pays par Défaut',
    'tenant_rent_reminder': 'Rappel de Loyer pour Locataire',
    'tenant_rent_reminder_sub': 'Envoyer un rappel aux locataires avant ou après la date d\'échéance du paiement',
    'days_before_due': 'Jours Avant Échéance',
    'reminder_message_template': 'Modèle de Message de Rappel',
    'service_fee_reminder': 'Rappel de Frais de Service',
    'enable_service_fee_reminder': 'Activer le Rappel de Frais de Service',
    'service_fee_reminder_sub': 'Informer les locataires des prochains paiements de frais de service',
    'owner_reminder': 'Rappel pour Propriétaire',
    'enable_owner_reminders': 'Activer les Rappels pour Propriétaires',
    'owner_reminder_sub': 'Informer les propriétaires lorsque leurs locataires ont des paiements en retard',
    'owner_message_template': 'Modèle de Message pour Propriétaire',
    'payment_confirmation': 'Confirmation de Paiement',
    'send_on_payment': 'Envoyer une confirmation lorsqu\'un paiement est enregistré',
    'payment_confirmation_sub': 'Envoyé automatiquement au locataire lorsqu\'un paiement est enregistré',
    'payment_confirmation_template': 'Modèle de Message de Confirmation',
    'whatsapp_test_send': 'Envoyer un Message de Test',
    'test_message': 'Message',
    'send_test_message': 'Envoyer le Message de Test',
    'whatsapp_test_sent': 'Message de test envoyé !',
    'whatsapp_test_default_message': 'Message de test du système de gestion immobilière',
    'send_reminders_now': 'Envoyer les Rappels Maintenant',
    'send_reminders_now_description': 'Envoyer immédiatement des rappels à tous les locataires et propriétaires qui en ont besoin en ce moment.',
    'whatsapp_must_be_enabled': 'WhatsApp doit d\'abord être activé',
    'failed_to_load_settings': 'Échec du chargement des paramètres',
    'settings_saved': 'Paramètres enregistrés avec succès',
    'failed_to_save': 'Échec de l\'enregistrement',
    'failed_to_send': 'Échec de l\'envoi',
    'server_error': 'Erreur de connexion au serveur',
    'sent': 'Envoyé',
    'errors': 'Erreurs',
    'skipped': 'Ignoré',

    // Bookings
    'bookings': 'Réservations',
    'booking_management': 'Gestion des Réservations',
    'new_booking': 'Nouvelle Réservation',
    'create_booking': 'Créer une Réservation',
    'edit_booking': 'Modifier la Réservation',
    'booking_details': 'Détails de la Réservation',
    'prospect': 'Prospect',
    'prospect_name': 'Nom du Prospect',
    'prospect_phone': 'Numéro de Téléphone',
    'prospect_email': 'Adresse E-mail',
    'move_in_date': 'Date d\'Emménagement',
    'move_out_date': 'Date de Déménagement',
    'hold_duration': 'Durée de Retenue',
    'hold_hours': 'Heures de Retenue',
    'hold_expiration': 'Expiration de la Retenue',
    'internal_notes': 'Notes Internes',
    'check_availability': 'Vérifier la Disponibilité',
    'checking_availability': 'Vérification de la disponibilité...',
    'no_bookings_found': 'Aucune réservation trouvée',
    'calendar_view': 'Vue Calendrier',
    'waitlist': 'Liste d\'Attente',
    'new_booking_hold': 'Nouvelle Retenue de Réservation',
    'property_information': 'Informations sur la Propriété',
    'prospect_details': 'Détails du Prospect',
    'requested_dates': 'Dates Demandées',
    'conflict_detected': 'Conflit Détecté',
    'booking_timeline': 'Chronologie de Réservation',
    'monthly_view_holds': 'Vue mensuelle des retenues d\'appartements actives',
    'confirmed_hold': 'Retenue Confirmée',
    'pending_payment': 'Paiement en Attente',
    'move_in': 'Emménagement',
    'move_out': 'Déménagement',
    'convert_to_tenant': 'Convertir en Locataire',
    'confirm_booking': 'Confirmer la Réservation',
    'cancel_booking': 'Annuler la Réservation',
    'booking_confirmed': 'Réservation confirmée',
    'booking_cancelled': 'Réservation annulée',
    'booking_converted': 'Réservation convertie en locataire avec succès !',
    'process_to_booking': 'Procéder à la Réservation',
    'waitlist_management': 'Gestion de la Liste d\'Attente',
    'waitlist_empty': 'La liste d\'attente est vide',
    'search_waitlist': 'Rechercher dans la liste d\'attente...',
    'priority': 'Priorité',
    'desired_unit': 'Unité Souhaitée',
    'move_in_preference': 'Préférence d\'Emménagement',
    'added': 'Ajouté',
    'rank': 'Rang',
    'process_waitlist_success': 'Converti en réservation en attente avec succès !',
    'remove_from_waitlist': 'Êtes-vous sûr de vouloir supprimer cette entrée de la liste d\'attente ?',
    'entry_removed': 'Entrée supprimée',
    'hold_expires': 'La Retenue Expire',
    'hours': 'Heures',
    'optional': 'Optionnel',
    'apartment_element': 'Élément Appartement',
    'select_unit': 'Sélectionner l\'Unité',
    'error_loading_data': 'Erreur lors du chargement des données',
    'error_saving_booking': 'Erreur lors de l\'enregistrement de la réservation',
    'save_changes': 'Enregistrer les Modifications',
    'select_apartment_move_in_date_error': 'Veuillez sélectionner un appartement et une date d\'emménagement pour vérifier la disponibilité',
    'apartment_available': 'L\'appartement est disponible pour ces dates !',
    'error_checking_availability': 'Erreur lors de la vérification de la disponibilité',
    'confirm_conflict_booking': 'Il y a des conflits de dates. Êtes-vous sûr de vouloir continuer ?',
    'booking_updated': 'Réservation mise à jour avec succès',
    'booking_number': 'Réservation #{{id}}',
    'created_at': 'Créé le {{date}}',
    'created_by': 'par {{name}}',
    'system': 'Système',
    'confirm': 'Confirmer',
    'target_property': 'Propriété Cible',
    'furnished': 'Meublé',
    'unfurnished': 'Non Meublé',
    'booking_window': 'Fenêtre de Réservation',
    'indefinite': 'Indéfini',
    'created_source': 'Créé ({{source}})',
    'view_tenant_profile': 'Voir le Profil du Locataire',
    'convert_to_active_tenant': 'Convertir en Locataire Actif',
    'lease_details_move_in_instruction': 'Complétez les détails du bail suivants pour emménager {{name}} dans l\'Unité {{unit}}.',
    'monthly_rent': 'Loyer Mensuel',
    'first_payment_date': 'Date du Premier Paiement',
    'contract_start': 'Début du Contrat',
    'contract_end': 'Fin du Contrat',
    'confirm_convert': 'Confirmer & Convertir',
    'confirm_booking_question': 'Finaliser la Réservation : Êtes-vous sûr de vouloir confirmer cette réservation et bloquer l\'unité pour ce prospect ?',
    'confirm_booking_question_ar': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'confirm_booking_question_ku': 'پشتڕاستکردنەوەی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'reason_optional': 'Veuillez fournir une raison (optionnel) :',
    'amount': 'Montant',
    'today': 'Aujourd\'hui',
    'sun': 'Dim',
    'mon': 'Lun',
    'tue': 'Mar',
    'wed': 'Mer',
    'thu': 'Jeu',
    'fri': 'Ven',
    'sat': 'Sam',
    'more': 'Plus',
    'close': 'Fermer',
    'hold_expiration': 'Expiration de la Retenue',
    'view_details': 'Voir les Détails',
    'waitlist_management': 'Gestion de la Liste d\'Attente',
    'search_waitlist': 'Rechercher dans la liste d\'attente...',
    'waitlist_empty': 'La liste d\'attente est vide',
    'no_prospective_tenants_waiting': 'Aucun prospect n\'attend actuellement la disponibilité d\'un appartement.',
    'priority': 'Priorité',
    'rank': 'Rang : {{priority}}',
    'desired_unit': 'Unité Souhaitée',
    'move_in_preference': 'Préférence d\'Emménagement',
    'process_to_booking': 'Procéder à la Réservation',
    'remove': 'Supprimer',
    'remove_waitlist_confirm': 'Êtes-vous sûr de vouloir supprimer cette entrée de la liste d\'attente ?',
    'waitlist_processed': 'Converti en réservation en attente avec succès !',
    'entry_removed': 'Entrée supprimée',
    'failed_process_waitlist': 'Échec du traitement de l\'entrée de la liste d\'attente',
    'failed_remove_entry': 'Échec de la suppression de l\'entrée',
    'booking_analytics': 'Analyses des Réservations',
    'track_conversion_and_holds': 'Suivez les taux de conversion et les durées de retenue',
    'last_7_days': 'Les 7 Derniers Jours',
    'last_30_days': 'Les 30 Derniers Jours',
    'last_90_days': 'Les 90 Derniers Jours',
    'last_year': 'L\'Année Dernière',
    'total_bookings': 'Total des Réservations',
    'in_selected_period': 'Pendant la période sélectionnée',
    'conversion_rate': 'Taux de Conversion',
    'converted_to_tenants': '{{count}} convertis en locataires',
    'cancellation_rate': 'Taux d\'Annulation',
    'cancelled_holds': '{{count}} retenues annulées',
    'avg_hold_time': 'Temps de Retenue Moyen',
    'before_conversion_cancel': 'Avant conversion/annulation',
    'volume_trends': 'Tendances de Volume',
    'no_trend_data': 'Aucune donnée de tendance disponible',
    'total_holds': 'Total des Retenues',
    'status_breakdown': 'Répartition par Statut',
    'no_status_data': 'Aucune donnée de statut disponible',
    'active_holds': 'Retenues Actives',
    'overdue_rent': 'Loyer en Retard',
    'subscription': 'Abonnement',
    'whatsapp': 'WhatsApp',
    'apartment_unit_display': 'Appartement {{number}} - Étage {{floor}}',
    'building_view': 'Vue du Bâtiment',
    'showing_all_apartments': 'Affichage de tous les appartements',
    'expand_all_floors': 'Développer tous les étages',
    'collapse_all_floors': 'Réduire tous les étages',
    'pending_move_in': 'Emménagement en Attente',
    'tenant_name': 'Nom',
    'tenant_phone': 'Téléphone',
    'tenant_email': 'E-mail',
    'lease_details': 'Détails du Bail',
    'start_date': 'Date de Début',
    'end_date': 'Date de Fin',
    'monthly_pay_date': 'Date de Paiement Mensuel',
    'day_number': 'Jour {{number}}',
    'duration': 'Durée',
    'months': 'Mois',
    'remaining_time': 'Temps Restant',
    'financial_summary': 'Résumé Financier',
    'monthly_rent': 'Loyer Mensuel',
    'effective_rent': 'Loyer Effectif',
    'rent_status': 'Statut du Loyer',
    'future_tenant_upcoming_move_in': 'Futur Locataire (Emménagement Prévu)',
    'move_in_date': 'Date d\'Emménagement',
    'contract_end': 'Fin de Contrat',
    'recent_bookings': 'Réservations et Retenues Récentes',
    'new_hold': 'Nouvelle Retenue',
    'available_now': 'Disponible Maintenant',
    'lease_ending_soon': 'Bail se Terminant Bientôt',
    'no_apartments_found': 'Aucun appartement approprié trouvé',
    'ready': 'Prêt',
    'ends_in_days': 'Se termine dans {{count}}j',
    'search_unit': 'Rechercher un appartement...',
    'currently_occupied': 'Actuellement Occupé',
    'occupied': 'Occupé',
    'all_service_payments': 'Tous les Paiements de Services',
    'manage_all_service_payments_across_buildings': 'Gérez tous les paiements de services à travers les bâtiments',
    'tenants_management': 'Gestion des Locataires',
    'manage_tenants_and_leases': 'Gérez les locataires et les baux',
    'past_tenants': 'Anciens Locataires',
    'lease_ended': 'Bail Terminé',
    'end_lease_confirm_title': 'Confirmer la Fin du Bail',
    'end_lease_confirm_body': 'Êtes-vous sûr de vouloir mettre fin à ce bail ?',
    'no_past_tenants': 'Aucun ancien locataire',
    'sign_up_to_get_started': 'Inscrivez-vous pour commencer',
    'company_name': 'Nom de l\'Entreprise',
    'already_have_account': 'Vous avez déjà un compte ?',
    'status_expired_description': 'Ce bail a expiré. Aucun autre paiement ne peut être appliqué.',
    'lease_expired_warning': 'Ce bail a expiré.',
    'tenant_lease_expired_message': 'Aucun autre paiement ne peut être appliqué.',
    'expired_on': 'Expiré le',
    'manage_tenant': 'Gérer le Locataire',
    'move_in_pending': 'Emménagement en Attente',
    'lease_expired': 'Bail Expiré',
    'create_hold': 'Créer une Retenue',
    'billing_subscription': 'Facturation et Abonnement',
    'current_plan': 'Forfait Actuel',
    'subscribe_now': 'S\'abonner Maintenant',
    'manage_your_subscription_and_billing': 'Gérez votre abonnement et votre facturation',
    'view_payment_logs': 'Voir les Journaux de Paiement',
    'view_activity_logs': 'Voir les Journaux d\'Activité',
    'view_revenue_report': 'Voir le Rapport de Revenus',
    'view_occupancy_report': 'Voir le Rapport d\'Occupation',
    'view_tenant_logs': 'Voir les Journaux Locataires',
    'login_success': 'Connexion Réussie',
    'logout_success': 'Déconnexion Réussie',
    'record_payment': 'Enregistrer un Paiement',
    'occupied_status': 'Occupé',
    'financial_status': 'Statut Financier',
    'occupancy_physical': 'Occupation Physique',
    'unit_indicators': 'Indicateurs d\'Unité',
    'furnished_unit': 'Unité Meublée',
    'lease_expired_short': 'Bail Expiré',
    'lease_ended_short': 'Bail Terminé',
    'expired_label': 'Expiré',
    'scheduled_tenants': 'Locataires Programmés',
    'multiple_leases': 'Baux Multiples',

    // Portal Common
    'owner_portal': 'Portail Propriétaire',
    'tenant_portal': 'Portail Locataire',
    'sign_out': 'Déconnexion',
    'indefinite': 'Indéfini',
    'total_value': 'Valeur Totale',
    'remaining_balance': 'Solde Restant',

    // Portal Navigation
    'lease_details': 'Détails du Bail',
    'installments': 'Versements',
    'documents': 'Documents',
    'announcements': 'Annonces',

    // Owner Portal / Admin
    'management_fees': 'Frais de Gestion',
    'management_fees_subtitle': 'Aperçu de tous les revenus et calendriers de gestion des propriétaires.',
    'ledger_subtitle': 'Répartition détaillée de vos versements de frais de gestion et soldes en attente.',
    'agreements_subtitle': 'Voir tous vos contrats de gestion et dossiers de propriété.',

    // Tenant Portal
    'welcome_back_user': 'Bon retour, {{name}} !',
    'tenancy_overview': "Voici ce qui se passe avec votre location aujourd'hui.",
    'current_balance': 'Solde Actuel',
    'action_required': 'Action requise',
    'account_good_standing': 'Compte en règle',
    'view_lease_short': 'Voir les détails du bail',
    'need_repairs': 'Besoin de Réparations ?',
    'repairs_subtitle': 'Soumettez rapidement un ticket de maintenance en ligne.',
    'create_request': 'Créer une Demande',
    'building_news': 'Actualités & Avis du Bâtiment',
    'payments_billing': 'Paiements & Facturation',
    'payments_subtitle': 'Gérez vos paiements de loyer et consultez l\'historique de vos transactions.',
    'download_statement': 'Télécharger le Relevé PDF',
    'amount_due': 'Montant Actuel Dû',
    'due_on': 'Échéance le {{date}}',
    'pay_now': 'Payer Maintenant',
    'transaction_history': 'Historique des Transactions',
    'no_transactions': 'Aucune transaction pour le moment',
    'first_payment_message': 'Votre historique de paiement apparaîtra ici une fois que vous aurez effectué votre premier paiement.',
    'unit_display': 'Unité {{number}}',

    // Tenant Lease
    'lease_details_subtitle': 'Passez en revue votre contrat de location actif et les informations sur la propriété.',
    'lease_signed': 'Bail Signé',
    'sign_lease_now': 'Signer le Bail Maintenant',
    'contract_term': 'Durée du Contrat',
    'property_info': 'Informations sur la Propriété',
    'landlord_owner': 'Propriétaire / Bailleur',
    'electronic_signature_recorded': 'Signature Électronique Enregistrée',
    'signed_on': 'Signé le : {{date}}',
    'digital_trace': 'Trace Numérique',
    'legal_disclosure': 'Divulgation Légale',
    'legal_disclosure_text': 'En signant ce document électroniquement, vous acceptez que votre signature électronique a la même valeur légale que votre signature manuscrite sur cet Accord.',
    'electronic_lease_signing': 'Signature Électronique du Bail',
    'confirmation_statement': '"Je, {{name}}, confirme par la présente avoir lu et accepter toutes les conditions du contrat de location pour {{building}}, Unité {{unit}}."',
    'type_full_name': 'Tapez le Nom Complet pour Signer',
    'digital_verification_required': 'Vérification de la Signature Numérique Requise',
    'complete_signing': 'Terminer la Signature',
    'lease_not_found': 'Bail Non Trouvé',
    'lease_not_found_subtitle': 'Contactez la direction si vous pensez qu\'il s\'agit d\'une erreur.',

    // Lease Management
    'renew_lease': 'Renouveler le Bail',
    'extend_lease': 'Prolonger le Bail',
    'current_end_date': 'Date de Fin Actuelle',
    'new_end_date': 'Nouvelle Date de Fin',
    'extend': 'Prolonger',
    'transfer': 'Transférer',
    'transfer_apartment': 'Transférer l\'Appartement',
    'current_apartment': 'Appartement Actuel',
    'select_new_apartment': 'Sélectionner un Nouvel Appartement',
    'new_monthly_rent': 'Nouveau Loyer Mensuel',
    'transferring': 'Transfert en cours...',
    'failed_to_transfer_tenant': 'Échec du transfert du locataire',
    'tenant_transferred_success': 'Locataire transféré avec succès',
    'expired': 'Expiré',
    'select_option': 'Sélectionner une Option',
    'invite_portal': 'Inviter sur le Portail',
    'tenant_documents': 'Documents Locataire',
    'maintenance_requests': 'Demandes de Maintenance',
    'add_request': 'Ajouter une Demande',
    'reported_on': 'Signalé le',
    'send_portal_invitation': 'Envoyer l\'Invitation au Portail',
    'fully_signed': 'Entièrement Signé',
    'voided': 'Annulé',
    'upgrade_for_analytics': 'Pour les analyses',
    'upgrade_analytics_message': 'Pour les analyses',
    'view_plans': 'Voir les plans',
    'choose_a_plan': 'Choisissez un plan',
    'subscribe_with_stripe': 'Abonnez-vous avec Stripe',
    'manage_subscription': 'Gérer l\'abonnement',
    'subscribe_with_stripe': 'Abonnez-vous avec Stripe',
    'upgrade': 'Mettre à jour',
    'contact_sales': 'Contacter les ventes',
    'no_payment_history': 'Aucun historique de paiement',
    'no_subscription_history': 'Aucun historique d\'abonnement',

    // ID Documents (Tenant & Owner)
    'id_documents': 'Documents d\'identité',
    'id_document_front': 'Recto',
    'id_document_back': 'Verso',
    'id_document_type': 'Type de document',
    'id_document_number': 'Numéro de document',
    'id_document_uploaded_at': 'Téléchargé le',
    'select_document_type': 'Sélectionner le type de document',
    'national_id': 'Carte nationale d\'identité',
    'passport': 'Passeport',
    'driving_license': 'Permis de conduire',
    'residence_permit': 'Titre de séjour',
    'other_document': 'Autre',
    'document_number_placeholder': 'Entrez le numéro de document (facultatif)',
    'front_side': 'Recto',
    'back_side': 'Verso',
    'drag_drop_or_click': 'Glisser-déposer ou cliquer pour télécharger',
    'supported_formats': 'Pris en charge : JPG, PNG, WEBP (max 5 Mo)',
    'upload_id_documents': 'Télécharger les documents d\'identité',
    'uploading': 'Téléchargement...',
    'id_documents_uploaded': 'Documents d\'identité téléchargés avec succès',
    'id_documents_upload_failed': 'Échec du téléchargement des documents d\'identité',
    'delete_document_side': 'Supprimer le document {{side}}',
    'confirm_delete_document': 'Êtes-vous sûr de vouloir supprimer ce document ?',
    'document_deleted': 'Document supprimé avec succès',
    'document_delete_failed': 'Échec de la suppression du document',
    'no_id_documents': 'Aucun document d\'identité téléchargé pour le moment',
    'view_document': 'Voir le document',
    'close_preview': 'Fermer l\'aperçu',
    'save_changes': 'Enregistrer les modifications',
    'pending_upload': 'Téléchargement en attente',
    'id_documents_tab': 'Documents d\'identité',
    'tenant_id_documents': 'Documents d\'identité du locataire',
    'owner_id_documents': 'Documents d\'identité du propriétaire',
    'id_documents_description': 'Télécharger et gérer les images des documents d\'identité',

    'waitlist': 'Liste d\'attente',
    'waitlist_management': 'Gestion de la liste d\'attente',
    'search_waitlist': 'Rechercher par nom, téléphone ou unité...',
    'waitlist_empty': 'La liste d\'attente est vide',
    'no_prospective_tenants_waiting': 'Aucun futur locataire n\'attend actuellement d\'unité.',

    // Waitlist table columns
    'priority': 'Priorité',
    'prospect': 'Prospect',
    'desired_unit': 'Unité souhaitée',
    'move_in_preference': 'Date d\'emménagement préférée',
    'added': 'Ajouté',
    'rank': '#{{priority}}',
    'process_to_booking': 'Convertir en réservation',
    'remove': 'Supprimer',
    'remove_from_waitlist': 'Supprimer de la liste d\'attente',
    'remove_waitlist_confirm': 'Êtes-vous sûr de vouloir supprimer ce prospect de la liste d\'attente ? Cette action ne peut pas être annulée.',

    // Waitlist status messages
    'waitlist_processed': 'Prospect converti avec succès en réservation en attente',
    'failed_process_waitlist': 'Échec de la conversion de cette entrée de liste d\'attente en réservation',
    'entry_removed': 'Entrée supprimée de la liste d\'attente',
    'failed_remove_entry': 'Échec de la suppression de l\'entrée de la liste d\'attente',

    // Add to Waitlist Modal
    'add_to_waitlist': 'Ajouter à la liste d\'attente',
    'waitlist_form_subtitle': 'Le prospect sera automatiquement promu lorsque l\'unité deviendra disponible',
    'desired_unit': 'Unité souhaitée',
    'prospect_details': 'Détails du prospect',
    'prospect_name': 'Nom du prospect',
    'prospect_phone': 'Téléphone du prospect',
    'prospect_email': 'E-mail du prospect',
    'scheduling_priority': 'Planification et priorité',
    'preferred_move_in_date': 'Date d\'emménagement préférée',
    'higher_is_first': 'Plus élevé = premier dans la file',
    'priority_hint': 'Les prospects ayant une priorité plus élevée avancent dans la file. La valeur par défaut est 0 (FIFO).',
    'priority_range_error': 'La priorité doit être comprise entre 0 et 10',
    'loading_apartments': 'Chargement des appartements...',
    'field_required': 'Ce champ est requis',
    'adding': 'Ajout...',
    'added_to_waitlist': 'Prospect ajouté avec succès à la liste d\'attente',
    'failed_add_waitlist': 'Échec de l\'ajout du prospect à la liste d\'attente',
    'waitlist_auto_promote_info': 'Lorsque l\'unité sélectionnée devient disponible, ce prospect sera automatiquement converti en réservation en attente en fonction de sa priorité et de sa position dans la file.',
    'waitlist_notes_placeholder': 'Exigences spéciales, source du prospect, notes de l\'agent...',

    // ── Maintenance Hub ───────────────────────────────────────────
    'maintenance_hub': 'Centre de Maintenance',
    'track_and_assign_maintenance': 'Suivre les demandes des locataires et assigner des ordres de travail aux prestataires',
    'search_requests': 'Rechercher par problème, locataire ou appartement...',
    'loading_requests': 'Chargement des demandes...',
    'no_maintenance_found': 'Aucune demande de maintenance trouvée',
    'issue': 'Problème',
    'location': 'Emplacement',
    'tenant': 'Locataire',
    'assign_vendor': 'Assigner un prestataire',
    'update_status': 'Mettre à jour le statut',
    'status_updated': 'Statut mis à jour avec succès',
    'error_updating_status': 'Erreur lors de la mise à jour du statut',
    'error_fetching_data': 'Erreur lors de la récupération des données',

    // Work Orders
    'create_work_order': 'Créer un ordre de travail',
    'work_order_created': 'Ordre de travail créé et assigné',
    'error_creating_work_order': 'Erreur lors de la création de l\'ordre de travail',
    'select_vendor': 'Sélectionner un prestataire',
    'select_a_vendor': 'Sélectionner un prestataire',
    'estimated_cost': 'Coût estimé',
    'scheduled_date': 'Date prévue',
    'work_description': 'Description du travail',

    // Maintenance statuses
    'open': 'Ouvert',
    'in_progress': 'En cours',
    'completed': 'Terminé',
    'cancelled': 'Annulé',

    // ── Vendor Management ─────────────────────────────────────────
    'vendor_management': 'Gestion des Prestataires',
    'manage_maintenance_vendors': 'Gérer les prestataires de maintenance externes et les fournisseurs de services',
    'add_vendor': 'Ajouter un prestataire',
    'add_new_vendor': 'Ajouter un nouveau prestataire',
    'edit_vendor': 'Modifier le prestataire',
    'search_vendors': 'Rechercher par nom ou catégorie...',
    'no_vendors_found': 'Aucun prestataire trouvé',
    'vendor_name': 'Nom du prestataire',
    'category': 'Catégorie',
    'contact_person': 'Personne de contact',
    'vendor_created': 'Prestataire créé avec succès',
    'vendor_updated': 'Prestataire mis à jour avec succès',
    'vendor_deleted': 'Prestataire supprimé avec succès',
    'update_vendor': 'Mettre à jour le prestataire',
    'save_vendor': 'Enregistrer le prestataire',
    'confirm_delete_vendor': 'Êtes-vous sûr de vouloir supprimer ce prestataire ? Cette action ne peut pas être annulée.',
    'error_fetching_vendors': 'Erreur lors de la récupération des prestataires',
    'error_saving_vendor': 'Erreur lors de l\'enregistrement du prestataire',
    'error_deleting_vendor': 'Erreur lors de la suppression du prestataire',
    'confirm_delete_vendor_title': 'Supprimer le prestataire',
    'vendor_no_email': "Le prestataire n'a pas d'adresse e-mail",
    'vendor_invite_saved': 'Invitation enregistrée !',
    'vendor_invite_link_copied': 'Lien de configuration copié dans le presse-papiers',
    'vendor_invite_failed': "Impossible d'envoyer l'invitation",
    'vendor_invite_portal': 'Inviter au portail prestataire',
    'vendor_category_placeholder': 'ex. Plomberie, IT, Électricité',
    'vendor_1099_nec': 'Prestataire 1099-NEC',
    'vendor_1099_desc': 'Rapport annuel IRS — prestataires payés ≥ 600 $ en compensation non salariale',
    'vendor_1099_disclaimer': "Les formulaires 1099-NEC sont requis pour tout prestataire (non-salarié) ayant reçu ≥ 600 $ au cours d'une année civile. La date limite de dépôt IRS est généralement le 31 janvier. Vérifiez toujours avec un professionnel fiscal avant de déposer.",
    '1099_required': '1099 Requis',
    'no_vendor_payments_recorded': 'Aucun paiement prestataire enregistré pour',

    // ── Contract Templates ────────────────────────────────────────
    'contract_templates': 'Modèles de Contrats',
    'manage_legal_templates_desc': 'Gérer les cadres juridiques et les règles automatisées pour les contrats.',
    'create_template': 'Créer un modèle',
    'search_templates': 'Rechercher dans les modèles...',
    'no_templates_found': 'Aucun modèle trouvé',
    'create_first_template_desc': 'Commencez par créer votre premier modèle juridique de contrat.',
    'no_description_provided': 'Aucune description fournie.',
    'default_rules': 'Règles par défaut',
    'failed_to_load_templates': 'Échec du chargement des modèles',
    'template_deleted_successfully': 'Modèle supprimé avec succès',
    'failed_to_delete_template': 'Échec de la suppression du modèle',
    'confirm_delete_template': 'Êtes-vous sûr de vouloir supprimer ce modèle ? Cette action ne peut pas être annulée.',

    // Contract Template Form
    'edit_template': 'Modifier le modèle',
    'create_new_template': 'Créer un nouveau modèle',
    'template_details': 'Détails du modèle',
    'template_name': 'Nom du modèle',
    'is_active': 'Modèle actif',
    'legal_text': 'Contenu du texte juridique',
    'default_variable_rules': 'Règles de variables par défaut',
    'default_rules_desc': 'Définissez les variables par défaut (comme commission_rate) que le créateur utilisera.',
    'add_rule': 'Ajouter une règle',
    'no_default_rules': 'Aucune règle par défaut définie.',
    'variable_name_placeholder': 'Nom de la variable (ex: commission_rate)',
    'default_value_placeholder': 'Valeur par défaut (ex: 8)',
    'archive_template': 'Archiver le modèle',
    'archive_template_confirm': 'Êtes-vous sûr de vouloir archiver ce modèle ? Il ne sera plus disponible pour les nouveaux contrats.',
    'archive': 'Archiver',
    'template_archived_successfully': 'Modèle archivé avec succès',
    'failed_to_archive_template': 'Échec de l\'archivage du modèle',
    'template_updated_successfully': 'Modèle mis à jour avec succès',
    'template_created_successfully': 'Modèle créé avec succès',
    'failed_to_save_template': 'Échec de l\'enregistrement du modèle',
    'failed_to_load_template': 'Échec du chargement du modèle',

    // Contract types
    'management': 'Gestion',
    'lease': 'Bail',
    'sale': 'Vente',
    'lease_progress': 'Avancement du bail',
    'status_open': 'Ouvert',
    'status_in_progress': 'En cours',
    'status_completed': 'Terminé',
    'status_cancelled': 'Annulé',
    'priority_low': 'Faible',
    'priority_medium': 'Moyen',
    'priority_high': 'Élevé',
    'priority_urgent': 'Urgent',
    'priority_emergency': 'Urgence',
    'estimated_cost': 'Coût est.',
    'tenant_portal_submissions': 'Soumissions du portail locataire',
    'portal_submission_note': 'Fichiers soumis par le locataire via son portail en libre-service',
    'tenant_proof_document': 'Pièce d\'identité / Justificatif',
    'tenant_insurance_document': 'Assurance / Certificat',
    'not_submitted': 'Non soumis',
    'saved': 'Enregistré',
    'payment_method': 'Méthode',
    'tenant_ledger': 'Grand livre locataire',
    'ledger_description': 'Registre immuable de tous les frais et paiements. Ajoutez des crédits pour corriger les erreurs.',
    'ledger_generate_monthly': 'Générer mensuel',
    'ledger_add_charge': 'Ajouter un débit',
    'ledger_add_credit': 'Ajouter un crédit',
    'ledger_apply_late_fee': 'Appliquer pénalité de retard',
    'ledger_late_fee': 'Pénalité de retard',
    'ledger_charge': 'Débit',
    'ledger_deposit': 'Dépôt',
    'ledger_payment': 'Paiement',
    'ledger_credit': 'Crédit',
    'ledger_charge_rent_fee': 'Débit (Loyer / Frais)',
    'ledger_description_placeholder': 'ex. Frais de maintenance',
    'outstanding_balance': 'Solde dû',
    'ledger_balance_note': 'Calculé à partir des écritures du grand livre',
    'ledger_total_entries': 'Total écritures',
    'ledger_no_entries': 'Aucune écriture pour le moment',
    'ledger_no_entries_hint': 'Générez le premier débit mensuel ou enregistrez un débit manuel ci-dessus.',
    'ledger_balance_after': 'Solde après',
    'ledger_charge_added': 'Débit enregistré dans le grand livre',
    'ledger_charge_failed': 'Impossible d\'ajouter le débit',
    'ledger_credit_added': 'Crédit enregistré dans le grand livre',
    'ledger_credit_failed': 'Impossible d\'ajouter le crédit',
    'ledger_late_fee_applied': 'Pénalité de retard enregistrée',
    'ledger_late_fee_failed': 'Impossible d\'appliquer la pénalité',
    'ledger_monthly_generated': 'Débit mensuel généré',
    'ledger_monthly_failed': 'Impossible de générer le débit',
    'ledger_load_failed': 'Impossible de charger le grand livre',
    'created_by': 'Créé par',
    'expired': 'Expiré',
    'expiring_soon': 'Expire bientôt',
    'email': 'E-mail',

    // ── Portail Locataire ──────────────────────────────────────────────────────

    // Tableau de bord
    'failed_to_load_dashboard_data': 'Échec du chargement des données du tableau de bord',
    'welcome_back_user': 'Bon retour, {{name}}',
    'tenancy_overview': 'Aperçu de votre location',
    'unit_display': 'Unité {{number}}',
    'current_balance': 'Solde actuel',
    'action_required': 'Action requise',
    'account_good_standing': 'Compte en règle',
    'lease_ends': 'Fin du bail',
    'view_lease_short': 'Voir le bail',
    'need_repairs': 'Besoin de réparations ?',
    'repairs_subtitle': 'Soumettre une demande de maintenance',
    'create_request': 'Créer une demande',
    'quick_actions': 'Actions rapides',
    'pay_now': 'Payer maintenant',
    'recent_account_activity': 'Activité récente du compte',
    'view_ledger': 'Voir le grand livre',
    'no_ledger_entries_yet': 'Aucune entrée pour l\'instant',
    'active_maintenance': 'Maintenance active',
    'view_all': 'Voir tout',
    'all_clear_maintenance': 'Aucune demande en cours',
    'maintenance_request_default': 'Demande de maintenance',
    'building_news': 'Actualités du bâtiment',
    'lease_progress': 'Avancement du bail',
    'days_left': '{{days}} jours restants',
    'expires_today': 'Expire aujourd\'hui !',
    'pct_elapsed': '{{pct}}% écoulé',
    'balance_after': 'solde :',

    // Paiements
    'failed_to_load_payment_data': 'Échec du chargement des données de paiement',
    'failed_to_initiate_payment': 'Échec de l\'initiation du paiement',
    'payments_billing': 'Paiements et facturation',
    'payments_billing_subtitle': 'Historique des loyers, charges de services et grand livre complet',
    'download_statement': 'Télécharger le relevé',
    'current_amount_due': 'Montant dû actuel',
    'due_on': 'Dû le',
    'view_ledger_hint': 'Vous souhaitez voir comment cela a été calculé ?',
    'view_your_ledger': 'Voir votre grand livre',
    'in_n_days': 'Dans {{count}} jour',
    'in_n_days_plural': 'Dans {{count}} jours',
    'due_today': '⚡ Dû aujourd\'hui',
    'all_paid_up': 'Tout est payé !',
    'tab_rent_payments': 'Paiements de loyer',
    'tab_service_charges': 'Charges de services',
    'tab_service_charges_due': 'Charges de services ({{count}} dues)',
    'tab_account_ledger': 'Grand livre',
    'transaction_history': 'Historique des transactions',
    'no_transactions': 'Aucune transaction encore',
    'no_transactions_subtitle': 'Votre historique de paiement apparaîtra ici une fois les paiements enregistrés.',
    'rejected': 'Rejeté',
    'outstanding_service_charges': 'Charges de services impayées',
    'paid_service_history': 'Historique des services payés',
    'service_charge_default': 'Charge de service',
    'pay': 'Payer',
    'paid_badge': 'Payé',
    'no_service_charges': 'Aucune charge de service',
    'no_service_charges_subtitle': 'Vous n\'avez aucune charge de service pour le moment.',
    'account_balance': 'Solde du compte',
    'ledger_calculated_from': 'Calculé à partir de {{count}} entrées',
    'full_account_statement': 'Relevé de compte complet',
    'full_account_statement_subtitle': 'Chaque débit et paiement de votre compte, avec solde courant.',
    'balance_after_col': 'Solde après',
    'no_ledger_entries': 'Aucune entrée de grand livre encore',
    'no_ledger_entries_subtitle': 'Votre historique financier apparaîtra ici une fois les charges enregistrées.',
    'ledger_type_charge': 'Débit',
    'ledger_type_late_fee': 'Pénalité de retard',
    'ledger_type_deposit': 'Caution',
    'ledger_type_payment': 'Paiement',
    'ledger_type_credit': 'Crédit',
    'payment_success_stripe': 'Paiement réussi ! Votre compte sera mis à jour sous peu.',
    'payment_cancelled_stripe': 'Paiement annulé. Aucun débit n\'a été effectué.',
    'online_payments_not_enabled': 'Les paiements en ligne ne sont pas encore activés.',

    // Bail
    'failed_to_load_lease_details': 'Échec du chargement des détails du bail',
    'lease_signed_success': 'Bail signé avec succès !',
    'failed_to_sign_lease': 'Échec de la signature du bail',
    'lease_pdf_download_success': 'Bail PDF téléchargé avec succès',
    'lease_pdf_download_failed': 'Échec du téléchargement du bail. Veuillez réessayer.',
    'generating': 'Génération…',
    'download_pdf': 'Télécharger PDF',
    'download_your_lease': 'Télécharger votre bail signé en PDF',
    'unit_prefix': 'Unité',
    'ip_trace': 'Trace IP :',
    'integrity_hash': 'Hash d\'intégrité :',
    'signature_graphic': 'Signature graphique :',
    'lease_details': 'Détails du bail',
    'lease_details_subtitle': 'Votre contrat de location actif et informations de paiement',
    'lease_signed': 'Signé',
    'sign_lease_now': 'Signer le bail maintenant',
    'contract_term': 'Durée du contrat',
    'start_date': 'Date de début',
    'end_date': 'Date de fin',
    'property_information': 'Informations sur la propriété',
    'landlord_owner': 'Propriétaire / Bailleur',
    'payment_status': 'Statut de paiement',
    'payment_required': 'Paiement requis',
    'e_signature_recorded': 'Signature électronique enregistrée',
    'signed_on': 'Signé le',
    'legal_disclosure': 'Divulgation légale',
    'legal_disclosure_text': 'Ce contrat de bail est juridiquement contraignant. En signant électroniquement, vous acceptez tous les termes et conditions. Assurez-vous d\'avoir lu le document complet avant de signer.',
    'lease_not_found': 'Aucun bail trouvé',
    'contact_management_error': 'Veuillez contacter la gestion si vous pensez qu\'il s\'agit d\'une erreur.',

    // Profil
    'my_profile': 'Mon profil',
    'my_profile_subtitle': 'Mettez à jour vos informations de contact et votre mot de passe',
    'personal_information': 'Informations personnelles',
    'full_name': 'Nom complet',
    'your_full_name_placeholder': 'Votre nom complet',
    'phone_placeholder': '+33 6 XX XX XX XX',
    'email_placeholder': 'votre@email.com',
    'save_changes': 'Enregistrer les modifications',
    'change_password': 'Changer le mot de passe',
    'current_password': 'Mot de passe actuel',
    'new_password': 'Nouveau mot de passe',
    'confirm_new_password': 'Confirmer le nouveau mot de passe',
    'min_8_chars': '8 caractères min.',
    'repeat_new_password': 'Répéter le nouveau mot de passe',
    'update_password': 'Mettre à jour le mot de passe',
    'updating': 'Mise à jour...',
    'passwords_do_not_match': 'Les mots de passe ne correspondent pas',
    'password_min_8': 'Le mot de passe doit comporter au moins 8 caractères',
    'failed_to_load_profile': 'Échec du chargement du profil',
    'profile_updated': 'Profil mis à jour avec succès !',
    'password_changed': 'Mot de passe modifié avec succès !',
    'failed_to_update_profile': 'Échec de la mise à jour du profil',
    'failed_to_change_password': 'Échec du changement de mot de passe',
    'account_id': 'ID du compte',
    'tenant_since': 'Locataire depuis',

    // Inspections
    'my_inspections': 'Mes inspections',
    'my_inspections_subtitle': 'Rapports d\'inspection de votre unité',
    'no_inspections_yet': 'Aucune inspection encore',
    'no_inspections_subtitle': 'Les rapports d\'inspection terminés apparaîtront ici.',
    'items_checked': '{{done}}/{{total}} points vérifiés',
    'inspection_items': 'Points d\'inspection',
    'general_notes': 'Notes générales',
    'failed_to_load_inspections': 'Échec du chargement des inspections',
    'inspection_type_move_in': 'Entrée',
    'inspection_type_move_out': 'Sortie',
    'inspection_type_periodic': 'Périodique',
    'inspection_type_maintenance': 'Maintenance',
    'inspection_status_completed': 'Terminé',
    'inspection_status_signed': 'Signé',
    'inspection_status_draft': 'Brouillon',

    // Services
    'service_charges_title': 'Charges de services',
    'service_charges_subtitle': 'Frais de services mensuels du bâtiment pour votre unité',
    'total_charges': 'Total des charges',
    'outstanding_balance_label': 'Solde impayé',
    'service_charges_year': 'Charges de services — {{year}}',
    'no_service_charges_year': 'Aucune charge de service pour {{year}}',
    'no_service_charges_year_hint': 'Les charges apparaîtront ici lorsqu\'elles seront générées par votre gestionnaire.',
    'paid_on': 'Payé le {{date}}',
    'unpaid': 'Non payé',
    'pay_online': 'Payer en ligne',
    'service_paid_success': 'Charge de service payée avec succès !',
    'payment_canceled': 'Paiement annulé.',
    'failed_to_load_service_charges': 'Échec du chargement des charges de services',

    // Messages
    'management_team': 'Équipe de gestion',
    'management_team_subtitle': 'Message direct avec l\'administration de la propriété',
    'message_empty_state': 'Envoyez un message pour contacter la gestion.',
    'message_placeholder': 'Tapez un message à l\'administration...',
    'failed_to_load_messages': 'Échec du chargement des messages',
    'failed_to_send_message': 'Échec de l\'envoi du message',

    'portfolio_summary': 'Résumé du portefeuille',
    'portfolio_subtitle': 'Indicateurs de performance en temps réel pour {{name}}.',
    'portfolio_statement': 'Relevé de portefeuille',
    'total_units': 'Total des unités',
    'occupancy_rate': 'Taux d\'occupation',
    'active_leases': '{{count}} baux actifs',
    'monthly_revenue': 'Revenus mensuels',
    'vacant_units': 'Unités vacantes',
    'installment_summary': 'Résumé des versements',
    'view_detailed_ledger': 'Voir le grand livre détaillé',
    'outstanding': 'En attente',
    'across_installments': 'Sur {{count}} versements',
    'actions_required': '{{count}} actions immédiates requises',
    'proceed_to_payments': 'Accéder aux paiements',
    'revenue_performance': 'Performance des revenus (6 derniers mois)',
    'no_revenue_data': 'Aucune donnée de revenu',
    'portfolio_distribution': 'Distribution du portefeuille',
    'no_building_data': 'Aucune donnée de bâtiment',
    'occupied_label': 'OCCUPÉ',
    'ready_to_scale': 'Prêt à évoluer ?',
    'ready_to_scale_subtitle': 'Gérez vos propriétés avec une visibilité maximale.',
    'financials': 'Finances',
    'approvals': 'Approbations',
    'failed_to_download_statement': 'Échec du téléchargement du relevé',
    'my_properties': 'Mes propriétés',
    'my_properties_subtitle': 'Aperçu de toutes les unités de votre portefeuille de gestion.',
    'portfolio_empty': 'Portefeuille vide',
    'portfolio_empty_subtitle': 'Aucune unité n\'est actuellement assignée à votre compte.',
    'floor_prefix': 'Étage',
    'current_rent': 'Loyer actuel',
    'per_month_short': '/mois',
    'sqm': 'm²',
    'maintenance_approvals': 'Approbations de maintenance',
    'maintenance_approvals_subtitle': 'Examinez et approuvez les demandes de réparation des locataires.',
    'no_maintenance_requests': 'Aucune demande de maintenance',
    'no_maintenance_subtitle': 'Toutes vos propriétés sont actuellement bien entretenues.',
    'pending_approval': 'En attente d\'approbation',
    'approved_in_progress': 'Approuvé / En cours',
    'rejected_cancelled': 'Rejeté/Annulé',
    'above_threshold': 'Au-dessus du seuil de ${{amount}}',
    'high_priority': 'Priorité haute',
    'medium_priority': 'Priorité moyenne',
    'low_priority': 'Priorité basse',
    'est_cost': 'Coût estimé',
    'approve': 'Approuver',
    'reject': 'Rejeter',
    'request_status_updated': 'Statut de la demande mis à jour',
    'failed_to_update_request': 'Échec de la mise à jour du statut',
    'failed_to_load_maintenance': 'Échec du chargement des demandes de maintenance',
    'failed_to_load_properties': 'Échec du chargement de vos propriétés',
    'financial_overview': 'Aperçu financier',
    'financial_subtitle': 'Suivez les revenus générés par vos locataires dans toutes vos propriétés.',
    'no_financial_data': 'Aucune donnée financière',
    'no_payments_message': 'Aucun paiement enregistré pour votre portefeuille actuellement.',
    'recent_payments': 'Paiements récents',
    'overdue_payments': 'Paiements en retard',
    'property_tenant': 'Propriété / Locataire',
    'gross_amount': 'Montant brut',
    'commission': 'Commission',
    'net_amount': 'Montant net',
    'since': 'Depuis',
    'amount_owed': 'Montant dû',
    'management_commission': 'Commission de gestion',
    'failed_to_load_financials': 'Échec du chargement des données financières',
    'statement_downloaded': 'Relevé de {{month}} {{year}} téléchargé !',
    'member_since': 'Membre depuis',
    'saving': 'Enregistrement...',
    'owner_messages_title': 'Administration immobilière',
    'owner_messages_subtitle': 'Message direct avec l\'équipe de gestion',

    'owner_service_charges': 'Frais de service',
    'owner_service_charges_subtitle': 'Frais de service mensuels pour vos unités vacantes',
    'owner_service_info': 'Les frais de service s\'appliquent uniquement à vos unités <strong>vacantes</strong>. Les unités occupées sont facturées directement aux locataires.',
    'total_charges': 'Total des frais',
    'outstanding_balance': 'Solde impayé',
    'no_service_charges_year': 'Aucun frais de service pour {{year}}',
    'no_service_charges_subtitle': 'Les frais pour les unités vacantes apparaîtront ici une fois générés.',
    'paid_on': 'Payé le {{date}}',
    'pay_online': 'Payer en ligne',
    'service_charge_paid': 'Frais de service payés avec succès !',
    'unpaid': 'Non payé',
    'my_agreements': 'Mes accords',
    'agreements_subtitle': 'Consultez tous vos contrats de gestion et dossiers de propriété.',
    'no_active_agreements': 'Aucun accord actif',
    'no_contracts_message': "Vous n'avez aucun contrat de gestion enregistré dans notre système.",
    'total_value': 'Valeur totale',
    'remaining': 'Restant',
    'indefinite': 'Indéfini',
    'sign_now': 'Signer maintenant',
    'failed_to_load_agreements': 'Impossible de charger les accords',
    'financial_ledger': 'Grand livre financier',
    'ledger_subtitle': 'Détail des versements de frais de gestion et des soldes en attente.',
    'total_outstanding': 'Total impayé',
    'no_installments': 'Aucun versement trouvé dans votre grand livre.',
    'settled': 'Réglé',
    'pay_amount': 'Payer {{amount}}',
    'failed_to_load_installments': 'Impossible de charger le calendrier des versements',
    'failed_to_initiate_payment': 'Impossible d\'initier le paiement',
    'error_connecting_payment': 'Erreur de connexion au prestataire de paiement',
    'payment_success_msg': 'Paiement effectué avec succès !',
    'payment_canceled_msg': 'Paiement annulé.',
    'welcome_user': 'Bienvenue, {{name}} !',
    'owner_portal': 'Portail propriétaire',
    'tenant_portal': 'Portail locataire',
    'owner': 'Propriétaire',
    'tenant': 'Locataire',
    'core': 'Principal',
    'properties_&_contracts': 'Propriétés & Contrats',
    'financial': 'Finances',
    'financial_&_lease': 'Finances & Bail',
    'Dashboard': 'Tableau de bord',
    'Properties': 'Propriétés',
    'Contracts': 'Contrats',
    'Installments': 'Versements',
    'Service Charges': 'Frais de service',
    'Financials': 'Finances',
    'Maintenance': 'Maintenance',
    'Payments': 'Paiements',
    'Lease Details': 'Détails du bail',
    'Inspections': 'Inspections',
    'Profile': 'Profil',
    'documents': 'Documents',
    'announcements': 'Annonces',
    'messages': 'Messages',
    'Messages': 'Messages',
    'maintenance_subtitle': 'Soumettez et suivez toutes vos demandes de maintenance en un seul endroit.',
    'new_request': 'Nouvelle demande',
    'report_an_issue': 'Signaler un problème',
    'issue_summary': 'Résumé du problème',
    'issue_summary_placeholder': 'Ex : Fuite d’eau dans la salle de bain',
    'urgency_level': 'Niveau d’urgence',
    'low_urgency': 'Faible – Pas urgent',
    'normal_urgency': 'Normal – Nécessite attention',
    'high_urgency': 'Élevé – Affecte la vie quotidienne',
    'emergency_urgency': 'Urgence – Action immédiate requise',
    'describe_the_problem': 'Décrire le problème',
    'describe_problem_placeholder': 'Veuillez décrire le problème avec autant de détails que possible...',
    'upload_photo_optional': 'Télécharger une photo (facultatif)',
    'add_photo': 'Ajouter une photo',
    'photo_upload_tip': 'Une photo nous aide à résoudre votre problème plus rapidement.',
    'photo_upload_specs': 'JPG, PNG ou WEBP. Max 5 Mo.',
    'emergency_contact_warning': 'Pour les urgences médicales, appelez immédiatement les services d’urgence. Nous traiterons cette demande en priorité absolue.',
    'processing': 'Traitement…',
    'submit_request': 'Soumettre la demande',
    'ongoing_past_requests': 'Demandes en cours et passées',
    'submitted': 'Soumis',
    'in_progress': 'En cours',
    'completed': 'Terminé',
    'request_cancelled': 'Demande annulée',
    'all_clear': 'Tout est en ordre !',
    'no_maintenance_on_record': 'Aucune demande de maintenance enregistrée. Tout va bien !',
    'resolved_on': 'Résolu le {{date}}',
    'failed_to_load_maintenance_requests': 'Impossible de charger les demandes de maintenance',
    'failed_to_submit_request': 'Impossible de soumettre la demande',
    'photo_size_limit_error': 'La photo doit faire moins de 5 Mo',
    'request_submitted_success': 'Demande soumise avec succès',
    'low': 'Faible',
    'normal': 'Normal',
    'high': 'Élevé',
    'emergency': 'Urgence',
    'id': 'ID',
    'announcements_subtitle': 'Restez informé des dernières nouvelles de votre gestion d\'immeuble.',
    'no_announcements_title': 'Aucune annonce',
    'no_announcements_subtitle': 'Revenez plus tard pour les mises à jour de votre gestion.',
    'posted_by': 'Publié par {{name}}',
    'failed_to_load_announcements': 'Impossible de charger les annonces',
    'documents_verification': 'Documents & Vérification',
    'documents_verification_subtitle': 'Téléchargez et gérez vos documents requis pour une location sereine.',
    'supported_formats_specs': 'Formats acceptés : PDF, JPG, JPEG, PNG. Max 5 Mo par document.',
    'identification_proof': 'Pièce d\'identité',
    'identification_proof_desc': 'Passeport, carte nationale d\'identité ou permis de conduire.',
    'renters_insurance': 'Assurance locataire',
    'renters_insurance_desc': 'Attestation d\'assurance locataire valide couvrant votre logement.',
    'verified': 'Vérifié',
    'missing': 'Manquant',
    'pdf_document': 'Document PDF',
    'view_full_size': 'Voir en plein écran',
    'replace': 'Remplacer',
    'upload_file': 'Télécharger',
    'need_help_verification': 'Besoin d\'aide pour la vérification ?',
    'need_help_verification_subtitle': 'Si vous avez des difficultés à télécharger vos documents, contactez notre équipe support.',
    'contact_support': 'Contacter le support',
    'failed_to_load_document_status': 'Impossible de charger le statut des documents',
    'file_size_large_error': 'Fichier trop volumineux. Max 5 Mo.',
    'document_uploaded_success': 'Document téléchargé avec succès',
    'failed_to_upload_document': 'Impossible de télécharger le document',
    'my_inspections': 'Mes inspections',
    'my_inspections_subtitle': 'Consultez toutes les inspections liées à votre bail.',
    'no_inspections_yet': 'Aucune inspection',
    'no_inspections_subtitle': 'Vos rapports d\'inspection apparaîtront ici une fois réalisés.',
    'failed_to_load_inspections': 'Impossible de charger les inspections',
    'inspection_type_move_in': 'Entrée',
    'inspection_type_move_out': 'Sortie',
    'inspection_type_periodic': 'Périodique',
    'inspection_type_maintenance': 'Maintenance',
    'inspection_status_completed': 'Terminé',
    'inspection_status_signed': 'Signé',
    'inspection_status_draft': 'Brouillon',
    'unit_prefix': 'Unité',
    'items_checked': '{{done}} / {{total}} éléments vérifiés',
    'inspection_items': 'Éléments inspectés',
    'general_notes': 'Notes générales',
    'management_team': 'Équipe de gestion',
    'management_team_subtitle': 'Ligne directe avec la gestion de votre immeuble',
    'message_empty_state': 'Aucun message pour l\'instant. Commencez la conversation !',
    'failed_to_load_messages': 'Impossible de charger les messages',
    'failed_to_send_message': 'Impossible d\'envoyer le message',
    'message_placeholder': 'Tapez un message...',
    'lease_details_subtitle': 'Consultez votre bail, votre statut de paiement et votre signature électronique.',
    'lease_not_found': 'Aucun bail trouvé',
    'contact_management_error': 'Veuillez contacter la gestion de votre immeuble pour obtenir de l\'aide.',
    'lease_signed': 'Signé',
    'download_your_lease': 'Télécharger votre bail en PDF',
    'generating': 'Génération...',
    'download_pdf': 'Télécharger PDF',
    'sign_lease_now': 'Signer le bail maintenant',
    'contract_term': 'Durée du bail',
    'property_information': 'Bien & Propriétaire',
    'landlord_owner': 'Propriétaire',
    'payment_status': 'Statut de paiement',
    'current_balance': 'Solde actuel',
    'payment_required': 'Paiement requis',
    'account_good_standing': 'Compte en règle',
    'lease_signed_success': 'Bail signé avec succès !',
    'failed_to_sign_lease': 'Impossible de signer le bail',
    'lease_pdf_download_success': 'PDF du bail téléchargé avec succès',
    'lease_pdf_download_failed': 'Impossible de télécharger le PDF',
    'e_signature_recorded': 'Signature électronique enregistrée',
    'signed_on': 'Signé le',
    'ip_trace': 'IP',
    'integrity_hash': 'Hash',
    'signature_graphic': 'Votre signature',
    'legal_disclosure': 'Mention légale',
    'legal_disclosure_text': 'Ce bail est un document juridiquement contraignant. En signant électroniquement, vous acceptez tous les termes et conditions du contrat.',
    'payments_billing': 'Paiements & Facturation',
    'payments_billing_subtitle': 'Suivez vos loyers, charges et relevé de compte.',
    'download_statement': 'Télécharger le relevé',
    'current_amount_due': 'Montant dû actuel',
    'due_on': 'Dû le',
    'view_ledger_hint': 'Consultez l\'historique complet dans le',
    'view_your_ledger': 'Relevé de compte',
    'all_paid_up': 'Tout est payé !',
    'tab_rent_payments': 'Paiements de loyer',
    'tab_service_charges': 'Charges',
    'tab_service_charges_due': 'Charges ({{count}} à payer)',
    'tab_account_ledger': 'Relevé de compte',
    'transaction_history': 'Historique des transactions',
    'no_transactions': 'Aucune transaction',
    'no_transactions_subtitle': 'Votre historique de paiements apparaîtra ici.',
    'outstanding_service_charges': 'Charges impayées',
    'service_charge_default': 'Charge',
    'paid_service_history': 'Historique des charges payées',
    'paid_badge': 'Payé',
    'no_service_charges': 'Aucune charge',
    'no_service_charges_subtitle': 'Aucune charge n\'a été facturée à votre compte.',
    'account_balance': 'Solde du compte',
    'ledger_calculated_from': 'Calculé sur {{count}} transactions',
    'full_account_statement': 'Relevé complet',
    'full_account_statement_subtitle': 'Toutes les charges et paiements de votre compte',
    'no_ledger_entries': 'Aucune entrée',
    'no_ledger_entries_subtitle': 'Votre activité de compte apparaîtra ici.',
    'balance_after_col': 'Solde après',
    'ledger_type_charge': 'Charge',
    'ledger_type_late_fee': 'Pénalité de retard',
    'ledger_type_deposit': 'Dépôt',
    'ledger_type_payment': 'Paiement',
    'ledger_type_credit': 'Crédit',
    'payment_success_stripe': 'Paiement réussi ! Votre compte a été mis à jour.',
    'payment_cancelled_stripe': 'Paiement annulé. Aucun frais n\'a été prélevé.',
    'online_payments_not_enabled': 'Les paiements en ligne ne sont pas activés pour votre compte.',
    'failed_to_initiate_payment': 'Impossible d\'initier le paiement',
    'failed_to_load_payment_data': 'Impossible de charger les données de paiement',
    'my_profile': 'Mon profil',
    'my_profile_subtitle': 'Gérez vos informations personnelles et la sécurité de votre compte.',
    'personal_information': 'Informations personnelles',
    'full_name': 'Nom complet',
    'your_full_name_placeholder': 'Votre nom complet',
    'phone_placeholder': '+33 6 XX XX XX XX',
    'email_placeholder': 'vous@exemple.com',
    'saving': 'Enregistrement...',
    'save_changes': 'Enregistrer',
    'change_password': 'Changer le mot de passe',
    'current_password': 'Mot de passe actuel',
    'new_password': 'Nouveau mot de passe',
    'confirm_new_password': 'Confirmer le nouveau mot de passe',
    'min_8_chars': '8 caractères minimum',
    'repeat_new_password': 'Répétez le nouveau mot de passe',
    'passwords_do_not_match': 'Les mots de passe ne correspondent pas',
    'updating': 'Mise à jour...',
    'update_password': 'Mettre à jour',
    'account_id': 'ID du compte',
    'tenant_since': 'Locataire depuis',
    'failed_to_load_profile': 'Impossible de charger le profil',
    'profile_updated': 'Profil mis à jour avec succès',
    'failed_to_update_profile': 'Impossible de mettre à jour le profil',
    'password_changed': 'Mot de passe changé avec succès',
    'failed_to_change_password': 'Impossible de changer le mot de passe',
    'password_min_8': 'Le mot de passe doit contenir au moins 8 caractères',
    'service_charges_title': 'Charges de service',
    'service_charges_subtitle': 'Consultez et payez vos factures de charges.',
    'total_charges': 'Total des charges',
    'outstanding_balance_label': 'Impayé',
    'service_charges_year': 'Charges — {{year}}',
    'no_service_charges_year': 'Aucune charge pour {{year}}',
    'no_service_charges_year_hint': 'Essayez de sélectionner une autre année.',
    'paid_on_date': 'Payé le {{date}}',
    'unpaid_label': 'Impayé',
    'pay_online': 'Payer en ligne',
    'service_paid_success': 'Charge payée avec succès !',
    'payment_canceled': 'Paiement annulé.',
    'failed_to_load_service_charges': 'Impossible de charger les charges',
    'portfolio_summary': 'Résumé du portefeuille',
    'portfolio_subtitle': 'Bienvenue, {{name}}. Voici un aperçu de votre portefeuille immobilier.',
    'portfolio_statement': 'Relevé du portefeuille',
    'total_units': 'Total des unités',
    'occupancy_rate': 'Taux d\'occupation',
    'active_leases': '{{count}} baux actifs',
    'monthly_revenue': 'Revenus mensuels',
    'vacant_units': 'Unités vacantes',
    'installment_summary': 'Résumé des versements',
    'view_detailed_ledger': 'Voir le grand livre',
    'outstanding': 'Impayé',
    'across_installments': 'Sur {{count}} versements',
    'overdue': 'En retard',
    'actions_required': '{{count}} actions requises',
    'proceed_to_payments': 'Accéder aux paiements',
    'revenue_performance': 'Performance des revenus',
    'no_revenue_data': 'Aucune donnée de revenus disponible',
    'portfolio_distribution': 'Distribution du portefeuille',
    'no_building_data': 'Aucune donnée de bâtiment disponible',
    'occupied_label': 'occupé',
    'ready_to_scale': 'Prêt à gérer votre portefeuille ?',
    'ready_to_scale_subtitle': 'Accédez aux outils essentiels pour gérer vos propriétés',
    'failed_to_load_dashboard_data': 'Impossible de charger les données du tableau de bord',
    'failed_to_download_statement': 'Impossible de télécharger le relevé',
    'owner_messages_title': 'Messages',
    'owner_messages_subtitle': 'Communications directes avec la gestion de l\'immeuble',
    'my_properties': 'Mes propriétés',
    'my_properties_subtitle': 'Consultez tous les appartements et unités de votre portefeuille.',
    'portfolio_empty': 'Aucune propriété trouvée',
    'portfolio_empty_subtitle': 'Aucun appartement n\'a encore été assigné à votre portefeuille. Contactez votre gestionnaire.',
    'floor_prefix': 'Étage',
    'sqm': 'm²',
    'current_rent': 'Loyer actuel',
    'per_month_short': '/mois',
    'failed_to_load_properties': 'Impossible de charger les propriétés',
    'maintenance_approvals': 'Approbations de maintenance',
    'maintenance_approvals_subtitle': 'Examinez et approuvez ou refusez les demandes de maintenance des locataires.',
    'failed_to_load_maintenance': 'Impossible de charger les demandes de maintenance',
    'request_status_updated': 'Statut de la demande mis à jour avec succès',
    'failed_to_update_request': 'Impossible de mettre à jour la demande de maintenance',
    'pending_approval': 'En attente d\'approbation',
    'approved_in_progress': 'Approuvé / En cours',
    'rejected_cancelled': 'Rejeté / Annulé',
    'above_threshold': 'Au-dessus du seuil (${{amount}})',
    'no_maintenance_requests': 'Aucune demande de maintenance',
    'no_maintenance_subtitle': 'Les demandes de maintenance des locataires nécessitant votre approbation apparaîtront ici.',
    'financial_overview': 'Vue d\'ensemble financière',
    'financial_subtitle': 'Suivez les revenus générés par vos locataires sur toutes vos propriétés.',
    'no_financial_data': 'Aucune donnée financière',
    'no_payments_message': 'Il n\'y a actuellement aucun paiement enregistré pour votre portefeuille.',
    'recent_payments': 'Paiements récents',
    'property_tenant': 'Propriété / Locataire',
    'gross_amount': 'Montant brut',
    'commission': 'Commission',
    'net_amount': 'Montant net',
    'overdue_payments': 'Paiements en retard',
    'failed_to_load_financials': 'Impossible de charger les données financières',
    'statement_downloaded': 'Relevé de {{month}} {{year}} téléchargé',
    'management_commission': 'Commission de gestion',
    'unit_display': 'Unité {{number}}',
    'since': 'Depuis',
    'amount_owed': 'Montant dû',
    'financial_ledger': 'Grand livre financier',
    'ledger_subtitle': 'Tous les versements d\'acomptes sur vos contrats immobiliers.',
    'total_outstanding': 'Total impayé',
    'installment': 'Versement',
    'due_date': 'Échéance',
    'action': 'Action',
    'partial': 'Partiel',
    'owner_contract': 'Contrat propriétaire',
    'pay_amount': 'Payer {{amount}}',
    'settled': 'Soldé',
    'no_installments': 'Aucun versement trouvé.',
    'failed_to_load_installments': 'Impossible de charger les versements',
    'payment_success_msg': 'Paiement réussi ! Merci.',
    'payment_canceled_msg': 'Paiement annulé.',
    'error_connecting_payment': 'Erreur de connexion au système de paiement',
    'owner_service_charges': 'Charges de service',
    'owner_service_charges_subtitle': 'Consultez et payez les charges facturées pour vos propriétés.',
    'owner_service_info': 'Les charges sont facturées par la gestion de l\'immeuble. Veuillez régler les impayés rapidement pour éviter toute interruption de service.',
    'outstanding_balance': 'Solde impayé',
    'service_charge_paid': 'Charge payée avec succès !',
    'paid_on': 'Payé le {{date}}',
    'unpaid': 'Impayé',
    'my_agreements': 'Mes accords',
    'agreements_subtitle': 'Consultez et signez vos contrats de gestion immobilière.',
    'no_active_agreements': 'Aucun accord trouvé',
    'no_contracts_message': 'Vous n\'avez actuellement aucun contrat enregistré. Contactez votre gestionnaire d\'immeuble.',
    'management_agreement': 'Accord de gestion',
    'total_value': 'Valeur totale',
    'remaining': 'Restant',
    'failed_to_load_agreements': 'Impossible de charger les accords',
    'rent': 'Loyer',
    'download_pdf': 'Télécharger PDF',
    'generating': 'Génération…',
    'announcements_manager': 'Annonces',
    'announcements_manager_subtitle': 'Publiez et gérez des annonces pour les locataires, propriétaires ou bâtiments spécifiques.',
    'new_announcement': 'Nouvelle annonce',
    'publish_announcement': 'Publier',
    'publishing': 'Publication…',
    'all_announcements': 'Toutes les annonces',
    'announcement_created': 'Annonce publiée avec succès !',
    'announcement_create_failed': 'Échec de la publication.',
    'announcement_deleted': 'Annonce supprimée.',
    'announcement_delete_failed': 'Échec de la suppression.',
    'announcement_delete_confirm': 'Supprimer cette annonce ? Cette action est irréversible.',
    'announcement_fields_required': 'Le titre et le contenu sont obligatoires.',
    'announcement_building_required': 'Veuillez sélectionner un bâtiment.',
    'announcement_title_placeholder': 'Ex. Maintenance de l\'eau planifiée lundi',
    'announcement_content_placeholder': 'Rédigez votre message ici…',
    'target_audience': 'Public cible',
    'audience_all': 'Tout le monde',
    'audience_tenants': 'Locataires uniquement',
    'audience_owners': 'Propriétaires uniquement',
    'audience_building': 'Bâtiment spécifique',
    'select_building': 'Sélectionner un bâtiment',
    'select_building_placeholder': '— choisir un bâtiment —',
    'no_announcements_yet': 'Aucune annonce',
    'no_announcements_yet_subtitle': 'Cliquez sur « Nouvelle annonce » pour envoyer votre premier message.',
    'announcements_owner_subtitle': 'Consultez les dernières nouvelles et mises à jour de votre gestionnaire immobilier.',
    'announcements_check_back': 'Revenez plus tard pour les nouvelles et mises à jour de votre gestionnaire.',
    'posted_by': 'Publié par {{name}}',

    // ── Rapport des honoraires de gestion ─────────────────────────────────────
    'management_fee_report': 'Rapport des honoraires de gestion',
    'management_fee_report_subtitle': 'Suivi des encaissements des acomptes propriétaires & analyse des retards',
    'ledger_activity_report': 'Rapport d\'activité du grand livre',
    'ledger_activity_report_subtitle': 'Toutes les entrées du grand livre — charges, paiements, pénalités, crédits et dépôts',
    'ledger_type_charge':   'Débit',
    'ledger_type_late_fee': 'Pénalité de retard',
    'ledger_type_deposit':  'Caution',
    'ledger_type_payment':  'Paiement',
    'ledger_type_credit':   'Crédit',
    'ledger_net_balance':   'Solde dû',
    'feature_locked': 'Fonctionnalité verrouillée',
    'mgmt_fee_analytics_required': 'Les rapports de frais de gestion nécessitent le plan Analytique.',
    'upgrade': 'Mettre à niveau',
    'year': 'Année',
    'month': 'Mois',
    'all_months': 'Tous les mois',
    'all_owners': 'Tous les propriétaires',
    'all_statuses': 'Tous les statuts',
    'status_paid': 'Payé',
    'status_pending_upcoming': 'En attente (à venir)',
    'status_overdue': 'En retard',
    'status_partial': 'Partiel',
    'status_cancelled_label': 'Annulé',
    'clear_filters': 'Effacer les filtres',
    'print_pdf': 'Imprimer / PDF',
    'export_csv': 'Exporter CSV',
    'exporting': 'Exportation…',
    'total_expected': 'Total prévu',
    'total_collected': 'Total collecté',
    'overdue_balance': 'Solde en retard',
    'collection_rate': 'Taux de collecte',
    'n_installments': '{{count}} acomptes',
    'n_paid': '{{count}} payé',
    'n_overdue_installments': '{{count}} acomptes en retard',
    'n_upcoming': '{{count}} à venir',
    'monthly_breakdown': 'Répartition mensuelle — {{year}}',
    'monthly_breakdown_filtered': 'Répartition mensuelle — {{year}} (filtré sur {{month}})',
    'chart_expected': 'Prévu',
    'chart_collected': 'Collecté',
    'chart_overdue': 'En retard',
    'no_installment_data_year': 'Aucune donnée d\'acompte pour {{year}}',
    'tooltip_expected': 'Prévu :',
    'tooltip_collected': 'Collecté :',
    'tooltip_overdue': 'En retard :',
    'all_installments': 'Tous les acomptes',
    'n_records': '{{count}} enregistrement',
    'n_records_plural': '{{count}} enregistrements',
    'page_of': 'page {{page}}/{{total}}',
    'no_installments_found': 'Aucun acompte trouvé',
    'try_adjusting_filters': 'Essayez d\'ajuster vos filtres.',
    'col_owner': 'Propriétaire',
    'col_apt': 'Apt',
    'col_building': 'Bâtiment',
    'col_due_date': 'Date d\'échéance',
    'col_amount': 'Montant',
    'col_paid': 'Payé',
    'col_balance': 'Solde',
    'col_status': 'Statut',
    'col_days_late': 'Jours de retard',
    'totals_all_pages': 'Totaux (toutes pages) :',
    'previous': '← Précédent',
    'next': 'Suivant →',
    'page_x_of_y': 'Page {{page}} sur {{total}} ({{count}} au total)',
    'overdue_aging_title': 'Acomptes en retard — Analyse de vieillissement',
    'col_aging': 'Ancienneté',
    'all_installments_up_to_date': 'Tous les acomptes sont à jour !',
    'no_overdue_found': 'Aucun acompte de frais de gestion en retard trouvé.',
    'total_overdue': 'Total en retard :',
    'n_days': '{{count}} jours',
    'aging_1_30': '1–30 jours',
    'aging_31_60': '31–60 jours',
    'aging_61_90': '61–90 jours',
    'aging_90_plus': '90+ jours',
    'badge_paid': 'Payé',
    'badge_partial': 'Partiel',
    'badge_pending': 'En attente',
    'badge_overdue': 'En retard',
    'badge_cancelled': 'Annulé',
    'failed_to_load_mgmt_fee_report': 'Échec du chargement du rapport de frais de gestion',
    'export_failed': 'Échec de l\'exportation',
    'export_downloaded_label': 'Téléchargé : {{label}}',

    // Report Templates
    'report_templates': 'Modèles de Rapports',
    'report_templates_subtitle': 'Créez et gérez des configurations de rapports réutilisables',
    'create_template': 'Nouveau Modèle',
    'create_first_template': 'Créer le Premier Modèle',
    'template_name': 'Nom du Modèle',
    'template_description': 'Description',
    'template_config': 'Configuration (JSON)',
    'no_templates': 'Aucun Modèle de Rapport',
    'no_templates_message': 'Enregistrez vos configurations de rapports fréquemment utilisées comme modèles réutilisables.',
    'template_created': 'Modèle créé avec succès',
    'template_updated': 'Modèle mis à jour avec succès',
    'template_deleted': 'Modèle supprimé',
    'delete_template_title': 'Supprimer le Modèle',
    'delete_template_message': 'Êtes-vous sûr de vouloir supprimer "{{name}}" ? Cette action ne peut pas être annulée.',



    // Email Template Form
    'et_new_title': 'Nouveau modèle d\'e-mail',
    'et_edit_title': 'Modifier le modèle d\'e-mail',
    'et_basic_info': 'Informations de base',
    'et_template_name': 'Nom du modèle *',
    'et_template_name_placeholder': 'ex. Rappel de loyer mensuel',
    'et_trigger_event': 'Événement déclencheur',
    'et_description': 'Description',
    'et_description_placeholder': 'Note interne optionnelle',
    'et_subject_line': 'Ligne d\'objet *',
    'et_subject_placeholder': 'ex. Votre loyer de ${{rent_amount}} est dû le {{due_date}}',
    'et_html_body': 'Corps HTML',
    'et_editor': 'Éditeur',
    'et_preview': 'Aperçu',
    'et_quick_insert': 'Insérer des variables',
    'et_update_btn': 'Mettre à jour le modèle',
    'et_create_btn': 'Créer le modèle',
    'et_created': 'Modèle créé',
    'et_updated': 'Modèle mis à jour',
    'et_failed_load': 'Échec du chargement du modèle',
    'et_save_failed': 'Échec de la sauvegarde',
    'et_fields_required': 'Le nom, l\'objet et le corps sont requis',
    'issue_utility_bill': 'Émettre une facture de services',
    'tenant_billing_assignment': 'Assignation du locataire et facturation',
    'select_tenant': 'Sélectionner le locataire',
    'search_tenant_placeholder': 'Rechercher par nom ou numéro d\'appartement...',
    'utility_details': 'Détails des services',
    'period_month': 'Mois',
    'period_year': 'Année',
    'due_date': 'Date d\'échéance',
    'posting_options': 'Options d\'enregistrement',
    'charge_immediately': 'Facturer immédiatement au grand livre',
    'charge_immediately_desc_on': 'Le montant sera enregistré sur le solde du locataire dès l\'enregistrement.',
    'charge_immediately_desc_off': 'La facture sera enregistrée comme "En attente" et vous devrez la facturer manuellement plus tard.',
    'processing': 'Traitement...',
    'issue_and_charge': 'Émettre et facturer',
    'issue_bill': 'Émettre la facture',
    'meter_identity_provider': 'Identité du compteur et fournisseur',
    'account_number': 'Numéro de compte',
    'meter_number': 'Numéro de compteur',
    'shared_meter_rubs': 'Compteur partagé (répartition RUBS)',
    'pricing_unit_measurement': 'Prix et unité de mesure',
    'rate_per_unit': 'Tarif par unité ($)',
    'unit_of_measure': 'Unité de mesure',
    'billing_day_monthly': 'Jour de facturation (mensuel)',
    'internal_notes': 'Notes internes',

    // Utility — edit / void / mark-paid
    'edit_utility_account': 'Modifier le compte de services',
    'void_bill': 'Annuler la facture',
    'void_reason': 'Raison (optionnel)',
    'void_reason_placeholder': 'ex. Erreur de facturation, doublon...',
    'confirm_void_bill': 'Cette facture sera annulée et ne pourra plus être débitée.',
    'confirm_void_bill_sent': 'Cette facture a déjà été débitée. Une écriture de crédit sera émise pour l\'annuler.',
    'bill_voided': 'Facture annulée',
    'bill_marked_paid': 'Facture marquée comme payée',
    'confirm_mark_paid': 'Marquer cette facture comme payée (paiement externe) ?',
    'deactivate_utility_account': 'Désactiver le compte',
    'confirm_deactivate_utility_account': 'Êtes-vous sûr de vouloir désactiver ce compte de services ?',
    'post_utility_charge': 'Enregistrer la charge de service',
    'account_updated': 'Compte mis à jour avec succès',
    'utility_bill': 'Facture de service',
    'tenant_info': 'Locataire',
    'tenant_name_5': 'Nom',
    'email_15': 'E-mail',
    'reading_history': 'Historique des relevés',
    'usage_breakdown': 'Détails de consommation',
    'previous_reading': 'Relevé précédent',
    'current_reading': 'Relevé actuel',
    'view_account': 'Voir le compte de service',

    // Currency
    'currency_selector_label': 'Devise de l\'organisation',
    'currency_stripe_warning': 'Les paiements en ligne via Stripe ne sont pas disponibles pour cette devise. Les locataires paieront en personne uniquement.',
    'online_payment_unavailable': 'Le paiement en ligne n\'est pas disponible pour votre devise. Veuillez payer en personne.',

    // --- HIGH-QUALITY MANUAL TRANSLATIONS ---
    'total_properties': 'Total des propriétés',
    'active_properties': 'Propriétés actives',
    'active_tenants': 'Locataires actifs',
    'monthly_revenue': 'Revenu mensuel',
    'pending_payments': 'Paiements en attente',
    'lease_expiring_soon': 'Bail expirant bientôt',
    'payment_risk': 'Risque de paiement',
    'ai_scored_late_payment': 'Probabilité de retard de paiement (IA)',
    'high_risk': 'Risque élevé',
    'medium_risk': 'Risque moyen',
    'low_risk': 'Faible risque',
    'no_scores_yet': 'Aucun score pour le moment. Cliquez sur actualiser.',
    'renewal_risk': 'Risque de renouvellement',
    'leases_expiring_in_90_days': 'Baux expirant dans 90 jours',
    'exp_in_30d': 'Expire dans 30j',
    'exp_in_90d': 'Expire dans 90j',
    'no_leases_expiring_90d': 'Aucun bail n\'expire dans les 90 prochains jours.',
    'leasing_office': 'Bureau de location',
    'marketing_links': 'Liens marketing',
    'bulk_import': 'Importation en masse',
    'evictions': 'Expulsions',
    'accounting': 'Comptabilité',
    'payments': 'Paiements',
    'portfolio_kpis': 'Portefeuille et KPIs',
    'bulk_comms': 'Message groupé',
    'email_templates': 'Modèles d\'e-mails',
    'building_view': 'Vue du bâtiment',
    'failed_to_load_logs': 'Échec du chargement des journaux d\'activité',
    'export_failed': 'Échec de l\'exportation des journaux',
    'all_user_activities_desc': 'Suivre toutes les actions du système',
    'search_logs': 'Rechercher dans les journaux...',
    'entries': 'entrées',
    'filter_activities': 'Filtrer les activités',
    'action_type': 'Type d\'action',
    'all_actions': 'Toutes les actions',
    'entity_type': 'Type d\'entité',
    'all_types': 'Tous les types',
    'start_date': 'Date de début',
    'end_date': 'Date de fin',
    'reset': 'Réinitialiser',
    'apply_filter': 'Appliquer le filtre',
    'time': 'Heure',
    'user': 'Utilisateur',
    'action': 'Action',
    'entity': 'Entité',
    'details': 'Détails',
    'amount': 'Montant',
    'no_logs_matching_search': 'Aucun journal ne correspond à votre recherche.',
    'no_logs_available': 'Aucun journal d\'activité disponible.',
    'showing_range': 'Affichage de {{start}} à {{end}} sur {{total}}',
    'previous': 'Précédent',
    'next': 'Suivant',
    'exporting': 'Exportation...',
    'export': 'Exporter',
    'filter': 'Filtrer',
    'activity_logs': 'Journaux d\'activité',
    'invitation_only_onboarding': 'Inscription sur invitation uniquement',
    'approve_payment_msg': 'Êtes-vous sûr de vouloir approuver ce paiement ?',
    'reject_payment_msg': 'Veuillez fournir une raison pour rejeter ce paiement.',
    'errors_serverError': 'Erreur de serveur interne',
    'timePeriods_month': 'Mois',
    'timePeriods_quarter': 'Trimestre',
    'timePeriods_year': 'Année',
    'common_startDate': 'Date de début',
    'common_endDate': 'Date de fin',
    'common_type': 'Type',
    'common_all': 'Tous',
    'common_tenant': 'Locataire',

  
  
  
    // Auto-added translations
    'leases_expiring_90d': 'Baux expirant 90j',
    'left': 'Gauche',
    'view_all_renewal_risks': 'Afficher tous les risques de renouvellement',
    're_run_ai_scoring': 'Réexécuter le score Ai',
    'medium': 'Moyen',
    'owed': 'dû',
    'view_all_risk_scores': 'Afficher tous les scores de risque',
    'at_12_pm': 'À 12 heures',
    'unpaid_balance': 'Solde impayé',
    'lease_period': 'Période de location',
    'view_record': 'Afficher l\'enregistrement',
    'apartment_created_successfully': 'Appartement créé avec succès',
    'apartment_updated_successfully': 'Appartement mis à jour avec succès',
    'manage_your_properties': 'Gérez vos propriétés',
    'filter_apartments': 'Filtrer les appartements',
    'no_matching_apartments_message': 'Aucun message d\'appartement correspondant',
    'furnished_apartment': 'Appartement Meublé',
    'manage': 'Gérer',
    'delete_apartment': 'Supprimer l\'appartement',
    'select_at_least_one_floor': 'Sélectionnez au moins un étage',
    'add_at_least_one_unit_type': 'Ajouter au moins un type d\'unité',
    'apartments_created': 'Appartements créés',
    'skipped_duplicates': 'Doublons ignorés',
    'apartments_created_successfully': 'Appartements créés avec succès',
    'error_creating_apartments': 'Erreur lors de la création d\'appartements',
    'select_floors': 'Sélectionnez les étages',
    'clear': 'Effacer',
    'qty_per_floor': 'Qté par étage',
    'units_per_floor': 'Unités par étage',
    'select_floors_and_types': 'Sélectionnez les sols et les types',
    'future_tenant_only': 'Futur locataire uniquement',
    'converted': 'Converti',
    'confirmed': 'Confirmé',
    'hold': 'Tenir',
    'failed_confirm_booking': 'Échec de la confirmation de la réservation',
    'failed_cancel_booking': 'Échec de l\'annulation de la réservation',
    'failed_convert_tenant': 'Échec de la conversion du locataire',
    'converted_to_tenant': 'Converti en locataire',
    'cancellation_reason': 'Raison de l\'annulation',
    'hold_expired': 'Conserver expiré',
    'cancel_booking_question': 'Question d\'annulation de réservation',
    'yes_cancel': 'Oui Annuler',
    'keep_it': 'Gardez-le',
    'booking_created': 'Réservation créée',
    'failed_save_booking': 'Échec de l\'enregistrement de la réservation',
    'building_created_successfully': 'Bâtiment créé avec succès',
    'building_updated_successfully': 'Bâtiment mis à jour avec succès',
    'bulk_add': 'Ajout groupé',
    'total_buildings': 'Total des bâtiments',
    'avg_occupancy': 'Occupation moyenne',
    'current': 'Actuel',
    'building_has_no_apartments': 'Le bâtiment n’a pas d’appartements',
    'add_apartments_hint': 'Ajouter un indice sur les appartements',
    'due': 'Due',
    'description': 'Descriptif',
    'next_7_days': '7 prochains jours',
    'next_14_days': '14 prochains jours',
    'next_30_days': '30 prochains jours',
    'view_arrow': 'Afficher la flèche',
    'search_unit_tenant': 'Rechercher un locataire d\'unité',
    'no_results_for_filters': 'Aucun résultat pour les filtres',
    'charged': 'Facturé',
    'bank': 'Banque',
    'cheque': 'Vérifier',
    'stripe': 'Rayure',
    'failed_to_load_revenue': 'Échec du chargement des revenus',
    'no_tenant_logs': 'Aucun journal de locataire',
    'payment_record_error': 'Erreur d\'enregistrement de paiement',
    'contract_not_found': 'Contrat introuvable',
    'back_to_owner': 'Retour au propriétaire',
    'contract_id': 'Numéro de contrat',
    'summary_info': 'Informations récapitulatives',
    'n_a': 'N.A.',
    'paid_progress': 'Progression payante',
    'total_installments': 'Total des versements',
    'paid_installments': 'Versements payés',
    'pending_installments': 'Versements en attente',
    'legal_document': 'Document juridique',
    'signatures': 'Signature',
    'owner_signature': 'Signature du propriétaire',
    'awaiting_owner_signature': 'En attente de la signature du propriétaire',
    'admin_signature': 'Signature de l\'administrateur',
    'awaiting_admin_signature': 'En attente de la signature de l\'administrateur',
    'paid_amount': 'Montant payé',
    'save_payment': 'Enregistrer le paiement',
    'language': 'Langue',
    'exportPDF': 'Exporter un PDF',
    'print': 'Imprimer',
    'receiptNo': 'Numéro de reçu',
    'contractDetails': 'Détails du contrat',
    'contractNo': 'Numéro de contrat',
    'contractType': 'Type de contrat',
    'startDate': 'Date de début',
    'endDate': 'Date de fin',
    'openEnded': 'Ouvert',
    'financialSummary': 'Résumé financier',
    'totalValue': 'Valeur totale',
    'totalPaid': 'Total payé',
    'balanceDue': 'Solde dû',
    'installmentSchedule': 'Calendrier des versements',
    'dueDate': 'Date d\'échéance',
    'paidAmt': 'Montant payé',
    'paymentDate': 'Date de paiement',
    'paidWatermark': 'Filigrane payant',
    'paymentDetails': 'Détails du paiement',
    'installmentNo': 'Numéro de versement',
    'amountDue': 'Montant dû',
    'amountPaid': 'Montant payé',
    'paymentStatus': 'Statut du paiement',
    'paymentConfirmed': 'Paiement confirmé',
    'awaitingPayment': 'En attente de paiement',
    'balanceRemaining': 'Solde restant',
    'authorizedSig': 'Signature autorisée',
    'ownerSig': 'Signature du propriétaire',
    'generatedBy': 'Généré par',
    'informationalOnly': 'À titre informatif seulement',
    'failed_to_load_owner_data': 'Échec du chargement des données du propriétaire',
    'sending': 'Envoi',
    'payment_reminder_message': 'Message de rappel de paiement',
    'reminder_sent_success': 'Rappel envoyé avec succès',
    'failed_to_send_reminder': 'Échec de l\'envoi du rappel',
    'owner_has_no_email': 'Le propriétaire n\'a pas d\'e-mail',
    'portal_invitation_sent_successfully': 'Invitation au portail envoyée avec succès',
    'failed_to_send_portal_invite': 'Échec de l\'envoi de l\'invitation au portail',
    'owner_not_found': 'Propriétaire introuvable',
    'total_income': 'Revenu total',
    'residence': 'Résidence',
    'does_not_live_on_property': 'N\'habite pas sur la propriété',
    'outstanding_fees_note': 'Remarque sur les frais impayés',
    'pending_signature': 'En attente de signature',
    'fully_executed': 'Entièrement exécuté',
    'error_loading_financials': 'Erreur lors du chargement des données financières',
    'due_soon': 'À venir bientôt',
    'owner_updated_successfully': 'Propriétaire mis à jour avec succès',
    'invitation_sent': 'Invitation envoyée',
    'invitation_failed': 'Échec de l\'invitation',
    'owner_created_successfully': 'Propriétaire créé avec succès',
    'preferred_language': 'Langue préférée',
    'english': 'Anglais',
    'arabic': 'arabe',
    'kurdish': 'Kurde',
    'drop_here': 'Déposez ici',
    'failed_to_load_owners_data': 'Échec du chargement des données des propriétaires',
    'connection_error': 'Erreur de connexion',
    'failed_to_delete_owner': 'Échec de la suppression du propriétaire',
    'failed_to_delete_owners': 'Échec de la suppression des propriétaires',
    'edit_owner': 'Modifier le propriétaire',
    'delete_owner': 'Supprimer le propriétaire',
    'occupied_lowercase': 'Minuscule occupée',
    'confirm_bulk_delete_title': 'Confirmer la suppression groupée du titre',
    'refresh_owners': 'Actualiser les propriétaires',
    'delete_selected_owners': 'Supprimer les propriétaires sélectionnés',
    'export_to_pdf': 'Exporter vers PDF',
    'print_owners': 'Propriétaires d\'impression',
    'min_zero': 'Min Zéro',
    'count_formatted': 'Nombre formaté',
    'most_popular': 'Les plus populaires',
    'trial': 'Essai',
    'past_due': 'En souffrance',
    'canceled': 'Annulé',
    'invalid_plan_selected': 'Plan non valide sélectionné',
    'could_not_start_checkout': 'Impossible de démarrer le paiement',
    'checkout_failed': 'Échec du paiement',
    'could_not_open_portal': 'Impossible d\'ouvrir le portail',
    'failed_to_open_portal': 'Échec de l\'ouverture du portail',
    'payment_approved_success': 'Paiement approuvé avec succès',
    'failed_to_approve_payment': 'Échec de l\'approbation du paiement',
    'provide_rejection_reason': 'Fournir la raison du rejet',
    'payment_rejected': 'Paiement rejeté',
    'failed_to_reject_payment': 'Échec du rejet du paiement',
    'stripe_connected': 'Bande connectée',
    'yr': 'Année',
    'mo': 'Mo',
    'expires': 'Expire',
    'renews': 'Renouvelle',
    'opening': 'Ouverture',
    'stripe_portal_title': 'Titre du portail Stripe',
    'stripe_portal_desc': 'Description du portail Stripe',
    'monthly': 'Mensuel',
    'annual': 'Annuel',
    'redirecting': 'Redirection',
    'stripe_secure_notice': 'Avis sécurisé Stripe',
    'failed': 'Échec',
    'organization': 'Organisation',
    'approve_payment': 'Approuver le paiement',
    'reject_payment': 'Rejeter le paiement',
    'errors.serverError': 'Erreur de serveur',
    'export_excel': 'Exporter Excel',
    'timePeriods.month': 'Mois',
    'timePeriods.quarter': 'Trimestre',
    'timePeriods.year': 'Année',
    'common.startDate': 'Date de début',
    'common.endDate': 'Date de fin',
    'common.type': 'Tapez',
    'common.all': 'Tout',
    'common.tenant': 'Locataire',
    'common.searchTenant': 'Rechercher un locataire',
    'ledgerReport.netBalance': 'Solde net',
    'ledgerReport.entries': 'Entrées',
    'common.noData': 'Aucune donnée',
    'common.date': 'Date',
    'common.building': 'Bâtiment',
    'common.apartment': 'Appartement',
    'common.description': 'Descriptif',
    'common.amount': 'Montant',
    'ledgerReport.balanceAfter': 'Solde après',
    'ledgerReport.createdBy': 'Créé par',
    'common.page': 'Pages',
    'metric': 'Métrique',
    'value': 'Valeur',
    'failed_to_export': 'Échec de l\'exportation',
    'select_date_range': 'Sélectionnez une plage de dates',
    'revenue_deep_dive_restricted': 'Revenus approfondis restreints',
    'showing_building_revenue': 'Affichage des revenus du bâtiment',
    'showing_owner_revenue': 'Affichage des revenus du propriétaire',
    'showing_monthly_revenue': 'Affichage des revenus mensuels',
    'receiptTitle': 'Titre du reçu',
    'receiptDate': 'Date de réception',
    'residentName': 'Nom du résident',
    'servicePeriod': 'Période de service',
    'signature': 'Signature',
    'responsible': 'Responsable',
    'thankYou': 'Merci',
    'invalid_amount': 'Montant invalide',
    'payment_generated_successfully': 'Paiement généré avec succès',
    'failed_to_generate_payment': 'Échec de la génération du paiement',
    'no_owner': 'Aucun propriétaire',
    'rented': 'Loué',
    'payer': 'Payeur',
    'failed_to_load_service_data': 'Échec du chargement des données de service',
    'records': 'Enregistrements',
    'no_matching_payments_found': 'Aucun paiement correspondant trouvé',
    'paid_count': 'Nombre payé',
    'unpaid_count': 'Compte impayé',
    'no_data_to_export': 'Aucune donnée à exporter',
    'export_successful': 'Exportation réussie',
    'months_with_data': 'Mois avec données',
    'data_refreshed_successfully': 'Données actualisées avec succès',
    'payment_marked_as_paid': 'Paiement marqué comme payé avec succès',
    'payment_marked_as_unpaid': 'Paiement marqué comme non payé avec succès',
    'rented': 'Loué',
    'service_charge_deleted': 'Charge de service supprimée avec succès',
    'failed_to_delete_service_charge': 'Échec de la suppression de la charge de service',
    'service_payment_note_default': 'Paiement de service pour {{month}} {{year}}',
    'failed_init_stripe': 'Échec de la bande d\'initialisation',
    'refresh_status': 'Actualiser le statut',
    'failed_to_load_user_data': 'Échec du chargement des données utilisateur',
    'error_updating_profile': 'Erreur lors de la mise à jour du profil',
    'error_updating_password': 'Erreur lors de la mise à jour du mot de passe',
    'failed_to_load_system_data': 'Échec du chargement des données système',
    'logo_upload_success': 'Succès du téléchargement du logo',
    'error_from_server': 'Erreur du serveur',
    'error_uploading_logo': 'Erreur lors du téléchargement du logo',
    'error_updating_system_settings': 'Erreur lors de la mise à jour des paramètres système',
    'contact_email': 'E-mail de contact',
    'contact_phone': 'Téléphone de contact',
    'office_address': 'Adresse du bureau',
    'organization_logo': 'Logo de l\'organisation',
    'nameLabel': 'Étiquette de nom',
    'floorPre': 'Pré-étage',
    'aptPre': 'Apt Pré',
    'periodLabel': 'Étiquette de période',
    'officeCommission': 'Commission de bureau',
    'invalid_date': 'Date invalide',
    'tenant_has_no_email': 'Le locataire n\'a pas d\'e-mail',
    'portal_invitation_failed': 'Échec de l\'invitation au portail',
    'lease_extended_success': 'Succès prolongé du bail',
    'failed_to_extend_lease': 'Échec de la prolongation du bail',
    'lease_renewed_success': 'Succès renouvelé du bail',
    'failed_to_renew_lease': 'Échec du renouvellement du bail',
    'ending_lease': 'Fin du bail',
    'french': 'Français',
    'german': 'Allemand',
    'italian': 'Italien',
    'no_additional_fees': 'Pas de frais supplémentaires',
    'electronic_signature': 'Signature électronique',
    'no_maintenance_requests_message': 'Aucun message de demande de maintenance',
    'add_first_request': 'Ajouter une première demande',
    'extending': 'Extension',
    'renewing': 'Renouveler',
    'tenant_updated_successfully': 'Locataire mis à jour avec succès',
    'tenant_created_successfully': 'Locataire créé avec succès',
    'no_phone': 'Pas de téléphone',
    'not_assigned': 'Non attribué',
    'financial_details': 'Détails financiers',
    'more_info': 'Plus d\'informations',
    'apartment_specs': 'Spécifications de l\'appartement',
    'user_created_email_failed': 'Échec de l\'e-mail créé par l\'utilisateur',
    'user_created_email_failed_2': 'Échec de l\'e-mail créé par l\'utilisateur 2',
    'invitation_email_could_not_be_sent': 'L\'e-mail d\'invitation n\'a pas pu être envoyé',
    'user_created_email_failed_3': 'Échec de l\'e-mail créé par l\'utilisateur 3',
    'manual_onboarding_link': 'Lien d\'intégration manuelle',
    'manual_onboarding_desc': 'Description d\'intégration manuelle',
    'link_copied_to_clipboard': 'Lien copié dans le presse-papiers',
    'copy_link': 'Copier le lien',
    'add_another_user': 'Ajouter un autre utilisateur',
    'invitation_only_onboarding_desc': 'Description d\'intégration sur invitation uniquement',
    'hide_inactive_users': 'Masquer les utilisateurs inactifs',
    'show_inactive_users': 'Afficher les utilisateurs inactifs',
    'error_loading_users': 'Erreur lors du chargement des utilisateurs',
    'no_users_message': 'Aucun message utilisateur',
    'create_first_user': 'Créer le premier utilisateur',
    'enable_whatsapp_notifications': 'Activer les notifications WhatsApp',
    'whatsapp_enable_desc': 'Whatsapp Activer la description',
    'default_message_language': 'Langue des messages par défaut',
    'spanish': 'Espagnol',
    'rent_reminder': 'Rappel de loyer',
    'enable_rent_reminders': 'Activer les rappels de loyer',
    'rent_reminders_desc': 'Rappels de loyer Desc',
    'enable_service_fee_reminders': 'Activer les rappels de frais de service',
    'service_fee_reminders_desc': 'Rappels de frais de service Desc',
    'owner_reminders_desc': 'Rappels au propriétaire Desc',
    'send_payment_confirmation': 'Envoyer une confirmation de paiement',
    'payment_confirmation_desc': 'Description de la confirmation de paiement',
    'sms_sent_to': 'SMS envoyé à',
    'sms_failed': 'Échec du SMS',
    'request_failed': 'La demande a échoué',
    'enable_sms_notifications': 'Activer les notifications par SMS',
    'sms_enable_desc': 'SMS Activer la description',
    'sender': 'Expéditeur',
    'via_twilio': 'Via Twilio',
    'send_test_sms': 'Envoyer un SMS test',
    'test_sms_desc': 'Tester la description du SMS',
    'send_test': 'Envoyer le test',
    'recipient_pending': 'Destinataire en attente',
    'no_pending_reminders': 'Aucun rappel en attente',
    'no_recipients_match': 'Aucune correspondance de destinataires',
    'confirm_send_all': 'Confirmer Envoyer tout',
    'failed_load_notification_settings': 'Paramètres de notification d\'échec de chargement',
    'settings_save_failed': 'Échec de l\'enregistrement des paramètres',
    'preview_failed': 'Échec de l\'aperçu',
    'reminders_sent': 'Rappels envoyés',
    'on': 'Sur',
    'off': 'Désactivé',
    'sms_twilio': 'SMS',
    'notification_settings': 'Paramètres de notification',
    'notification_settings_desc': 'Description des paramètres de notification',
    'preview_send': 'Aperçu Envoyer',
    'save_settings': 'Enregistrer les paramètres',
    'loading_units': 'Unités de chargement',
    'listed_rent': 'Loyer Inscrit',
    'portfolio_occupancy': 'Occupation du portefeuille',
    'avg_renewal_increase': 'Augmentation moyenne du renouvellement',
    'title': 'Titre',
    'content': 'Contenu',
    'marketing_links_desc': 'Description des liens marketing',
    'days': 'Jours',
    'download_failed': 'Échec du téléchargement',
    'run_report': 'Exécuter le rapport',
    'downloading': 'Téléchargement',
    'total_ar': 'Ar totale',
    'total_balance': 'Solde total',
    'no_outstanding_balances_found': 'Aucun solde impayé trouvé',
    'totals': 'Totaux',
    'subject_body_required': 'Corps du sujet requis',
    'no_active_tenants': 'Aucun locataire actif',
    'confirm_send_bulk': 'Confirmer l\'envoi groupé',
    'message_sent_to_tenants': 'Message envoyé aux locataires',
    'bulk_communications': 'Communications en masse',
    'message_sent_successfully': 'Message envoyé avec succès',
    'in_app_announcement': 'Annonce dans l\'application',
    'dismiss': 'Rejeter',
    'target_building': 'Bâtiment cible',
    'all_buildings_count': 'Tous les bâtiments comptent',
    'compose_message': 'Composer un message',
    'subject': 'Sujet',
    'message_body': 'Corps du message',
    'markdown_hint': 'Astuce de démarque',
    'characters': 'Personnages',
    'delivery_channels': 'Canaux de livraison',
    'email_blast': 'Envoi d\'e-mails',
    'send_to_tenants': 'Envoyer aux locataires',
    'bulk_guidelines': 'Directives concernant le volume',
    'in_app_announcements': 'Annonces dans l\'application',
    'in_app_desc': 'Dans la description de l\'application',
    'email_blasts': 'Envois d\'e-mails',
    'email_blast_desc': 'Description de l\'envoi d\'e-mails',
    'send_immediate_desc': 'Envoyer une description immédiate',
    'professional_desc': 'Description professionnelle',
    'owner_balances': 'Soldes du propriétaire',
    'deselect_all': 'Désélectionner tout',
    'select_all': 'Sélectionner tout',
    'notes_optional': 'Remarques Facultatif',
    'confirm_bulk_payout_title': 'Confirmer le paiement groupé',
    'error_loading_churn_data': 'Erreur lors du chargement des données de désabonnement',
    'running_scoring': 'Notation en cours d\'exécution',
    'scored_tenants': 'Locataires notés',
    'scoring_failed': 'Échec de la notation',
    'vendor_dashboard_subtitle': 'Sous-titre du tableau de bord du fournisseur',
    'view_your_work_orders': 'Afficher vos bons de travail',
    'confirm_replace_content': 'Confirmer le remplacement du contenu',
    'applied_template': 'Modèle appliqué',
    'templates': 'Modèles',
    'editor': 'Éditeur',
    'desktop': 'Bureau',
    'mobile': 'Mobile',
    'realistic_sample_data': 'Exemples de données réalistes',
    'template_logic': 'Logique du modèle',
    'event_trigger_desc': 'Description du déclencheur d\'événement',
    'admin_only': 'Administrateur uniquement',
    'click_to_insert': 'Cliquez pour insérer',
    'body': 'Corps',
    'template_deactivated': 'Modèle désactivé',
    'failed_to_deactivate': 'Échec de la désactivation',
    'enter_test_email': 'Entrez l\'e-mail de test',
    'test_email_sent_to': 'E-mail de test envoyé à',
    'failed_to_send_test': 'Échec de l\'envoi du test',
    'active_templates_count': 'Nombre de modèles actifs',
    'send_test_email': 'Envoyer un e-mail de test',
    'save_failed': 'Échec de l\'enregistrement',
    'description_required': 'Description Obligatoire',
    'post_failed': 'Échec de la publication',
    'code': 'Coder',
    'create_account': 'Créer un compte',
    'apply': 'Postuler',
    'account': 'Compte',
    'debit': 'Débit',
    'credit': 'Crédit',
    'lines': 'Lignes',
    'hide': 'Masquer',
    'reverse': 'Inverser',
    'run': 'Courir',
    'total_debits': 'Total des débits',
    'total_credits': 'Crédits totaux',
    'journal_entry': 'Entrée de journal',
    'building_id_label': 'Étiquette d\'identification du bâtiment',
    'units_count': 'Nombre d\'unités',
    'enable_in_settings': 'Activer dans les paramètres',
    'unit_label': 'Étiquette de l\'unité',
    'no_messages_yet': 'Aucun message pour l\'instant',
    'failed_to_load_notification_log': 'Échec du chargement du journal de notification',
    'no_notifications_found': 'Aucune notification trouvée',
    'channel': 'Chaîne',
    'recipient': 'Destinataire',
    'flat_amount': 'Montant forfaitaire',
    'org_settings_desc': 'Description des paramètres de l\'organisation',
    'late_fee_configuration': 'Configuration des frais de retard',
    'enabled': 'Activé',
    'disabled': 'Désactivé',
    'legal_note_late_fees': 'Mentions légales Frais de retard',
    'grace_period_days': 'Jours de grâce',
    'fee_type': 'Type de frais',
    'percent_of_rent': 'Pourcentage du loyer',
    'late_fee_summary': 'Récapitulatif des frais de retard',
    'applied_after': 'Appliqué après',
    'discount_rent': 'Loyer réduit',
    'lease_start': 'Début du bail',
    'lease_end': 'Fin du bail',
    'next_bill': 'Prochaine facture',
    'no_units_found': 'Aucune unité trouvée',
    'csv_download_failed': 'Échec du téléchargement CSV',
    'all_1099_downloaded': 'Tous les 1099 téléchargés',
    'no_reportable_owners': 'Aucun propriétaire à signaler',
    'pdf_download_failed': 'Échec du téléchargement du PDF',
    'pdf_generation_failed': 'Échec de la génération du PDF',
    'generating_pdfs': 'Générer des PDF',
    'download_all_pdfs': 'Télécharger tous les PDF',
    'important': 'Important',
    'irs_1099_disclaimer': 'Irs 1099 Avis de non-responsabilité',
    'owner_payment_summary': 'Récapitulatif des paiements du propriétaire',
    'irs_threshold': 'Seuil Irs',
    'total_paid': 'Total payé',
    'form': 'Formulaire',
    'file_form': 'Formulaire de fichier',
    'no_owner_payments_found': 'Aucun paiement de propriétaire trouvé',
    'no_deposits_found': 'Aucun dépôt trouvé',
    'deposit_amount': 'Montant du dépôt',
    'deductions': 'Déductions',
    'error_loading_showing': 'Erreur de chargement Affichage',
    'required_fields_error': 'Erreur de champs obligatoires',
    'showing_updated': 'Affichage mis à jour',
    'showing_scheduled': 'Affichage programmé',
    'time_conflict_error': 'Erreur de conflit d\'heure',
    'choose_unit': 'Choisir l\'unité',
    'agent_name_placeholder': 'Espace réservé pour le nom de l\'agent',
    'schedule': 'Calendrier',
    'error_loading_showings': 'Erreur lors du chargement des présentations',
    'marked_as': 'Marqué comme',
    'update_failed': 'Échec de la mise à jour',
    'delete_failed': 'Échec de la suppression',
    'mark_completed': 'Marquer comme terminé',
    'mark_no_show': 'Marquer une non-présentation',
    'confirm_delete': 'Confirmer la suppression',
    'confirm_delete_showing': 'Confirmer la suppression de l\'affichage',
    'error_loading_surveys': 'Erreur de chargement des enquêtes',
    'from_responses': 'À partir des réponses',
    'no_data_yet': 'Aucune donnée pour l\'instant',
    'utility_type_required': 'Type d\'utilitaire requis',
    'failed_to_create_account': 'Échec de la création du compte',
    'select_tenant_error': 'Sélectionnez une erreur de locataire',
    'please_fix_errors': 'Veuillez corriger les erreurs',
    'bill_issued_successfully': 'Facture émise avec succès',
    'failed_to_issue_bill': 'Échec de l\'émission de la facture',
    'download_csv': 'Télécharger le CSV',
    'vendor_1099_disclaimer': 'Avis de non-responsabilité du fournisseur 1099',
    'vendor': 'Vendeur',
    'first_payment': 'Premier paiement',
    'last_payment': 'Dernier paiement',
    'no_vendor_payments_recorded': 'Aucun paiement fournisseur enregistré',
    'ok_200': 'D\'accord 200',
    'failed_load_webhooks': 'Échec du chargement des webhooks',
    'failed_load_deliveries': 'Échec des livraisons de chargement',
    'failed_update': 'Échec de la mise à jour',
    'delete_webhook_confirm': 'Confirmer la suppression du webhook',
    'failed_delete': 'Échec de la suppression',
    'rotate_secret_confirm': 'Confirmer le secret de rotation',
    'secret_rotated': 'Secret tourné',
    'failed_rotate': 'Échec de la rotation',
    'copied_to_clipboard': 'Copié dans le presse-papiers',
    'add_endpoint': 'Ajouter un point de terminaison',
    'no_webhooks_yet': 'Pas encore de webhooks',
    'no_webhooks_desc': 'Aucune description de Webhooks',
    'failures': 'Échecs',
    'disable': 'Désactiver',
    'enable': 'Activer',
    'rotate_secret': 'Rotation secrète',
    'no_deliveries_yet': 'Aucune livraison pour l\'instant',
    'event': 'Événement',
    'http': 'Http',
    'account_deactivated': 'Compte désactivé',
    'server_no_response': 'Serveur Aucune réponse',
    'logging_in': 'Connexion',
    'company_name_required': 'Nom de l\'entreprise requis',
    'registration_failed': 'Échec de l\'inscription',
    'enter_company_name': 'Entrez le nom de l\'entreprise',
    'fully_signed_active': 'Actif entièrement signé',
    'pending_owner_signature': 'En attente de signature du propriétaire',
    'pending_admin_signature': 'En attente de signature de l\'administrateur',
    'terminated': 'Terminé',
    'back_to_contracts': 'Retour aux contrats',
    'contract_terms': 'Conditions du contrat',
    'payment_schedule': 'Calendrier de paiement',
    'no_installments_defined': 'Aucun versement défini',
    'signed_by': 'Signé par',
    'awaiting_admin_review': 'En attente d\'examen par l\'administrateur',
    'sign_contract': 'Signer le contrat',
    'past': 'Passé',
    'tenant_signin_success': 'Connexion réussie du locataire',

    // Auto-added mass translations from ESLint Codemod
    '10': '10/',
    '12': '/ 12',
    '16': '−16%',
    '25': '25 /',
    '50': '50 /',
    '100': '100 /',
    '600': ': 600$',
    'ai_assistant_pro_only': 'Assistant IA – Pro uniquement',
    'ask_questions_about_your_portfolio_in_pl': 'Posez des questions sur votre portfolio dans un anglais simple. Obtenez des réponses instantanées sur les revenus, les paiements en retard, les postes vacants et bien plus encore.',
    'upgrade_to_pro': 'Passer à Pro',
    'here_s_what_s_happening_across_your_port': 'Voici ce qui se passe aujourd’hui dans votre portefeuille.',
    'portfolio_risk': 'Risque de portefeuille',
    'pro_only': 'Professionnel uniquement',
    'pending_collections': 'Collections en attente',
    'ask_ai_assistant': 'Demandez à l\'Assistant IA',
    'unlock_ai_assistant_upgrade_to_pro': 'Déverrouillez AI Assistant – Mettez à niveau vers Pro',
    'download': 'Télécharger',
    'd': 'ré',
    'view_details_1': 'Afficher les détails',
    'export_data': 'Exporter des données',
    'refresh_data': 'Actualiser les données',
    'property_pulse': 'Impulsion immobilière',
    'cash_flow_analysis_for_the_current_fisca': 'Analyse des flux de trésorerie de l\'exercice en cours',
    'yearly_report': 'Rapport annuel',
    'analytics_pro_required': 'Analytics Pro requis',
    'unlock_deep_financial_insights_and_custo': 'Bénéficiez d’informations financières approfondies et de rapports de prévision personnalisés.',
    'upgrade_now': 'Mettre à niveau maintenant',
    'items_requiring_immediate_follow_up': 'Articles nécessitant un suivi immédiat',
    'activity_log': 'Journal d\'activité',
    'view_history': 'Afficher l\'historique',
    'no_recent_logs_found': 'Aucun journal récent trouvé',
    'active_issues': 'Problèmes actifs',
    'pro': 'Pro',
    'pro_1': 'Pro',
    'sell_unit': 'Vendre l\'unité',
    'floor_1': 'Sol',
    'size_1': 'Taille',
    'm': 'm²',
    'amenities': 'Commodités',
    'last_updated_today': 'Dernière mise à jour : Aujourd\'hui',
    'back_to_apartment': 'Retour à l\'appartement',
    'sell_unit_1': 'Vendre l\'unité',
    'floor_2': 'Sol',
    'select_buyer': 'Sélectionnez l\'acheteur',
    'existing_owner': 'Propriétaire existant',
    'new_buyer': 'Nouvel acheteur',
    'no_owners_found_switch_to_new_buyer_to_c': 'Aucun propriétaire trouvé : passez à "Nouvel acheteur" pour en créer un',
    'edit_1': 'Modifier',
    'the_buyer_will_be_created_as_an_owner_an': 'L\'acheteur sera créé en tant que propriétaire et lié automatiquement à cette vente.',
    'sale_terms': 'Conditions de vente',
    'total_sale_price': 'Prix de vente total *',
    'down_payment': 'Acompte',
    'annual_interest_rate': 'Taux d\'intérêt annuel (%)',
    'term_months': 'Durée (mois) *',
    'yrs': 'années)',
    'sale_start_date': 'Vente / Date de début *',
    'quick_preview': 'Aperçu rapide',
    'principal': 'Directeur',
    'down_payment_1': 'Acompte',
    'term': 'Durée',
    'months_1': 'mois',
    'amortization_schedule': 'Calendrier d\'amortissement',
    'confirm_sale': 'Confirmer la vente',
    'buyer': 'Acheteur',
    'floor_3': '— Sol',
    'financial_terms': 'Conditions financières',
    'draft_sale_contract': 'projet de contrat de vente',
    'will_be_created_the_apartment_will_be_ma': 'sera créé. L\'appartement sera marqué comme',
    'sold': 'Vendu',
    'only_after_both_you_and_the_buyer_digita': 'seulement après que vous et l’acheteur ayez signé numériquement le contrat.',
    'sale_finalized': 'Vente finalisée !',
    'the_sale_contract_for_unit': 'Le contrat de vente de l\'Unité',
    'has_been_created_use_the_links_below_to': 'a été créé. Utilisez les liens ci-dessous pour intégrer l\'acheteur.',
    'public_sign_link': 'Lien vers les panneaux publics',
    'p_sign_owner': '/p/sign/propriétaire/',
    'portal_invite_link': 'Lien d\'invitation au portail',
    'portal_setup_password_type_owner_id': '/portal/setup-password?type=owner&id=',
    'email_1': '&e-mail=',
    'token': '&jeton=',
    'view_owner': 'Afficher le propriétaire',
    'manage_contract': 'Gérer le contrat',
    '0_10': '(0-10,',
    'm_1': 'm²',
    'm_2': 'm²',
    'm_3': 'm²',
    'm_4': 'm²',
    'empty_key': '✕',
    'this_apartment_already_has': 'Cet appartement a déjà',
    'active_booking_s_for_these_dates': 'réservation(s) active(s) pour ces dates.',
    'levels': 'Niveaux',
    'cap': 'Casquette',
    'no_inventory_data': 'Aucune donnée d\'inventaire',
    'init_units': 'Unités d\'initialisation',
    'm_5': 'm²',
    'm_6': 'm²',
    'supports_markdown_placeholders_e_g': 'Prend en charge MarkDown et les espaces réservés, par ex.',
    'empty_key_1': '✓',
    'trial_ends_in': 'Le procès se termine dans',
    'days_subscribe': 'jours - Abonnez-vous',
    'new_lease_agreement': 'Nouveau contrat de location',
    'tenant_unit_assignment': 'Attribution des locataires et des unités',
    'please_select_a_building_first': 'Veuillez d\'abord sélectionner un bâtiment',
    'lease_terms_duration': 'Conditions et durée du bail',
    'lease_type': 'Type de bail',
    'fixed_term': 'Durée déterminée',
    'month_to_month': 'Mois après mois',
    'end_date_optional': 'Date de fin (facultatif)',
    'financial_obligations': 'Obligations financières',
    'empty_key_2': ') *',
    'notes_special_provisions': 'Notes / Dispositions particulières',
    'empty_key_3': ': #',
    'send_for_signature': 'Envoyer pour signature',
    'copy_sign_link': 'Copier le lien de signe',
    'download_contract_pdf': 'Télécharger le contrat PDF',
    'contract_summary': 'Résumé du contrat',
    'generated_from_template': 'Généré à partir du modèle :',
    'digitally_executed': 'Exécuté numériquement',
    'electronic_signatures': 'Signatures électroniques',
    'management_office': 'Bureau de gestion',
    'authorized_signature': 'Signature autorisée',
    'owner_landlord': 'Propriétaire / Bailleur',
    'email_2': 'Courriel :',
    'signed': 'Signé :',
    'ip': 'IP :',
    'reason_for_voiding': 'Raison de l\'annulation',
    'building_agreement_for': 'Contrat de construction pour',
    'contract_builder_rules': 'Règles du constructeur de contrat',
    'select_contract_template': 'Sélectionnez un modèle de contrat',
    'no_template_manual_mode': 'Aucun modèle (mode manuel)',
    'template_dynamic_variables': 'Variables dynamiques du modèle',
    'owner_default_commission': 'Commission par défaut du propriétaire :',
    'maintenance_threshold': 'Seuil de maintenance :',
    'unit_1': 'Unité',
    'sale_unit_purchase': 'Vente / Achat d\'unité',
    'fixed_maintenance_contract': 'Contrat de maintenance fixe',
    'lease_agreement': 'Contrat de location',
    'start_date_1': 'Date de début',
    'auto_generate_quarterly': 'Génération automatique trimestrielle',
    'add_custom_installment': 'Ajouter un versement personnalisé',
    'plan_total': 'Total du régime',
    'agreement': 'Accord',
    'copy_portal_link': 'Copier le lien du portail',
    'ledger': 'Grand livre',
    'empty_key_4': ') â†\'',
    'owner_documents': 'Documents du propriétaire',
    'add_document': 'Ajouter un document',
    'name_1': 'Nom *',
    'tax': 'Taxe',
    'file_url': 'URL du fichier *',
    'cancel_1': 'Annuler',
    'no_documents_yet': 'Aucun document pour l\'instant',
    '30_days': '(30 jours)',
    'view_1': 'Voir',
    'future_scheduled_installments': 'futurs versements programmés',
    'unit_2': ', Unité',
    'no_investment_data_available_add_purchas': 'Aucune donnée d\'investissement disponible. Ajoutez le prix d\'achat et la valeur actuelle des appartements pour voir les mesures.',
    'click_the_edit_icon_on_any_unit_to_updat': 'Cliquez sur l\'icône d\'édition de n\'importe quelle unité pour mettre à jour sa valeur marchande actuelle ou son prix d\'achat.',
    'unit_3': 'Unité',
    'unit_mo': '/unité/mois',
    'save_16_billed_annually': 'Économisez 16 % · facturé annuellement',
    'reason_for_rejection': 'Motif du refus',
    'of_1': 'de',
    'error_loading_receipt': 'Erreur lors du chargement du reçu',
    'go_back': 'Retourner',
    'receipt_not_found': 'Reçu introuvable',
    'the_requested_payment_receipt_could_not': 'Le reçu de paiement demandé est introuvable.',
    'go_back_1': 'Retourner',
    'payment_receipt': 'Reçu de paiement',
    'issue_date': 'Date d\'émission :',
    'from_1': 'De',
    'phone_1': 'Téléphone :',
    'to_1': 'À',
    'phone_2': 'Téléphone :',
    'amount_1': 'Montant',
    'notes_1': 'Remarques',
    'thank_you_for_your_payment': 'Merci pour votre paiement !',
    'this_receipt_was_generated_automatically': 'Ce reçu a été généré automatiquement.',
    'delete_template': 'Supprimer le modèle',
    'cancel_2': 'Annuler',
    'delete_1': 'Supprimer',
    'description_optional': 'Description (facultatif)',
    'report_type': 'Type de rapport',
    'choosing_a_report_type_shows_the_relevan': 'Le choix d\'un type de rapport affiche les filtres pertinents ci-dessous.',
    'saved_filters': 'Filtres enregistrés',
    'select_a_report_type_above_to_set_saved': 'Sélectionnez un type de rapport ci-dessus pour définir les valeurs de filtre enregistrées pour ce modèle.',
    'cancel_3': 'Annuler',
    'saved_filter': 'filtre enregistré',
    'saved_1': 'Enregistré',
    'favourites': 'Favoris',
    'all_templates': 'Tous les modèles',
    'load_template': 'Charger le modèle',
    'favourites_1': 'Favoris',
    'no_templates_for_this_report_type': 'Aucun modèle pour ce type de rapport',
    'saved_filter_1': 'filtre enregistré',
    'manage_apartment_sales_and_track_sold_un': 'Gérer les ventes d\'appartements et suivre les unités vendues',
    'apartments_1': 'appartements',
    'available': 'disponible',
    'sold_1': 'vendu',
    'sold_rate': '% taux vendu',
    'floor_4': 'Sol',
    'units_1': 'unités',
    'available_1': 'disponible',
    'sold_2': 'vendu',
    'unit_4': 'Unité',
    'owner_buyer': 'Propriétaire / Acheteur',
    'sale_price': 'Prix de vente',
    'sale_date': 'Date de vente',
    'sell_unit_2': 'Vendre l\'unité',
    'view_details_2': 'Afficher les détails',
    'print_1': 'Imprimer',
    'apartment_management_system': 'Système de gestion d\'appartement',
    'erbil_kurdistan_region_iraq': 'Erbil, Région du Kurdistan - Irak',
    'tel_xxx_xxxxxxxx': 'Tél : +XXX XXXXXXXXX',
    'receipt': 'Numéro de reçu :',
    'name_2': 'Nom :',
    'phone_3': 'Téléphone :',
    'building_1': 'Bâtiment :',
    'payment_details_1': 'Détails du paiement',
    'amount_2': 'Montant :',
    'payment_date_1': 'Date de paiement :',
    'period_1': 'Période :',
    'notes_2': 'Remarques',
    'thank_you_for_your_payment_1': 'Merci pour votre paiement !',
    'tenant_information_1': 'Informations sur le locataire',
    'name_3': 'Nom :',
    'phone_4': 'Téléphone :',
    'apartment_1': 'Appartement :',
    'building_2': 'Bâtiment :',
    'furnished_1': 'Meublé :',
    'at_12_00_pm': 'à 12h00',
    'monthly_rent_1': 'Loyer mensuel :',
    'insurance_1': 'Assurance :',
    'additional_notes': 'Notes complémentaires',
    'tenant_signature': 'Signature du locataire',
    'this_receipt_is_electronically_generated': 'Ce reçu est généré électroniquement et est valable sans signature.',
    'apartment_management_system_all_rights_r': 'Système de gestion d\'appartement. Tous droits réservés.',
    'lease_renewal_risk': 'Risque de renouvellement de bail',
    'expiring_in_30_days': 'Expiration dans 30 jours',
    'expiring_in_60_days': 'Expiration dans 60 jours',
    'expiring_in_90_days': 'Expiration dans 90 jours',
    'expiring_in_180_days': 'Expiration dans 180 jours',
    'all_risk_levels': 'Tous les niveaux de risque',
    'no_leases_matching_the_selected_filters': 'Aucun bail correspondant aux filtres sélectionnés.',
    'd_1': 'ré',
    'no_documents_uploaded_for_this_tenant': 'Aucun document téléchargé pour ce locataire.',
    'empty_key_5': '✓',
    'empty_key_6': '✕',
    'empty_key_7': '($) *',
    'ai_lease_reader': 'Lecteur de bail AI',
    'upload_a_lease_pdf_to_auto_fill_the_form': 'Téléchargez un PDF de bail pour remplir automatiquement le formulaire',
    'empty_key_8': '●',
    'empty_key_9': '✓',
    '10_1': '10/',
    '25_1': '25 /',
    '50_1': '50 /',
    '100_1': '100 /',
    'register_as_maintenance_provider_service': 'S\'inscrire en tant que fournisseur de maintenance (fournisseur de services)',
    'this_will_automatically_create_a_record': 'Cela créera automatiquement un enregistrement dans le Maintenance Hub afin que vous puissiez attribuer des bons de travail à cet utilisateur.',
    'assigned_buildings_portfolio': 'Bâtiments attribués (portefeuille)',
    'select_the_buildings_this_portfolio_mana': 'Sélectionnez les bâtiments auxquels ce Portfolio Manager peut accéder. Ils verront UNIQUEMENT les données de ces bâtiments.',
    'no_buildings_found_please_create_buildin': 'Aucun bâtiment trouvé. Veuillez d\'abord créer des bâtiments.',
    'building_3': 'bâtiment',
    'empty_key_10': '☀️',
    '1_315_333_7884': '+1 (315) 333-7884',
    'sent_sid': '✅Envoyé ! Numéro d\'identification :',
    'iraq_964_is_blocked_by_default_enable_it': '🌍 L\'Irak (+964) est bloqué par défaut. Activez-le :',
    'twilio_messaging_geo_permissions_iraq_on': 'Twilio → Messagerie → Autorisations géographiques → Irak → ON → Enregistrer',
    'trial_accounts_can_only_message': '🔒 Les comptes d\'essai ne peuvent envoyer que des messages',
    'verified_numbers': 'numéros vérifiés',
    'apt_1': '· Appt',
    'mo_1': '/mois',
    'mo_2': '/mois',
    'manage_building_amenities_unit_features': 'Gérer les commodités du bâtiment, les caractéristiques des unités et les places de stationnement',
    'all_buildings_1': 'Tous les bâtiments',
    'add_amenity': 'Ajouter un équipement',
    'no_building_amenities_found': 'Aucune commodité du bâtiment trouvée',
    'all_buildings_2': 'Tous les bâtiments',
    'all_units': 'Toutes les unités',
    'add_unit_amenity': 'Ajouter des équipements à l\'unité',
    'no_unit_amenities_found': 'Aucune commodité de l\'unité trouvée',

    'unit_amenities': 'Équipements de l\'unité',
    'col_monthly_fee': 'Frais mensuels',
    'col_available': 'Disponible',
    'all_buildings_3': 'Tous les bâtiments',
    'available_2': 'Disponible',
    'reserved': 'Réservé',
    'add_space': 'Ajouter de l\'espace',
    'no_parking_spaces_found': 'Aucune place de parking trouvée',
    'assign': 'Attribuer',
    'unassign': 'Annuler l\'attribution',
    'spaces': 'Espaces',
    'driveway_area': 'Zone d\'allée',
    'cancel_4': 'Annuler',
    'complete': 'Terminé',
    'confirm_1': 'Confirmer',
    'cancel_5': 'Annuler',
    'complete_1': 'Terminé',
    'assign_space': 'Attribuer un espace',
    'select_tenant_1': 'Sélectionner un locataire',
    'choose_tenant': '-- Choisissez le locataire --',
    'select_owner': 'Sélectionnez le propriétaire',
    'choose_owner': '-- Choisissez le propriétaire --',
    'cancel_6': 'Annuler',
    'assign_1': 'Attribuer',
    'new_amenity_booking': 'Réservation de nouveaux équipements',
    'amenity': 'Commodité *',
    'select_amenity': 'Sélectionnez l\'équipement…',
    'tenant_1': 'Locataire *',
    'select_tenant_2': 'Sélectionnez le locataire…',
    'date_1': 'Date*',
    'notes_3': 'Remarques',
    'cancel_7': 'Annuler',
    'deactivated': 'Désactivé',
    'max_uses': 'Utilisations maximales',
    'generate_application_link': 'Générer un lien d\'application',
    'building_4': 'Bâtiment *',
    'specific_unit_optional': 'Unité spécifique (en option)',
    'any_unit_in_building': 'Toute unité dans le bâtiment',
    'unit_5': 'Unité',
    'floor_5': '– Sol',
    'label': 'Étiquette',
    'expires_at': 'Expire à',
    'max_uses_1': 'Utilisations maximales',
    'cancel_8': 'Annuler',
    'label_unit': 'Étiquette / Unité',
    'token_url': 'URL du jeton',
    'uses': 'Utilisations',
    'status_1': 'Statut',
    'no_links_yet_click_generate_link_to_crea': 'Pas encore de liens. Cliquez sur "Générer un lien" pour en créer un.',
    'link_generated': 'Lien généré !',
    'failed_to_generate_link': 'Échec de la génération du lien',
    'failed_to_load_links': 'Échec du chargement des liens',
    'link_deactivated': 'Lien désactivé',
    'search_label_building_token': 'Rechercher par étiquette, bâtiment ou jeton…',
    'links_count': '{{count}} lien(s)',
    'untitled': 'Sans titre',
    'open_form': 'Ouvrir le formulaire',
    'no_links_match_filters': 'Aucun lien ne correspond à vos filtres.',
    'unit_6': '· Unité',
    '1_30': '1 à 30',
    '31_60': '31-60',
    '61_90': '61-90',
    'building_amenity': 'Équipement du bâtiment',
    'amenity_details': 'Détails des commodités',
    'building_5': 'Bâtiment *',
    'name_4': 'Nom *',
    'category_1': 'Catégorie',
    'monthly_fee': 'Frais mensuels ($)',
    'operating_hours': 'Heures d\'ouverture',
    'capacity': 'Capacité',
    'description_1': 'Descriptif',
    'notes_4': 'Remarques',
    'available_for_booking': 'Disponible à la réservation',
    'cancel_9': 'Annuler',
    'saving_1': 'Sauvegarde…',
    'bulk_tenant_import': 'Importation groupée de locataires',
    'import_tenants_from_a_csv_file_apartment': 'Importer des locataires à partir d\'un fichier CSV — les appartements sont associés par nom du bâtiment + numéro d\'unité',
    'download_csv_template': 'Télécharger le modèle CSV',
    'use_this_template_to_format_your_data_co': 'Utilisez ce modèle pour formater correctement vos données',
    'template': 'Modèle',
    'required_columns': 'Colonnes obligatoires',
    'optional_columns': 'Colonnes facultatives',
    'payment_date_2': 'date_paiement',
    'day_of_month_1_31': '= jour du mois (1–31) ·',
    'contract_start_contract_end': 'contrat_début / contrat_end',
    'yyyy_mm_dd': '= AAAA-MM-JJ ·',
    'en_ar_fr_de_it_sp': '= en, ar, fr, de, it, sp',
    'parsing_csv': 'Analyse CSV…',
    'or_click_to_browse_max_2_mb': 'ou cliquez pour parcourir — max 2 Mo',
    'import_preview': 'Aperçu de l\'importation',
    'rows_found_review_before_importing': 'lignes trouvées – examiner avant d\'importer',
    'start_over': 'Recommencer',
    'name_5': 'Nom',
    'phone_5': 'Téléphone',
    'building_unit': 'Bâtiment / Unité',
    'contract_1': 'Contrat',
    'status_2': 'Statut',
    'empty_key_11': '· #',
    'ready_to_import': 'Prêt à importer',
    'tenant_2': 'locataire',
    'row': 'rangée',
    'with_errors_will_be_skipped': 'avec des erreurs seront ignorés',
    'no_valid_rows_to_import': 'Aucune ligne valide à importer',
    'fix_the_errors_in_your_csv_and_try_again': 'Corrigez les erreurs dans votre CSV et réessayez',
    'upload_new_file': 'Télécharger un nouveau fichier',
    'import_complete': 'Importation terminée',
    'tenants_successfully_imported': 'Locataires importés avec succès',
    'row_1': 'rangée',
    'skipped_rows': 'Lignes ignorées',
    'row_2': 'Rangée',
    'import_another_file': 'Importer un autre fichier',
    'view_tenants': 'Voir les locataires',
    'upload_document': 'Télécharger un document',
    'tenant_3': 'Locataire *',
    'select_tenant_3': 'Sélectionnez le locataire…',
    'document_name': 'Nom du document *',
    'category_2': 'Catégorie',
    'file_pdf_image_word_max_5mb': 'Fichier * (PDF, Image, Word — max 5 Mo)',
    'upload_document_1': 'Télécharger un document',
    'document_management': 'Gestion des documents',
    'document': 'documents',
    'across_all_tenants': 'chez tous les locataires',
    'upload': 'Télécharger',
    'all_categories': 'Toutes les catégories',
    'document_1': 'Documenter',
    'tenant_4': 'Locataire',
    'category_3': 'Catégorie',
    'status_3': 'Statut',
    'uploaded': 'Téléchargé',
    'actions_1': 'Actions',
    'no_documents_found': 'Aucun document trouvé',
    'of_2': 'de',
    'prev': 'Précédent',
    'next_1': 'Suivant',
    'select_tenant_required': 'Sélectionner un locataire',
    'document_name_required': 'Le nom du document est obligatoire',
    'select_file_required': 'Veuillez sélectionner un fichier',
    'document_uploaded': 'Document téléversé',
    'upload_failed': 'Téléversement échoué',
    'failed_to_load_documents': 'Impossible de charger les documents',
    'document_status_updated': 'Statut du document mis à jour',
    'failed_to_update_status': 'Impossible de mettre à jour le statut',
    'confirm_delete_doc': 'Supprimer « {{name}} » ? Cette action peut être annulée par un administrateur.',
    'failed_to_delete_document': 'Suppression échouée',
    'documents_count': '{{count}} document(s)',
    'search_by_tenant_name': 'Rechercher par nom de locataire…',
    'doc_results_count': '{{count}} résultat(s)',
    'uploaded_from': 'Téléversé du',
    'uploaded_to': "Téléversé jusqu'au",
    'doc_cat_id': "Pièce d'identité",
    'doc_cat_contract': 'Contrat',
    'doc_cat_financial': 'Financier',
    'doc_cat_insurance': 'Assurance',
    'doc_cat_other': 'Autre',
    'approved': 'Approuvé',
    'file_1': 'Fichier',
    'open_eviction_case': 'Dossier d\'expulsion ouvert',
    'tenant_5': 'Locataire',
    'tenant_6': 'Locataire *',
    'building_apartment_auto_filled_from_tena': 'Bâtiment et appartement remplis automatiquement à partir du dossier du locataire',
    'case_details': 'Détails du cas',
    'reason': 'Raison *',
    'notice_type': 'Type d\'avis',
    'cancel_10': 'Annuler',
    'open_case': 'Cas ouvert',
    'eviction_management': 'Gestion des expulsions',
    'track_and_manage_eviction_cases_from_not': 'Suivre et gérer les cas d\'expulsion depuis la notification jusqu\'à l\'achèvement',
    'new_case': 'Nouveau cas',
    'pipeline': 'Pipeline',
    'no_eviction_cases_found': 'Aucun cas d\'expulsion trouvé',
    'advance': 'Avancer →',
    'eviction_case': 'Numéro de cas d\'expulsion',
    'tenant_7': 'Locataire',
    'unit_7': '· Numéro d\'unité',
    'reason_1': 'Raison',
    'amount_owed_1': 'Montant dû',
    'pipeline_status': 'État du pipeline',
    'notes_5': 'Remarques',
    'expense_details': 'Détails des dépenses',
    'payment_info': 'Informations de paiement',
    'description_2': 'Descriptif',
    'no_accounts_posted_yet': 'Aucun compte publié pour l\'instant.',
    'total_1': 'Total',
    'assets': 'Actifs',
    'liabilities': 'Passif',
    'select_a_date_and_click_run_to_generate': 'Sélectionnez une date et cliquez sur Exécuter pour générer le bilan.',
    'from_2': 'De',
    'to_2': 'À',
    'run_1': 'Courir',
    'operating_activities': 'Activités opérationnelles',
    'net_operating_cash_flow': 'Flux de trésorerie net d\'exploitation',
    'financing_activities': 'Activités de financement',
    'net_financing_cash_flow': 'Flux de trésorerie net de financement',
    'net_change_in_cash': 'Variation nette de la trésorerie',
    'select_a_date_range_and_click_run': 'Sélectionnez une plage de dates et cliquez sur Exécuter.',
    'balance_sheet': 'Bilan',
    'cash_flow_statement': 'Flux de trésorerie',
    'total_assets': 'Total des actifs',
    'total_liabilities': 'Total des passifs',
    'total_equity': 'Total des capitaux propres',
    'bs_balanced_msg': '✓ Équilibré — Actifs = Passifs + Capitaux propres',
    'bs_unbalanced_msg': '⚠ Déséquilibré — vérifiez les écritures de journal',
    'operating_cash_flow': 'Flux de trésorerie opérationnel',
    'financing_cash_flow': 'Flux de trésorerie de financement',
    'edit_expense': 'Modifier la dépense',
    'expense_updated': 'Dépense mise à jour',
    'rated': 'noté',
    'property_inspections': 'Inspections de propriété',
    'move_in_move_out_periodic_20_item_standa': 'Emménagement · Déménagement · Périodique · Liste de contrôle standardisée de 20 éléments',
    'new_inspection': 'Nouvelle inspection',
    'no_inspections_found': 'Aucune inspection trouvée.',
    'adjust_the_filters_or_create_a_new_inspe': 'Ajustez les filtres ou créez une nouvelle inspection.',
    'showing_1': 'Affichage',
    'of_3': 'de',
    'new_inspection_1': 'Nouvelle inspection',
    'apartment_2': 'Appartement',
    'nothing_found': 'Rien trouvé.',
    'unit_8': '— Unité',
    'no_active_tenant_on_this_unit': 'Aucun locataire actif sur cette unité.',
    'tenant_8': 'Locataire',
    'no_tenant_vacant': 'Aucun locataire (vacant)',
    'inspection_type': 'Type d\'inspection',
    'overall_condition': 'État général',
    'a_20_item_standardized_checklist_entranc': 'Une liste de contrôle standardisée de 20 éléments (Entrée, Salon, Cuisine, Salle de bain, Chambre, Général) sera automatiquement créée.',
    'cancel_11': 'Annuler',
    'creating': 'Création…',
    'create_inspection': 'Créer une inspection',
    'unit_9': '· Unité',
    'tenant_9': 'Locataire :',
    'inspector': 'Inspecteur :',
    'print_2': 'Imprimer',
    'checklist_completion': 'Achèvement de la liste de contrôle',
    'overall': 'Dans l\'ensemble :',
    'click_a_condition_button_to_rate_each_it': 'Cliquez sur un bouton de condition pour évaluer chaque élément. Les notes sont enregistrées automatiquement sur le flou.',
    'general_notes_1': 'Remarques générales',
    'close_1': 'Fermer',
    'completing': 'Compléter…',
    'mark_as_completed': 'Marquer comme terminé',
    'close_2': 'Fermer',
    'signing': 'Signature…',
    'sign_inspection': 'Inspection des panneaux',
    'signing_is_final_and_cannot_be_undone': 'La signature est définitive et ne peut être annulée.',
    'covered_entity': 'Entité couverte',
    'select': 'Sélectionnez',
    'policy_details': 'Détails de la politique',
    'insurer_name': 'Nom de l\'assureur *',
    'start_date_2': 'Date de début',
    'notes_6': 'Remarques',
    'cancel_12': 'Annuler',
    'manage_tenant_owner_and_building_insuran': 'Gérer les polices d\'assurance des locataires, des propriétaires et des immeubles',
    'empty_key_12': '✓',
    'new_lease_application': 'Demande de nouveau bail',
    'applicant_information': 'Informations sur le candidat',
    'full_name_1': 'Nom complet *',
    'email_3': 'Courriel',
    'phone_6': 'Téléphone',
    'date_of_birth': 'Date de naissance',
    'current_address': 'Adresse actuelle',
    'employment': 'Emploi',
    'employment_status': 'Statut d\'emploi',
    'monthly_income': 'Revenu mensuel ($)',
    'employer_name': 'Nom de l\'employeur',
    'employer_phone': 'Téléphone de l\'employeur',
    'unit_preferences': 'Préférences d\'unité',
    'building_6': 'Bâtiment',
    'unit_10': 'Unité',
    'desired_move_in': 'Emménagement souhaité',
    'desired_lease_months': 'Bail souhaité (mois)',
    'has_pets': 'A des animaux de compagnie',
    'pet_details': 'Détails de l\'animal',
    'notes_7': 'Remarques',
    'cancel_13': 'Annuler',
    'submit_application': 'Soumettre la candidature',
    'review_and_approve_prospective_tenant_ap': 'Examiner et approuver les demandes de locataires potentiels',
    'all_buildings_4': 'Tous les bâtiments',
    'no_applications_found': 'Aucune application trouvée',
    'showing_2': 'Affichage',
    'of_4': 'de',
    'prev_1': 'Précédent',
    'next_2': 'Suivant',
    'close_3': 'Fermer',
    'unit_11': '· Numéro d\'unité',
    'monthly_rent_2': 'Loyer mensuel *',
    'discount_1': 'Remise',
    'contract_start_1': 'Début du contrat *',
    'contract_end_1': 'Fin du contrat *',
    'payment_day_of_month': 'Jour du mois de paiement *',
    'application': 'Demande',
    'rejection_reason': 'Motif du rejet',
    'cancel_14': 'Annuler',
    'app_search_placeholder': 'Rechercher par nom, e-mail, téléphone…',
    'app_status_submitted': 'Soumis',
    'app_status_under_review': 'En cours d\'examen',
    'app_status_approved': 'Approuvé',
    'app_status_rejected': 'Rejeté',
    'app_status_waitlisted': 'Liste d\'attente',
    'app_status_withdrawn': 'Retiré',
    'app_status_converted': 'Converti',
    'sort_newest': 'Plus récent d\'abord',
    'sort_movein_asc': 'Emménagement ↑ Plus tôt',
    'sort_movein_desc': 'Emménagement ↓ Plus tard',
    'sort_income_asc': 'Revenu ↑ Le plus bas',
    'sort_income_desc': 'Revenu ↓ Le plus élevé',
    'all_employment': 'Tous types d\'emploi',
    'emp_other': 'Autre',
    'move_in_from': 'Emménagement du',
    'move_in_to': 'Emménagement au',
    'application_results_count': '{{count}} candidature(s)',
    'failed_to_load_lease_applications': 'Échec du chargement des candidatures',
    'status_updated_to': 'Statut mis à jour : {{status}}',
    'rent_dates_payment_required': 'Loyer, dates de début/fin et jour de paiement requis',
    'converted_to_tenant_success': 'Converti en locataire',
    'conversion_failed': 'Échec de la conversion',
    'lease_duration_months_label': 'Durée du bail',
    'lease_duration_months': '{{n}} mois',
    'details_not_provided': 'détails non fournis',
    'reviewed_by': 'Examiné par',
    'reviewed_at': 'Examiné le',
    'converting': 'Conversion en cours…',
    'applicant_name_required': 'Le nom du candidat est requis',
    'failed_to_submit_application': 'Échec de la soumission de la candidature',
    'submitting': 'Envoi en cours…',
    'update_failed': 'Mise à jour échouée',
    'nightly_scan_flags_leases_expiring_in_90': 'Une analyse nocturne signale les baux expirant dans 90 jours : des brouillons d\'offres sont créés automatiquement et vous les envoyez en un seul clic.',
    'send_all_drafts': 'Envoyer tous les brouillons (',
    'expiring_within_90_days': 'expirant dans les 90 jours',
    'without_an_offer_yet': 'sans offre pour le moment',
    'd_2': 'ré',
    'offer_sent': 'offre envoyée',
    'no_offer': 'aucune offre',
    'all_statuses_1': 'Tous les statuts',
    'no_renewals_found': 'Aucun renouvellement trouvé',
    'd_left': 'je suis parti',
    'convert_lease': 'Convertir le bail',
    'counter_offer': 'Contre-offre',
    'tenant_10': 'Locataire :',
    'counter_rent_amount': 'Montant du loyer au comptoir *',
    'cancel_15': 'Annuler',
    'send_counter': 'Envoyer le compteur',
    'error_loading_renewals': 'Impossible de charger les renouvellements',
    'offer_sent_2': 'Offre envoyée',
    'error_sending_offer': "Impossible d'envoyer l'offre",
    'renewal_accepted': 'Renouvellement accepté',
    'error_accepting_renewal': "Impossible d'accepter le renouvellement",
    'decline_renewal_title': 'Refuser le renouvellement',
    'decline_renewal_msg': 'Êtes-vous sûr de vouloir refuser cette offre de renouvellement ?',
    'renewal_declined': 'Renouvellement refusé',
    'error_declining_renewal': 'Impossible de refuser le renouvellement',
    'lease_converted_msg': 'Bail converti — enregistrement du locataire mis à jour !',
    'error_converting_renewal': 'Impossible de convertir le renouvellement',
    'drafts_created': "{{count}} brouillon(s) d'offre créé(s) !",
    'no_new_drafts_needed': 'Aucun nouveau brouillon nécessaire — tous les baux expirants ont déjà des offres.',
    'error_generating_drafts': 'Impossible de générer les brouillons',
    'no_draft_renewals_to_send': 'Aucun renouvellement en brouillon à envoyer',
    'send_all_draft_offers_title': 'Envoyer toutes les offres en brouillon',
    'send_all_draft_offers_msg': 'Envoyer des offres de renouvellement à tous les {{count}} locataires en brouillon (e-mail + WhatsApp) ?',
    'offers_sent': '{{count}} offre(s) envoyée(s) !{{failed}}',
    'error_sending_offers': "Impossible d'envoyer les offres",
    'counter_offer_sent': 'Contre-offre envoyée',
    'error_sending_counter': "Impossible d'envoyer la contre-offre",
    'search_tenant_unit_building': 'Rechercher locataire, unité, bâtiment…',
    'all_risk': 'Tous les risques',
    'risk_low': 'Risque faible',
    'risk_medium': 'Risque moyen',
    'risk_high': 'Risque élevé',
    'renewals_count': '{{count}} renouvellement(s)',
    'leases_expiring_90d': '{{count}} bail(-aux) expirant dans 90 jours',
    'viewed_1': 'Consulté',
    'accepted_1': 'Accepté',
    'counter_offered': 'Contre-offre',
    'declined_1': 'Refusé',
    'full_lease_lifecycle_create_renew_termin': 'Cycle de vie complet du bail : création, renouvellement, résiliation, historique',
    'new_lease': 'Nouveau bail',
    'all_status_1': 'Tous les statuts',
    'active_1': 'Actif',
    'expired_1': 'Expiré',
    'renewed': 'Renouvelé',
    'all_buildings_5': 'Tous les bâtiments',
    'no_leases_found': 'Aucun bail trouvé',
    'expired_2': 'Expiré',
    'd_left_1': 'je suis parti',
    'd_left_2': 'je suis parti',
    'd_3': 'ré',
    'renew': 'Renouveler',
    'terminate': 'Terminer',
    'terminate_lease': 'Résilier le bail',
    'this_action_cannot_be_undone_the_lease_w': 'Cette action ne peut pas être annulée. Le bail sera définitivement résilié.',
    'cancel_16': 'Annuler',
    'empty_key_13': '— #',
    'new_start_date': 'Nouvelle date de début *',
    'monthly_rent_3': 'Loyer mensuel ($) *',
    'lease_type_1': 'Type de bail',
    'fixed_term_1': 'Durée déterminée',
    'month_to_month_1': 'Mois après mois',
    'annual_1': 'Annuel',
    'renew_lease_1': 'Renouveler le bail',
    'cancel_17': 'Annuler',
    'expiry_days': '{{days}}j',
    'leases_expiring_within_60d': '{{count}} bail(s) expirant dans 60 jours',
    'sort_default': 'Tri : Défaut',
    'sort_expiry_asc': 'Expiration ↑ Plus tôt',
    'sort_expiry_desc': 'Expiration ↓ Plus tard',
    'sort_rent_asc': 'Loyer ↑ Le plus bas',
    'sort_rent_desc': 'Loyer ↓ Le plus élevé',
    'sort_name_asc': 'Locataire A → Z',
    'expiring_within': 'Expire dans',
    'any_expiry': 'Toute expiration',
    'days_lte': '≤ {{n}} jours',
    'create_tenant_for_lease': 'Ajoutez un locataire pour générer automatiquement un enregistrement de bail.',
    'terminating': 'Résiliation en cours…',
    'enter_termination_reason': 'Entrez la raison de la résiliation…',
    'failed_to_load_leases': 'Échec du chargement des baux',
    'renewal_failed': 'Échec du renouvellement',
    'terminate_failed': 'Échec de la résiliation',
    'start_date_and_rent_required': 'La date de début et le loyer mensuel sont requis',
    'lease_results_count': '{{count}} bail(s)',
    'description_3': 'Descriptif',
    'tenant_11': 'Locataire',
    'close_4': 'Fermer',
    'new_maintenance_schedule': 'Nouveau calendrier de maintenance',
    'schedule_details': 'Détails du calendrier',
    'building_7': 'Bâtiment',
    'all_buildings_6': 'Tous les bâtiments',
    'frequency': 'Fréquence *',
    'first_due_date': 'Première date d\'échéance *',
    'description_4': 'Descriptif',
    'cancel_18': 'Annuler',
    'create_schedule': 'Créer un calendrier',
    'maintenance_schedules': 'Calendriers d\'entretien',
    'preventive_maintenance_tracking': 'Suivi de maintenance préventive',
    'new_schedule': 'Nouvel horaire',
    'overdue_work_orders_will_be_auto_created': 'en retard – les bons de travail seront créés automatiquement ce soir',
    'no_schedules_found': 'Aucun horaire trouvé',
    'history': 'Histoire —',
    'no_history_yet': 'Pas encore d\'historique',
    'wo': 'AT #',
    'empty_key_14': '✓',
    'owner_ledger': 'Grand livre du propriétaire',
    'immutable_financial_history': '— histoire financière immuable',
    'refresh_1': 'Actualiser',
    'add_entry': 'Ajouter une entrée',
    'payouts': 'Paiements',
    'add_manual_ledger_entry': 'Ajouter une écriture comptable manuelle',
    'amount_3': 'Montant *',
    'description_5': 'Descriptif *',
    'cancel_19': 'Annuler',
    'showing_3': 'Affichage',
    'of_5': 'de',
    'prev_2': 'Précédent',
    'next_3': 'Suivant',
    'new_parking_space': 'Nouvelle place de stationnement',
    'creation_mode': 'Mode Création',
    'single_space': 'Espace unique',
    'bulk_generation': 'Génération en masse',
    'building_8': 'Bâtiment *',
    'select_building_1': 'Sélectionnez le bâtiment…',
    'prefix': 'Préfixe',
    'start_number': 'Numéro de départ *',
    'end_number': 'Numéro de fin *',
    'pad_with_zeros_e_g_01_02': 'Un tampon avec des zéros ? (par exemple 01, 02)',
    'space_number': 'Numéro d\'espace *',
    'level': 'Niveau',
    'type_1': 'Tapez',
    'monthly_fee_1': 'Frais mensuels ($)',
    'notes_8': 'Remarques',
    'cancel_20': 'Annuler',
    'saving_2': 'Sauvegarde…',
    'create_space': 'Créer de l\'espace',
    'tenant_screening': 'Sélection des locataires',
    'identity_verification_background_checks': 'Vérification d\'identité et vérification des antécédents',
    'unit_12': 'Unité',
    'select_a_tenant_to_view_or_start_their_s': 'Sélectionnez un locataire pour visualiser ou démarrer sa sélection',
    'final_decision': 'Décision finale',
    'set_on': 'Allumer',
    'identity_verification': 'Vérification d\'identité',
    'document_2': 'Documenter :',
    'name_6': 'Nom :',
    'start_identity_verification': 'Démarrer la vérification d\'identité',
    'link_was_shared_with_the_tenant_waiting': 'Le lien a été partagé avec le locataire – en attendant qu\'il le termine.',
    'background_check_checkr': 'Vérification des antécédents (Checkr)',
    'adjudication': 'Adjudication :',
    'checks': 'Chèques :',
    'start_background_check': 'Commencer la vérification des antécédents',
    'united_states': 'États-Unis',
    'canada': 'Canada',
    'fcra_consent_required': 'Consentement FCRA requis',
    'under_the_fair_credit_reporting_act_fcra': 'En vertu du Fair Credit Reporting Act (FCRA), vous devez obtenir le consentement écrit du demandeur avant d\'effectuer une vérification des antécédents. Le locataire recevra un e-mail de Checkr pour terminer le processus.',
    'i_confirm_the_applicant_has_provided_wri': 'Je confirme que le candidat a donné son consentement écrit pour cette vérification des antécédents.',
    'cancel_21': 'Annuler',
    'invitation_sent_waiting_for_the_applican': 'Invitation envoyée – en attente que le demandeur termine. Checkr le mettra à jour automatiquement.',
    'set_final_decision': 'Définir la décision finale',
    'final_screening_decision': 'Décision finale d\'examen préalable',
    'manual_review': 'Révision manuelle',
    'cancel_22': 'Annuler',
    'no_screening_started_for_this_tenant_yet': 'Aucune sélection n\'a encore commencé pour ce locataire.',
    'empty_key_15': '($) *',
    'prospect_information': 'Informations sur les prospects',
    'showing_details': 'Affichage des détails',
    'empty_key_16': '· #',
    'empty_key_17': '· #',
    'add_unit_amenity_1': 'Ajouter des équipements à l\'unité',
    'bulk_addition_mode': 'Mode d\'ajout en masse',
    'add_this_amenity_to_multiple_units_at_on': 'Ajoutez cet équipement à plusieurs unités à la fois',
    'amenity_details_1': 'Détails des commodités',
    'clear_all': 'Tout effacer',
    'nothing_found_1': 'Rien trouvé.',
    'amenity_name': 'Nom de l\'équipement *',
    'category_4': 'Catégorie',
    'condition': 'État',
    'notes_9': 'Remarques',
    'cancel_23': 'Annuler',
    'saving_3': 'Sauvegarde…',
    'add_amenity_1': 'Ajouter un équipement',
    'n_more': '+{{n}} de plus',
    'board_view': 'Vue tableau',
    'main_level': 'Niveau principal',
    'unassigned_1': 'Non attribué',
    'unit_cat_appliance': 'Appareil',
    'unit_cat_climate': 'Climatisation',
    'unit_cat_view': 'Vue',
    'unit_cat_layout': 'Agencement',
    'unit_cat_finish': 'Finition',
    'unit_cat_storage': 'Rangement',
    'unit_cat_connectivity': 'Connectivité',
    'unit_cat_safety': 'Sécurité',
    'unit_cat_other': 'Autre',
    'bld_cat_general': 'Général',
    'bld_cat_fitness': 'Fitness',
    'bld_cat_pool': 'Piscine',
    'bld_cat_common_area': 'Espace commun',
    'bld_cat_outdoor': 'Extérieur',
    'bld_cat_security': 'Sécurité',
    'bld_cat_business': 'Affaires',
    'bld_cat_parking': 'Parking',
    'bld_cat_pet': 'Animaux',
    'bld_cat_laundry': 'Laverie',
    'bld_cat_storage': 'Rangement',
    'all_fields_required': 'Tous les champs sont requis',
    'booking_failed': 'Échec de la réservation',
    'failed_to_load_amenity': "Impossible de charger l'équipement",
    'name_required': 'Le nom est requis',
    'amenity_updated': 'Équipement mis à jour',
    'amenity_added': 'Équipement ajouté',
    'open_time': 'Ouverture',
    'close_time': 'Fermeture',
    'max_occupancy': 'Capacité maximale',
    'edit_building_amenity': "Modifier l'équipement du bâtiment",
    'new_building_amenity': 'Nouvel équipement du bâtiment',
    'unit_required': "L'unité est requise",
    'at_least_one_unit_required': 'Au moins une unité est requise',
    'unit_amenity_updated': "Équipement de l'unité mis à jour",
    'amenity_bulk_added': 'Équipement ajouté à {{count}} unités',
    'selected_units_label': 'Unités sélectionnées *',
    'unit_searchable_label': 'Unité * (recherchable)',
    'search_add_multiple_units': 'Rechercher et ajouter plusieurs unités...',
    'search_unit_by_num': 'Rechercher une unité par n° ou bâtiment...',
    'cond_new': 'Neuf',
    'cond_excellent': 'Excellent',
    'cond_good': 'Bon',
    'cond_fair': 'Acceptable',
    'cond_needs_repair': 'À réparer',
    'meter_accounts_rubs_billing_and_per_tena': 'Comptes de compteurs, facturation RUBS et frais de services publics par locataire',
    'option_a_metered': 'Option A — Mesuré :',
    'add_account_record_reading_generate_bill': 'Ajouter un compte → enregistrer la lecture → générer des factures → facturer au grand livre',
    'option_c_rubs': 'Option B — RUBS :',
    'building_level_meter_split_equally_acros': 'Compteur au niveau du bâtiment réparti également entre tous les locataires actifs',
    'reading_recorded_for': 'Lecture enregistrée pour',
    'no_utility_accounts_yet_add_one_to_start': 'Aucun compte de services publics pour l\'instant — ajoutez-en un pour démarrer la facturation mesurée.',
    'no_readings': 'Aucune lecture',
    'shared': 'Partagé',
    'reading': 'Lecture',
    'all_statuses_2': 'Tous les statuts',
    'no_bills_yet_generate_from_meter_readings': 'Aucune facture pour l\'instant — ajoutez des comptes de compteur, enregistrez des relevés, puis générez des factures.',
    'accounts': 'Comptes',
    'bills': 'Factures',
    'benchmarking': 'Analyse comparative',
    'total_bills': 'Total des factures',
    'total_billed': 'Total facturé',
    'charge': 'Frais',
    'unit_13': 'Unité',
    'notes_10': 'Remarques',
    'cancel_24': 'Annuler',
    'loading_1': 'Chargement…',
    'accounts_tracked': 'comptes suivis',
    'monthly_consumption_last_6_months': 'Consommation mensuelle – 6 derniers mois',
    'monthly_cost': 'Coût mensuel ($)',
    'no_readings_recorded_yet_for': 'Aucune lecture enregistrée pour le moment',
    'valuation_details': 'Détails de l\'évaluation',
    'building_9': 'Bâtiment *',
    'market_value': 'Valeur marchande ($) *',
    'valuation_method': 'Méthode d\'évaluation',
    'notes_11': 'Remarques',
    'cancel_25': 'Annuler',
    'portal': 'Portail ✓',
    'invite_as_system_user_full_portal_access': 'Inviter en tant qu\'utilisateur système (accès complet au portail)',
    'this_will_create_a_staff_account_with_th': 'Cela créera un compte personnel avec le rôle de « fournisseur ». Ils recevront une invitation par e-mail pour définir leur mot de passe.',
    'record_violation': 'Violation du record',
    'tenant_unit': 'Locataire et unité',
    'tenant_12': 'Locataire *',
    'unit_14': '— Unité',
    'apartment_id': 'Numéro d\'identification de l\'appartement',
    'auto_filled': 'rempli automatiquement',
    'violation_details': 'Détails de la violation',
    'title_1': 'Titre *',
    'type_2': 'Tapez *',
    'severity': 'Gravité *',
    'incident_date': 'Date de l\'incident *',
    'fine_amount_optional': 'Montant de l\'amende (facultatif)',
    'description_6': 'Descriptif *',
    'if_a_fine_amount_is_entered_it_will_be_a': 'Si un montant d’amende est inscrit, il sera automatiquement imputé au grand livre des locataires.',
    'cancel_26': 'Annuler',
    'record_violation_1': 'Violation du record',
    'violations_notices': 'Violations et avis',
    'track_lease_violations_and_issue_formal': 'Suivre les violations de bail et émettre des avis juridiques formels',
    'new_violation': 'Nouvelle infraction',
    'how_it_works_1': 'Comment ça marche',
    'all_statuses_3': 'Tous les statuts',
    'notice': 'Avis',
    'resolve': 'Résoudre',
    'issue_legal_notice': 'Émettre un avis juridique',
    'cancel_27': 'Annuler',
    'add_webhook_endpoint': 'Ajouter un point de terminaison Webhook',
    'push_events_to_your_external_systems': 'Poussez les événements vers vos systèmes externes',
    'successfully_created': 'Création réussie !',
    'save_your_signing_secret_now_it_won_t_be': 'Enregistrez votre secret de signature maintenant : il ne sera plus affiché.',
    'copy_secret': 'Copier le secret',
    'done_return': 'Terminé et retour',
    'connection_details': 'Détails de connexion',
    'payload_url': 'URL de la charge utile',
    'description_7': 'Descriptif',
    'event_subscriptions': 'Abonnements aux événements',
    'you_can_always_add_more_events_later': 'Vous pourrez toujours ajouter d\'autres événements ultérieurement.',
    'register_endpoint': 'Enregistrer le point de terminaison',
    'cancel_28': 'Annuler',
    'assign_a_new_task_to_a_maintenance_provi': 'Attribuer une nouvelle tâche à un prestataire de maintenance',
    'work_order_details': 'Détails du bon de travail',
    'work_order_title': 'Titre du bon de travail',
    'task_description': 'Description de la tâche',
    'scheduling_reference': 'Planification et référence',
    'maintenance_request_id': 'ID de demande de maintenance',
    'assignment': 'Affectation',
    'select_a_maintenance_provider': 'Sélectionnez un prestataire de maintenance',
    'priority_level_level': 'Niveau de priorité Niveau',
    'dispatch_work_order': 'Ordre de travail d\'expédition',
    'discard_changes': 'Ignorer les modifications',
    'pro_tip': 'Conseil de pro',
    'dispatching_a_work_order_will_immediatel': 'L\'envoi d\'un bon de travail informera immédiatement le fournisseur via son portail et par e-mail si cette option est activée.',
    'update_work_order': 'Mettre à jour le bon de travail',
    'status_priority': 'Statut et priorité',
    'status_4': 'Statut',
    'completed_date': 'Date de fin',
    'invoice': 'Facture',
    'invoice_amount': 'Montant de la facture',
    'invoice_status': 'Statut de la facture',
    'cancel_29': 'Annuler',
    'vendor_work_order_management': 'Gestion des bons de travail des fournisseurs',
    'refresh_2': 'Actualiser',
    'new_work_order': 'Nouveau bon de travail',
    'all_statuses_4': 'Tous les statuts',
    'no_work_orders_found': 'Aucun bon de travail trouvé',
    'mr': 'M. :',
    'work_order': 'Numéro de bon de travail',
    'priority_1': 'priorité',
    'description_8': 'Descriptif',
    'linked_maintenance_request': 'Demande de maintenance liée',
    'unit_15': 'Unité',
    'invoice_1': 'Facture',
    'view_invoice_document': 'Afficher le document de facturation',
    'review_approve_invoice': 'Vérifier et approuver la facture',
    'edit_work_order': 'Modifier le bon de travail',
    'approve_invoice': 'Approuver la facture',
    'you_are_approving_a_vendor_invoice_of': 'Vous approuvez une facture fournisseur de',
    'for': 'pour',
    'charge_to_tenant_ledger': 'Facturation au grand livre du locataire',
    'the_cost_will_be_automatically_added_as': 'Le coût sera automatiquement ajouté au débit sur le grand livre du locataire pour que celui-ci puisse le payer.',
    'organization_absorbs_cost': 'L’organisation absorbe les coûts',
    'the_tenant_will_not_be_charged_this_crea': 'Le locataire ne sera pas facturé. Cela crée une entrée de comptes fournisseurs pour l\'organisation.',
    'cancel_30': 'Annuler',
    'loading_2': 'Chargement…',
    'page_not_found': 'Page introuvable',
    'the_page_you_re_looking_for_doesn_t_exis': 'La page que vous recherchez n\'existe pas.',
    'go_to_dashboard': 'Aller au tableau de bord',
    'clear_signature': 'Signature claire',
    'i_consent_to_use_electronic_signatures_a': 'J\'accepte d\'utiliser des signatures électroniques et j\'accepte que ma signature électronique',
    'cancel_31': 'est l\'équivalent légal de ma signature manuelle sur ce contrat. je comprends',
    'sign_contract_1': 'que j\'ai le droit de recevoir une copie papier de ce document.',
    'by_signing_this_document_electronically': 'Annuler',
    'subscription_locked': 'Signer le contrat',
    'your_subscription_status_is': 'En signant électroniquement ce document, vous reconnaissez que votre signature électronique',
    'please_renew_your_subscription_to_contin': 'est juridiquement contraignant et a le même effet qu’une signature manuscrite. Votre adresse IP',
    'payment_options': 'et l\'horodatage sera enregistré à des fins de vérification.',
    'please_contact_the_administrator_to_proc': 'Abonnement verrouillé',
    'contact_admin_to_renew': 'Le statut de votre abonnement est',
    'request_sent_pending_approval': '.',
    'need_help_contact_support_at_support_qua': 'Veuillez renouveler votre abonnement pour continuer à gérer vos propriétés.',
    'requires_the': 'Options de paiement',
    'pro_plan': 'Veuillez contacter l\'administrateur pour traiter votre paiement et réactiver votre abonnement.',
    'is_a_pro_feature': 'Contacter l\'administrateur pour renouveler',
    'upgrade_to_pro_to_unlock_ai_powered_inte': 'Demande envoyée ! En attente d\'approbation.',
    'upgrade_to_pro_1': 'Besoin d\'aide ? Contactez l\'assistance à support@quadcores.com',
    'starting_at_3_20_unit_month_no_minimum_u': 'nécessite le',
    'our_narrative': 'Forfait Pro',
    'reimagined': 'est une fonctionnalité Pro',
    'quadcores_properties_is_an_elite_operati': 'Passez à Pro pour débloquer l’intelligence basée sur l’IA sur l’ensemble de votre portefeuille.',
    'core_capabilities': 'Passer à Pro',
    'our_approach_to': 'À partir de 3,20 $ / unité / mois · Aucun minimum d\'unités requis',
    'operations': 'Notre récit',
    'we_believe_property_management_should_be': 'réinventé.',
    'whether_you_manage_10_units_or_10_000_qu': 'Quadcores Properties est une couche opérationnelle d\'élite pour le portefeuille immobilier moderne.',
    'complete_platform': 'Conçu pour l\'échelle, conçu pour la précision et conçu pour ceux qui sont sérieux.',
    'all_features': 'Toutes les fonctionnalités',
    '35_powerful_features_organized_into_7_co': '35 fonctionnalités puissantes organisées en 7 catégories complètes.',
    'link_unavailable': 'Lien indisponible',
    'application_submitted': 'Candidature soumise !',
    'your_application_has_been_received_our_t': 'Votre candidature a été reçue. Notre équipe l\'examinera et vous répondra bientôt.',
    'your_application_id': 'Votre identifiant de candidature',
    'successfully_registered': 'Inscrit avec succès',
    'track_application_status': 'Suivre l\'état de la demande',
    'rental_application': 'Demande de location',
    'unit_16': 'Unité',
    'applying_for': 'Faire une demande',
    'full_name_2': 'Nom complet *',
    'email_address': 'Adresse e-mail *',
    'national_id_passport': 'Carte d\'identité nationale/passeport',
    'date_of_birth_1': 'Date de naissance',
    'current_address_1': 'Adresse actuelle',
    'employment_income': 'Emploi et revenu',
    'employment_status_1': 'Statut d\'emploi',
    'employed': 'Employé',
    'self_employed': 'Travailleur indépendant',
    'retired': 'Retraité',
    'student': 'Étudiant',
    'unemployed': 'Au chômage',
    'monthly_income_1': 'Revenu mensuel',
    'employer_name_1': 'Nom de l\'employeur',
    'employer_phone_1': 'Téléphone de l\'employeur',
    'lease_preferences': 'Préférences de location',
    'desired_move_in_date': 'Date d\'emménagement souhaitée',
    'lease_duration_months': 'Durée du bail (mois)',
    'months_2': 'mois',
    'i_have_pets': 'j\'ai des animaux de compagnie',
    'emergency_contact': 'Contact d\'urgence',
    'name_7': 'Nom',
    'phone_7': 'Téléphone',
    'relation': 'Relation',
    'additional_notes_1': 'Notes complémentaires',
    'your_information_is_kept_private_and_use': 'Vos informations restent confidentielles et utilisées uniquement pour l’évaluation locative.',
    'track_application': 'Suivre la candidature',
    'ref_id': 'ID de référence : #',
    'verification_email': 'E-mail de vérification',
    'review': 'Examen',
    'approval': 'Approbation',
    'notice_from_the_team': 'Avis de l\'équipe',
    'applicant': 'Demandeur',
    'property_1': 'Propriété',
    'submitted_1': 'Soumis',
    'approved_for_lease': 'Approuvé pour la location',
    'next_steps_sign_lease': 'Prochaines étapes : signer le bail',
    'questions_contact': 'Des questions ? Contacter',
    'support': 'Assistance',
    'or_call_our_leasing_office': 'ou appelez notre bureau de location.',
    'verification_code': 'Code de vérification',
    'verify_code': 'Vérifier le code',
    'resend_code': 'Renvoyer le code',
    'back_to_login': 'Retour à la connexion',
    'invalid_link': 'Lien invalide',
    'go_to_login': 'Allez dans Connexion',
    'welcome_aboard': 'Bienvenue à bord !',
    'secure_onboarding': 'Intégration sécurisée',
    'welcome_to_the_quadcores_property_manage': 'Bienvenue sur le portail de gestion immobilière Quadcores. Terminons la configuration de votre compte interne.',
    'account_role': 'Rôle du compte',
    'email_address_1': 'Adresse e-mail',
    'set_your_password': 'Définissez votre mot de passe',
    'please_choose_a_secure_password_for_your': 'Veuillez choisir un mot de passe sécurisé pour votre compte.',
    'show_password': 'Afficher le mot de passe',
    'complete_account_setup': 'Terminer la configuration du compte',
    'password_requirement_minimum_8_character': 'Exigence de mot de passe : minimum 8 caractères. Nous vous recommandons d\'utiliser un mélange de lettres, de chiffres et de symboles pour une sécurité maximale.',
    'thank_you_for_your_subscription_your_acc': 'Merci pour votre abonnement. Votre compte a été mis à niveau.',
    'go_to_dashboard_1': 'Aller au tableau de bord',
    'back_to_home': 'Retour à la maison',
    'pricing_plans': 'Tarifs + Forfaits',
    'pay_for_what': 'Payer pour quoi',
    'you_actually_use': 'vous utilisez réellement.',
    'annual_2': 'Annuel',
    '16_1': '−16%',
    'per_unit_pricing_no_minimum_portfolio_si': 'Tarification à l\'unité. Pas de taille minimale de portefeuille. Annulez à tout moment.',
    'current_1': 'Actuel',
    'unit_17': '/unité',
    'from_3': 'de',
    'mo_3': '/mois',
    'minimum': 'minimum',
    '2_months_free_annual_billing': '2 mois gratuits · Facturation annuelle',
    'includes': 'Comprend',
    'enterprise_custom_contract': 'Entreprise / Contrat personnalisé',
    '10_000_units_custom_sla_dedicated_suppor': 'Plus de 10 000 unités, SLA personnalisé, support dédié, option sur site.',
    'talk_to_sales': 'Parlez aux ventes →',
    'feature_matrix': 'Matrice des fonctionnalités',
    'full_capability': 'Pleine capacité',
    'breakdown': 'panne.',
    'starter': 'Démarreur',
    'growth': 'Croissance',
    'pro_2': 'Pro',
    'no_minimum_units_no_setup_fees_enterpris': 'Pas d\'unités minimales. Aucun frais d\'installation. Sécurité de niveau entreprise sur chaque plan.',
    'legal': 'Juridique',
    'privacy': 'Confidentialité',
    'policy': 'Politique.',
    'we_are_committed_to_protecting_your_prof': 'Nous nous engageons à protéger vos données professionnelles et personnelles avec la même rigueur que nous appliquons aux opérations immobilières.',
    'principles': 'La transparence est notre fondement.',
    'section_0': 'Principes',
    'legal_and_compliance': 'SECTION 0',
    'inquiries': 'Juridique et conformité',
    'if_you_have_questions_about_how_we_handl': 'enquêtes.',
    'info_quadcores_com': 'Si vous avez des questions sur la manière dont nous traitons vos données ou si vous devez exercer vos droits en matière de confidentialité, veuillez contacter notre équipe de conformité.',
    'please_review_the_full_contract_terms_be': 'Nous sommes là pour assurer votre tranquillité d\'esprit.',
    'link_expired_or_invalid': 'info@quadcores.com',
    'we_couldn_t_find_the_contract_associated': 'Veuillez consulter les conditions complètes du contrat ci-dessous.',
    'your_signature_has_been_recorded_a_copy': 'Lien expiré ou invalide',
    'setup_your_portal': 'Nous n\'avons pas trouvé le contrat associé à ce lien. Veuillez contacter le bureau de gestion immobilière pour un nouveau lien de signature.',
    'access_your_payments_installments_and_do': 'Votre signature a été enregistrée. Une copie du contrat signé sera envoyée à votre adresse électronique sous peu.',
    'activate_my_account': 'Configurez votre portail',
    'go_to_dashboard_2': 'Accédez à vos paiements, versements et documents à tout moment en configurant votre compte de portail.',
    'id_1': 'Activer mon compte',
    'contract_signature_portal': 'Aller au tableau de bord',
    'review_sign': 'Identifiant : #',
    'hello': 'Portail de signature de contrat',
    'please_review_your_contract_details_for': 'Examiner et signer',
    'property_2': 'Bonjour',
    'contract_value': ', veuillez consulter les détails de votre contrat pour la propriété ci-dessous.',
    'timeline': 'Propriété',
    'to_3': 'Valeur du contrat',
    'legal_terms': 'Conditions juridiques',
    'en_ar': 'FR/AR',
    'legal_disclaimer': 'Mentions légales',
    'electronic_signatures_are_legally_equiva': 'Les signatures électroniques sont juridiquement équivalentes aux signatures manuscrites.',
    'your_ip_address_and_device_information_w': 'Votre adresse IP et les informations sur votre appareil seront enregistrées pour des raisons de sécurité.',
    'you_can_download_the_pdf_anytime_after_c': 'Vous pouvez télécharger le PDF à tout moment une fois terminé.',
    'ready_to_complete': 'Prêt à terminer ?',
    'continue_to_plans': 'Continuer vers les forfaits',
    'next_step': 'Étape suivante...',
    'complete_registration': 'Terminer l\'inscription',
    'verify_phone_number': 'Vérifiez votre numéro de téléphone',
    'verification_code_sent_to_phone': 'Code de vérification envoyé à votre téléphone. Veuillez le saisir ci-dessous.',
    'popular': 'Populaire',
    'mo_4': '/mois',
    'up_to': 'Jusqu\'à',
    'units_2': 'unités',
    'back_to_info': 'Retour aux informations',
    'verification_code_1': 'Code de vérification',
    'please_enter_the_6_digit_code_sent_to': 'Veuillez saisir le code à 6 chiffres envoyé à',
    'verify_phone': 'Vérifier le téléphone',
    'guidelines': 'Lignes directrices',
    'terms_of': 'Conditions de',
    'use': 'Utiliser.',
    'our_terms_are_designed_to_ensure_a_secur': 'Nos conditions sont conçues pour garantir un environnement sécurisé, fiable et équitable pour les propriétaires, les locataires et les gestionnaires immobiliers.',
    'conditions': 'Conditions',
    'clause_0': 'ARTICLE 0',
    'agreement_to': 'Accord pour',
    'arbitration': 'arbitrage.',
    'by_using_the_platform_you_agree_that_any': 'En utilisant la plateforme, vous acceptez que tout litige soit résolu par une médiation professionnelle ou un arbitrage exécutoire, garantissant une résolution efficace des conflits opérationnels.',
    'last_updated_march_2026': 'Nous nous engageons à maintenir une relation de collaboration avec tous nos utilisateurs.',
    'system_architecture': 'Dernière mise à jour : mars 2026',
    'refined': 'Architecture du système',
    'operations_1': 'Raffiné',
    'a_masterclass_in_property_management_we': 'Opérations.',
    'complete_platform_1': 'Plateforme complète',
    'everything_you_need_to_manage': 'Tout ce dont vous avez besoin pour gérer',
    'your_properties': 'vos propriétés.',
    'a_comprehensive_property_management_syst': 'Un système de gestion immobilière complet conçu pour l\'efficacité, l\'automatisation et l\'évolutivité.',
    'view_all_24_features': 'Afficher les 24 fonctionnalités',
    'get_started': 'Commencez',
    'take_control_of': 'Prendre le contrôle de',
    'your_entire_portfolio': 'tout votre portefeuille.',
    'hundreds_of_property_managers_have_alrea': 'Des centaines de gestionnaires immobiliers ont déjà transféré leurs opérations vers QuadProperties.',
    'start_free_trial': 'Commencez votre essai gratuit – aucune carte de crédit n\'est nécessaire.',
    'already_have_an_account': 'Commencer l\'essai gratuit',
    'quadcores_properties': 'Vous avez déjà un compte ?',
    'the_apartment_management_platform_built': 'Propriétés des quadricœurs',
    'quadcores': 'La plateforme de gestion d\'appartements conçue pour les opérations sérieuses.',
    'quadcores_properties_1': 'Quadcœurs',
    'every_property': 'Propriétés des quadricœurs',
    'under_control': 'Chaque propriété.',
    'one_platform_for_leases_rent_collection': 'Sous le contrôle.',
    'start_free_trial_1': 'Une plateforme unique pour les baux, la perception des loyers, la maintenance et les locataires —',
    'view_dashboard': 'conçu pour les gestionnaires immobiliers qui sont sérieux.',
    'scroll': 'Commencer l\'essai gratuit',
    'quadcores_properties_2': 'Afficher le tableau de bord',
    'tenant_login': 'Faire défiler',
    'owner_login': 'Propriétés des quadricœurs',
    'sign_in': 'Connexion locataire',
    'get_started_1': 'Connexion du propriétaire',
    'sign_in_1': 'Connectez-vous',
    'menu': 'Commencez →',
    'get_started_2': 'Connectez-vous',
    'tenant_13': 'Menus',
    'owner_1': 'Propriétaire',
    'nav_features': 'Fonctionnalités',
    'nav_pricing': 'Tarifs',
    'nav_about': 'À propos',
    'our_tiers': 'Nos niveaux',
    'choose_the_right': 'Choisissez le bon',
    'plan_for_you': 'planifier pour vous.',
    'monthly_1': 'Mensuel',
    'annual_3': 'Annuel',
    'mo_5': '/ mois',
    '20_off_annual_billing': '-20% sur la facturation annuelle',
    'quadcores_properties_3': 'Propriétés des quadricœurs',
    'the_apartment_management_platform_built_1': 'La plateforme de gestion d\'appartements conçue pour les opérations sérieuses.',
    'quadcores_1': 'Quadcœurs',
    'solutions': 'Solutions',
    'built_for_every_property_professional': 'Conçu pour tous les professionnels de l\'immobilier.',
    'empty_key_18': '✦',
    'set_up_your_password': 'Configurez votre mot de passe',
    'create_a_strong_password_for': 'Créez un mot de passe fort pour',
    'email_address_2': 'Adresse e-mail',
    'new_password_1': 'Nouveau mot de passe',
    'confirm_password_1': 'Confirmer le mot de passe',
    'back_to_login_1': 'Retour à la connexion',
    'view_all_announcements': 'Voir toutes les annonces →',
    'session_expiring_soon': 'Session expirant bientôt',
    'you_will_be_logged_out_automatically': 'Vous serez déconnecté automatiquement',
    'log_out': 'Se déconnecter',
    'stay_logged_in': 'Restez connecté',
    'id_2': 'Identifiant : #',
    'to_4': 'à',
    'ip_1': 'IP :',
    'ip_2': 'IP :',
    'contract_already_signed': 'Contrat déjà signé',
    'you_have_already_signed_this_contract': 'Vous avez déjà signé ce contrat.',
    'review_sign_contract': 'Examiner et signer le contrat',
    'awaiting_your_signature': 'En attente de votre signature',
    'contract_summary_1': 'Résumé du contrat',
    'property_3': 'Propriété',
    'start_date_3': 'Date de début',
    'end_date_1': 'Date de fin',
    'terms_and_conditions': 'Conditions générales',
    'important_information': 'Informations importantes',
    'by_signing_you_agree_to_all_terms_and_co': '• En signant, vous acceptez tous les termes et conditions énoncés ci-dessus',
    'your_electronic_signature_is_legally_bin': '• Votre signature électronique est juridiquement contraignante',
    'you_will_receive_a_signed_copy_via_email': '• Vous recevrez une copie signée par e-mail',
    'you_can_download_the_signed_contract_any': '• Vous pouvez télécharger le contrat signé à tout moment depuis votre portail',
    'cancel_32': 'Annuler',
    'sign_contract_2': 'Signer le contrat',
    'units_3': 'unités',
    'unit_18': 'Unité',
    'tenant_14': 'Locataire :',
    'empty_key_19': '· $',
    'mo_6': '/mois',
    'no_properties_found_in_your_portfolio': 'Aucune propriété trouvée dans votre portefeuille.',
    'my_ledger': 'Mon grand livre',
    'complete_history_of_your_financial_trans': 'Historique complet de vos transactions financières',
    'current_balance_1': 'Solde actuel',
    'no_ledger_entries_yet_1': 'Aucune écriture au grand livre pour l\'instant',
    'transactions_will_appear_here_once_recor': 'Les transactions apparaîtront ici une fois enregistrées.',
    'unit_19': 'Unité',
    'bal': 'Bal',
    'professional_access': 'Accès professionnel',
    'owner_2': 'Propriétaire',
    'secure_identify_for_property_executives': 'Identité sécurisée pour les dirigeants et la gestion immobilière.',
    'email_or_phone_number': 'E-mail ou numéro de téléphone',
    'secure_password': 'Mot de passe sécurisé',
    'switch_to_resident_login': 'Passer à la connexion résidente',
    'institutional_oversight': 'Surveillance institutionnelle.',
    'portfolio_suite': 'Suite Portefeuille',
    'full_control_over_your': 'Contrôle total sur votre',
    'property_assets': 'actifs immobiliers.',
    'audited_secure_compliant': 'Vérifié. Sécurisé. Conforme.',
    'empty_key_20': ': $',
    'per_unit_p_l_last_12_months': 'P&L par unité – 12 derniers mois',
    'loading_report': 'Chargement du rapport…',
    'no_properties_found': 'Aucune propriété trouvée',
    'unit_20': '· Numéro d\'unité',
    'mo_lease_ends': '/mois · Fin du bail',
    '12_mo_noi': 'NOI sur 12 mois',
    'empty_key_21': '▾',
    'monthly_collections_last_6_months': 'Collections mensuelles (6 derniers mois)',
    'tax_documents': 'Documents fiscaux',
    'annual_payment_summary_for_tax_reporting': 'Récapitulatif des paiements annuels pour la déclaration fiscale (1099-NEC)',
    'total_paid_1': 'Total payé',
    'this_is_your_personal_payment_summary_fo': 'Ceci est votre récapitulatif de paiement personnel. Pour le formulaire officiel 1099-NEC, veuillez contacter votre gestionnaire immobilier. Seuls les paiements de 600 $ ou plus au cours d\'une année civile doivent être déclarés à l\'IRS.',
    'unit_21': 'Unité',
    'no_payments_recorded_for': 'Aucun paiement enregistré pour',
    'select_a_different_year_to_view_your_pay': 'Sélectionnez une autre année pour afficher votre historique de paiement.',
    'browse_facilities_and_book_time_slots': 'Parcourez les installations et réservez des plages horaires',
    'no_amenities_available_in_your_building': 'Aucune commodité disponible dans votre immeuble',
    'mo_7': '/mois',
    'capacity_1': 'Capacité :',
    'book_time_slot': 'Réserver un créneau horaire',
    'book_an_amenity': 'Réservez un équipement',
    'amenity_1': 'Commodité *',
    'select_amenity_1': 'Sélectionnez l\'équipement',
    'date_2': 'Date*',
    'start_time_1': 'Heure de début *',
    'end_time_1': 'Heure de fin *',
    'notes_optional_1': 'Remarques (facultatif)',
    'cancel_33': 'Annuler',
    'no_upcoming_bookings': 'Aucune réservation à venir',
    'browse_amenities': 'Parcourir les commodités',
    'cancel_34': 'Annuler',
    'history_1': 'Histoire',
    'property_assistant': 'Assistant immobilier',
    'ask_about_your_account': 'Renseignez-vous sur votre compte',
    'lease_history': 'Historique du bail',
    'your_current_and_past_lease_agreements': 'Vos contrats de location actuels et passés',
    'active_lease': 'Bail actif',
    'unit_22': 'Unité',
    'building_10': 'Bâtiment',
    'monthly_rent_4': 'Loyer mensuel',
    'expires_1': 'Expire',
    'open_ended': 'Ouvert',
    'start_date_4': 'Date de début',
    'security_deposit_1': 'Dépôt de garantie',
    'type_3': 'Tapez',
    'no_active_lease_on_file': 'Aucun bail actif au dossier',
    'history_2': 'Histoire',
    'mo_8': '/mois',
    'no_lease_records_found': 'Aucun enregistrement de bail trouvé',
    'secure_access': 'Accès sécurisé',
    'hello_1': 'Bonjour à nouveau.',
    'again': 'Entrez vos coordonnées pour gérer votre maison et vos paiements.',
    'enter_your_details_to_manage_your_home_a': 'Votre e-mail',
    'your_email': 'Votre mot de passe',
    'your_password': 'Passer à la connexion propriétaire',
    'switch_to_owner_login': 'Tout en un seul endroit.',
    'everything_in_one_place': 'Des outils pour vous',
    'tools_for_you': 'Tout ce dont vous avez besoin',
    'everything_you_need': 'pour gérer votre maison.',
    'to_manage_your_home': 'Sûr. Privé. Fiable.',
    'safe_private_reliable': 'Nous utilisons un cryptage de qualité professionnelle pour garantir que vos données et vos paiements sont toujours protégés.',
    'we_use_professional_grade_encryption_to': ': #',
    'empty_key_22': 'Le paiement automatique est activé',
    'auto_pay_is_on': '· Votre loyer est facturé automatiquement à la date d\'échéance.',
    'your_rent_is_charged_automatically_on_th': 'Activer le paiement automatique',
    'enable_auto_pay': 'Enregistrez une carte ou un compte bancaire et ne manquez plus jamais un paiement de loyer.',
    'save_a_card_or_bank_account_and_never_mi': 'Offres de renouvellement',

    'autopay_enabled_toast': "Paiement automatique active ! Votre loyer sera preleve automatiquement a la date d'echeance.",
    'autopay_setup_canceled': 'La configuration du paiement automatique a ete annulee.',
    'autopay_setup_failed': 'Impossible de demarrer la configuration du paiement automatique.',
    'autopay_start_failed': 'Echec du demarrage de la configuration du paiement automatique.',
    'confirm_disable_autopay': 'Voulez-vous vraiment desactiver le paiement automatique ? Votre moyen de paiement enregistre sera supprime.',
    'autopay_disabled_success': 'Le paiement automatique a ete desactive.',
    'autopay_disable_failed': 'Echec de la desactivation du paiement automatique.',
    'card_ending_label': "{{brand}} se terminant par ••••{{last4}}",
    'payment_method_saved': 'Moyen de paiement enregistre',
    'disable_auto_pay': 'Desactiver le paiement automatique',
    'set_up_auto_pay': 'Configurer le paiement automatique',
    'due_colon': 'Echeance :',
    'disabling': 'Desactivation…',
    'renewal_offers': 'Examinez et répondez aux offres de renouvellement de bail de votre propriétaire',
    'review_and_respond_to_lease_renewal_offe': 'Aucune offre de renouvellement pour l\'instant',
    'no_renewal_offers_yet': 'Votre gestionnaire immobilier enverra ici une offre de renouvellement lorsque votre bail approche de sa date de fin.',
    'your_property_manager_will_send_a_renewa': 'Unité',
    'unit_23': 'Offre envoyée',
    'offer_sent_1': 'par mois',
    'per_month': 'Loyer offert',
    'offered_rent': 'par mois',
    'per_month_1': 'Nouveau terme :',
    'new_term': 'Note de la direction',
    'note_from_management': 'Refuser',
    'decline': 'Offres passées',
    'past_offers': 'Past Offers',
    'unit_24': 'Unité',
    'mo_9': '/mois',
    'responded': 'A répondu',
    'share_feedback': 'Partager les commentaires',
    'your_opinion_helps_us_improve': 'Votre avis nous aide à nous améliorer',
    'thank_you': 'Merci!',
    'your_feedback_has_been_submitted': 'Vos commentaires ont été soumis.',
    'submit_another': 'En soumettre un autre',
    'category_5': 'Catégorie',
    'your_rating': 'Votre note',
    'comment_optional': 'Commentaire (facultatif)',
    'your_past_feedback': 'Vos commentaires passés',

    'general': 'Général',
    'submit_feedback': "Soumettre l'évaluation",
    'please_select_rating': 'Veuillez sélectionner une note en étoiles',
    'submission_failed': 'Échec de la soumission',
    'tell_us_placeholder': 'Dites-nous ce que vous pensez…',
    'rating_very_poor': 'Très mauvais',
    'rating_poor': 'Mauvais',
    'rating_okay': 'Correct',
    'rating_good': 'Bien',
    'rating_excellent': 'Excellent',
    'utility_bills_1': 'Factures de services publics',
    'electricity_water_gas_and_other_utility': 'Frais d\'électricité, d\'eau, de gaz et autres services publics',
    'paid_on_time': 'Payé à temps',
    'monthly_utility_spend': 'Dépenses mensuelles en services publics',
    'no_utility_bills_yet': 'Pas encore de factures de services publics',
    'bills_will_appear_here_once_issued_by_ma': 'Les factures apparaîtront ici une fois émises par la direction.',
    'due_now': 'À payer maintenant (',
    'history_3': 'Histoire (',
    'due_1': 'Due',
    'violations_notices_1': 'Violations et avis',
    'view_violations_and_official_notices_iss': 'Afficher les violations et les avis officiels qui vous sont adressés',
    'no_violations_on_record': 'Aucune violation enregistrée',
    'you_have_a_clean_record_keep_it_up': 'Vous avez un casier vierge – continuez comme ça !',
    'fine': 'Bien :',
    'resolution': 'Résolution',
    'unit_25': 'Unité',
    'no_notices': 'Aucun avis',
    'no_official_notices_have_been_issued_to': 'Aucune notification officielle ne vous a été adressée.',
    'here_s_an_overview_of_your_operations_to': 'Voici un aperçu de vos opérations aujourd’hui.',
    'system_live': 'Système en direct',
    'active_operations': 'Opérations actives',
    'priority_task_queue': 'File d\'attente des tâches prioritaires',
    'no_active_tasks_in_your_queue': 'Aucune tâche active dans votre file d\'attente.',
    'compliance_alert': 'Alerte de conformité',
    'insurance_expires_in_12_days_please_uplo': 'L\'assurance expire dans 12 jours. Veuillez télécharger les documents mis à jour.',
    'upgrade_1': 'Mise à niveau',
    'service_score': 'Note de service',
    'detailed_analysis': 'Analyse détaillée',
    'system_activity': 'Activité du système',
    'profile_load_error': 'Erreur de chargement du profil',
    'the_registry_could_not_verify_your_ident': 'Le registre n\'a pas pu vérifier votre identité. Contactez les administrateurs système.',
    'operator': 'Opérateur',
    'tier_platinum': 'Niveau : Platine',
    'identity_matrix': 'Matrice d\'identité',
    'logistical_data': 'Données logistiques',
    'verified_credentials': 'Informations d\'identification vérifiées',
    'profile_modifications_are_managed_by_ins': 'Les modifications de profil sont gérées par des protocoles de sécurité institutionnels. Demandez des mises à jour via le pupitre de contrôle pour l’intégrité du réseau.',
    'invalid_or_expired_link': 'Lien invalide ou expiré',
    'security_established': 'Sécurité établie',
    'your_portal_access_key_has_been_successf': 'Votre clé d\'accès au portail a été créée avec succès.',
    'proceed_to_login': 'Procéder à la connexion',
    'access_setup': 'Accéder à la configuration',
    'finalize_your_credentials_for': 'Finalisez vos identifiants pour',
    'new_access_key': 'Nouvelle clé d\'accès',
    'confirm_authorization': 'Confirmer l\'autorisation',
    'finalize_connection': 'Finaliser la connexion',
    'w_9_tax_form': 'Formulaire fiscal W-9',
    'request_for_taxpayer_identification_numb': 'Demande de numéro d’identification fiscale – requise pour le dépôt 1099-NEC',
    'w_9_on_file': 'W-9 au dossier',
    'certified_on': 'Certifié le',
    'you_can_update_and_re_certify_at_any_tim': '. Vous pouvez mettre à jour et recertifier à tout moment.',
    'this_form_is_required_by_the_irs_if_you': 'Ce formulaire est requis par l\'IRS. Si vous recevez 600 $ ou plus au cours d\'une année civile, un 1099-NEC sera émis en utilisant ces informations. Votre SSN complet n’est jamais stocké – seuls les 4 derniers chiffres s’ils sont fournis.',
    '1_legal_name_as_shown_on_income_tax_retu': '1. Nom légal (tel qu\'indiqué sur la déclaration de revenus) *',
    '3_federal_tax_classification': '3. Classement fiscal fédéral *',
    'employer_id_number_ein': 'Numéro d’identification d’employeur (EIN)',
    'ssn_last_4_digits_only': 'SSN – 4 derniers chiffres uniquement',
    'we_only_store_the_last_4_for_your_privac': 'Nous stockons uniquement les 4 derniers pour votre vie privée',
    '5_address': '5. Adresse',
    'city': 'Ville',
    'state': 'État',
    'certification': 'Attestation',
    'under_penalties_of_perjury_i_certify_tha': 'Sous peine de parjure, je certifie que : (1) le numéro indiqué est mon numéro d’identification de contribuable correct ; (2) Je ne suis pas soumis à une retenue à la source ; (3) Je suis un citoyen américain ou une autre personne américaine ; (4) Je suis exempté de déclaration FATCA (le cas échéant).',
    'by_clicking': 'En cliquant',
    'save_certify': 'Enregistrer et certifier',
    'you_are_electronically_signing_this_w_9': 'vous signez électroniquement ce W-9. Votre adresse IP et votre horodatage seront enregistrés.',
    'core_operations': 'Opérations de base',
    'work_orders_1': 'Bons de travail',
    'execute_your_assignments_with_efficiency': 'Exécutez vos missions avec efficacité et précision.',
    'all_assignments': 'Toutes les missions',
    'assigned_tasks': 'Tâches assignées',
    'currently_active': 'Actuellement actif',
    'completed_history': 'Historique terminé',
    'no_assignments_found': 'Aucune mission trouvée',
    'your_current_view_filters_haven_t_matche': 'Vos filtres d\'affichage actuels ne correspondent à aucun enregistrement.',
    'unit_26': 'Unité',
    'task_description_1': 'Description de la tâche',
    'completion_evidence': 'Preuve d\'achèvement',
    'logistics_control': 'Contrôle Logistique',
    'start_mission': 'Démarrer la mission',
    'mark_finished': 'Marquer comme terminé',
    'submit_invoice': 'Soumettre la facture',
    'view_brief': 'Voir le résumé',
    'notice_1': 'Avis',
    'safety_protocols_are_active_wear_authori': 'Les protocoles de sécurité sont actifs. Portez des EPI autorisés en tout temps.',
    'page_1': 'Pages',
    'of_6': 'de',
    'next_4': 'Suivant',
    'submit_settlement': 'Soumettre le règlement',
    'claim_amount_for': 'Montant de la réclamation pour',
    'cancel_35': 'Annuler',
    'live': 'En direct',
    'sign_out_1': 'Se déconnecter',
    'sign_out_2': 'Se déconnecter',

    // Missing translations added
    'BULK_ADD': 'Ajout en masse',
    'QTY_PER_FLOOR': 'Qté / Étage',
    'SELECT_FLOORS': 'Sélectionner les étages',
    'SIZE': 'Superficie',
    'bill_charged': 'Facture imputée au compte du locataire',
    'billing_day': 'Jour de facturation du mois',
    'building_meter_hint': 'Compteur de l\'immeuble — utilisez RUBS pour répartir le coût entre tous les locataires',
    'calculating': 'Calcul en cours…',
    'charge_all': 'Tout facturer',
    'charging': 'Facturation en cours…',
    'custom': 'Personnalisé',
    'date': 'Date',
    'deleted': 'Supprimé',
    'done': 'Terminé',
    'ent_f1': 'Unités et administrateurs illimités',
    'ent_f10': 'Accès API & Webhook',
    'ent_f11': '2FA via WhatsApp OTP',
    'ent_f2': 'Portails locataires & propriétaires',
    'ent_f3': 'Messagerie sécurisée bidirectionnelle',
    'ent_f4': 'Paiements de loyer Stripe E2E',
    'ent_f5': 'Système d\'e-mail automatisé',
    'ent_f6': 'Signature numérique de contrats',
    'ent_f7': 'Support multi-organisations',
    'ent_f8': 'Modèles de rapports personnalisés',
    'ent_f9': 'Journaux d\'activité avancés',
    'enterprise_desc': 'Contrôle de qualité institutionnelle avec des portails en libre-service complets.',
    'generate_bills': 'Générer des factures',
    'generate_bills_now': 'Générer les factures maintenant',
    'individual_meter_hint': 'Compteur individuel — générer une facture pour cette unité',
    'pro_desc': 'Pour les cabinets professionnels avec des workflows d\'administration automatisés.',
    'pro_f1': 'Jusqu\'à 150 unités',
    'pro_f10': 'Support prioritaire standard',
    'pro_f2': '5 postes d\'administrateur',
    'pro_f3': 'Hub de maintenance global',
    'pro_f4': 'Conformité des dépôts de garantie',
    'pro_f5': 'Relevés mensuels automatisés',
    'pro_f6': 'Rappels WhatsApp',
    'pro_f7': 'Gestion des propriétaires & ordres de travail',
    'pro_f8': 'Analytique d\'occupation',
    'pro_f9': 'Réservation, liste d\'attente & transferts',
    'run_rubs_btn': 'Exécuter la répartition RUBS',
    'save_20_annual': 'Économisez 20 % · ${{amount}}/an facturé annuellement',
    'starter_desc': 'Pour les propriétaires indépendants gérant des dossiers internes.',
    'starter_f1': 'Jusqu\'à 100 unités',
    'starter_f2': '2 postes d\'administrateur',
    'starter_f3': 'Gestion des bâtiments & unités',
    'starter_f4': 'Grand livre à double entrée',
    'starter_f5': 'Suivi manuel des loyers',
    'starter_f6': 'Rapports financiers de base',
    'starter_f7': 'Notifications par e-mail',
    'starter_plan': 'Starter',
    'unknown': 'Inconnu',
    'utility_step1': 'Ajouter un compte de service public (électricité, eau, gaz…)',
    'utility_step2': 'Enregistrer un relevé de compteur',
    'utility_step3': 'Générer des factures à partir des relevés',
    'utility_step4': 'Imputer les factures directement au compte du locataire',
    'view_application': 'Voir la demande',

    'confirm_charge_bill': 'Imputer cette facture de service public au compte du locataire ?',

    'all_tenants_compliant_desc': 'Tous les locataires sont actuellement conformes',
    'audit_compliance': 'Audit de conformité',
    'compliant': 'Conforme',
    'confirm_delete_policy': 'Supprimer cette police ?',
    'entity_name': 'Nom de l\'entité',
    'error_loading_insurance': 'Échec du chargement des polices d\'assurance',
    'expiration': 'Expiration',
    'no_insurance_records': 'Aucun dossier d\'assurance trouvé',
    'non_compliant': 'Non conforme',
    'policy_added': 'Police ajoutée',
    'policy_updated': 'Police mise à jour',
    'send_notice': 'Envoyer un avis',
    'view_policy': 'Voir la police',

    'generate_drafts': 'Générer les brouillons maintenant',

    // Expulsions
    'ev_initiated': 'Initié',
    'ev_notice_served': 'Avis remis',
    'ev_court_filed': 'Déposé au tribunal',
    'ev_court_ruling': 'Décision du tribunal',
    'ev_completed': 'Terminé',
    'ev_dismissed': 'Rejeté',
    'ev_notice_pay_or_quit': 'Payer ou quitter',
    'ev_notice_cure_or_quit': 'Remédier ou quitter',
    'ev_notice_unconditional': 'Expulsion inconditionnelle',
    'ev_active_cases': 'Dossiers actifs',
    'ev_total_owed': 'Total dû',
    'ev_notice_type': "Type d'avis",
    'ev_amount_owed': 'Montant dû',
    'ev_status_updated': 'Statut mis à jour',
    'ev_dismiss_case': 'Classer l\'affaire',
    'ev_dismiss_confirm': 'Êtes-vous sûr de vouloir classer cette affaire d\'expulsion ? Cette action est irréversible.',
    'ev_case_dismissed': 'Affaire d\'expulsion classée',
    'ev_dismiss_failed': 'Échec du classement de l\'affaire',
    'ev_case_timeline': 'Chronologie de l\'affaire',
    'ev_notice_served_date': 'Signification de l\'avis',
    'ev_court_filing_date': 'Dépôt au tribunal',
    'ev_court_date': 'Date d\'audience',
    'ev_ruling': 'Jugement',
    'ev_ruling_date': 'Date du jugement',
    'ev_vacate_date': 'Date de libération',
    'ev_edit_notes': 'Modifier les notes',
    'ev_save_notes': 'Enregistrer les notes',
    'ev_add_notes': 'Ajouter une note',
    'ev_notes_saved': 'Notes enregistrées',
    'ev_save_failed': 'Échec de l\'enregistrement',
    'filed': 'Déposé',

    // Inspections
    'insp_move_in': 'Entrée',
    'insp_move_out': 'Sortie',
    'insp_periodic': 'Périodique',
    'insp_maintenance': 'Maintenance',
    'all_types': 'Tous les types',
    'all_status': 'Tous les statuts',
    'unit_building': 'Unité / Immeuble',
    'checklist_progress': 'Progression de la liste',
    'condition_1': 'État',

    // Infractions
    'tenant_unit': 'Locataire / Unité',
    'severity': 'Gravité',
    'fine': 'Amende',

    // Baux
    'start': 'Début',
    'end': 'Fin',
    'expiry': 'Expiration',
    'rent_mo': 'Loyer/mois',
    'open_ended': 'Durée indéterminée',

    // Renouvellements
    'offered_rent': 'Loyer proposé',
    'risk': 'Risque',
    'offer_expires': "Expiration de l'offre",

    // Candidatures
    'applicant': 'Candidat',
    'employment': 'Emploi',

    // Liens de candidature
    'total_links': 'Total des liens',
    'active_links': 'Liens actifs',
    'total_uses': 'Utilisations totales',
    'generating': 'Génération en cours...',
    'generate_link': 'Générer un lien',
    'deactivate_link': 'Désactiver le lien',
    'deactivate_link_confirm': 'Désactiver le lien « {{label}} » ? Il n\'acceptera plus de demandes.',
    'deactivate': 'Désactiver',

    // Assistant de vente
    'sw_step_buyer': 'Acheteur',
    'sw_step_terms': 'Conditions',
    'sw_step_schedule': 'Calendrier',
    'sw_step_confirm': 'Confirmer',
    'back': 'Retour',
    'creating': 'Création en cours...',
    'create_sale_contract': 'Créer le contrat de vente',
    'hash': '#',
    'due_date': "Date d'échéance",
    'principal': 'Capital',
    'interest': 'Intérêts',
    'monthly_payment': 'Paiement mensuel',
    'total_interest': 'Intérêts totaux',
    'total_cost': 'Coût total',
    'down_payment': 'Acompte',
    'sale_price': 'Prix de vente',
    'financed_amount': 'Montant financé',
    'interest_rate': "Taux d'intérêt",
    'term': 'Durée',

    // Validation errors
    'val_first_name_min': 'Le prénom doit comporter au moins 2 caractères',
    'val_first_name_max': 'Le prénom ne peut pas dépasser 50 caractères',
    'val_last_name_min': 'Le nom de famille doit comporter au moins 2 caractères',
    'val_last_name_max': 'Le nom de famille ne peut pas dépasser 50 caractères',
    'val_username_min': "Le nom d'utilisateur doit comporter au moins 3 caractères",
    'val_username_max': "Le nom d'utilisateur ne peut pas dépasser 30 caractères",
    'val_username_no_spaces': "Le nom d'utilisateur ne peut pas contenir d'espaces",
    'val_email_invalid': 'Veuillez entrer une adresse e-mail valide',
    'val_company_name_min': "Le nom de l'entreprise doit comporter au moins 2 caractères",
    'val_password_min': 'Le mot de passe doit comporter au moins 8 caractères',
    'val_password_max': 'Le mot de passe ne peut pas dépasser 128 caractères',
    'val_name_max_100': 'Le nom ne peut pas dépasser 100 caractères',
    'val_close_time_required': "Veuillez définir l'heure de fermeture",
    'val_open_time_required': "Veuillez définir l'heure d'ouverture",
    'val_close_after_open': "L'heure de fermeture doit être après l'heure d'ouverture",
    'val_title_max_200': 'Le titre ne peut pas dépasser 200 caractères',
    'val_description_max_2000': 'La description ne peut pas dépasser 2000 caractères',
    'val_fine_non_negative': "Le montant de l'amende doit être nul ou positif",
    'val_prospect_name_max': 'Le nom du prospect ne peut pas dépasser 200 caractères',
    'val_end_after_start': "L'heure de fin doit être après l'heure de début",
    'val_notes_max_2000': 'Les notes ne peuvent pas dépasser 2000 caractères',
    'val_expiry_after_start': "La date d'expiration doit être après la date de début",
    'val_url_invalid': 'L\'URL doit commencer par http:// ou https://',
    'val_notes_max_1000': 'Les notes ne peuvent pas dépasser 1000 caractères',
    'val_webhook_url_https': 'L\'URL du webhook doit commencer par https://',

    'error_loading_violations': 'Erreur lors du chargement des violations',
    'marked_as_resolved': 'Marqué comme résolu',
    'error_updating_violation': 'Erreur lors de la mise à jour de la violation',
    'title_and_notice_body_required': 'Le titre et le contenu de l\'avis sont requis',
    'notice_issued': 'Avis émis',
    'error_issuing_notice': 'Erreur lors de l\'émission de l\'avis',
    'search_violations': 'Rechercher par locataire, titre ou description...',
    'loading_violations': 'Chargement des violations...',
    'no_violations_recorded': 'Aucune violation enregistrée',
    'no_status_violations': 'Aucune violation {{status}}',
    'notice_type_required': 'Type d\'avis *',
    'delivery_method_required': 'Méthode de livraison *',
    'notice_title_required': 'Titre de l\'avis *',
    'notice_deadline_optional': 'Date limite de conformité (optionnel)',
    'notice_body_required': 'Corps de l\'avis *',
    'issuing': 'Émission en cours...',
    'issue_notice_btn': 'Émettre un avis',
    'violations_count': '{{count}} violations',
    'open_tickets': 'Tickets ouverts',
    'has_balance': 'A un solde',
    'perfect_payments': 'Paiements parfaits',
    'risk_score': 'Score de risque',
    'failed_to_load_evictions': 'Échec du chargement des expulsions',
    'failed_to_update_status': 'Échec de la mise à jour du statut',
    'please_select_a_tenant': 'Veuillez sélectionner un locataire',
    'tenant_must_have_apartment': 'Le locataire sélectionné doit avoir un appartement et un bâtiment assignés pour être expulsé.',
    'reason_is_required': 'La raison est requise',
    'eviction_case_opened': 'Dossier d\'expulsion ouvert',
    'failed_to_create_eviction': 'Échec de la création de l\'expulsion',

    'wo_stat_total': 'Total',
    'wo_stat_assigned': 'Attribué',
    'wo_stat_in_progress': 'En cours',
    'wo_stat_completed': 'Terminé',
    'wo_col_title': 'Titre',
    'wo_col_vendor': 'Fournisseur',
    'wo_col_priority': 'Priorité',
    'wo_col_status': 'Statut',
    'wo_col_scheduled': 'Planifié',
    'wo_col_invoice': 'Facture',
    'wo_col_assigned_by': 'Assigné par',
    'wo_detail_scheduled': 'Planifié',
    'wo_detail_completed': 'Terminé',
    'wo_detail_created': 'Créé',
    'wo_failed_to_load': 'Impossible de charger les bons de travail',
    'wo_invoice_approved': 'Facture approuvée avec succès!',
    'wo_confirm_approval': 'Confirmer l\'approbation',
    'wo_status_assigned': 'Assigné',
    'wo_status_in_progress': 'En cours',
    'wo_status_on_hold': 'En attente',
    'inv_status_received': 'Reçue',
    'view_detail': 'Voir le détail',
    'wo_failed_approve': "Impossible d'approuver la facture",
    'wo_failed_load_vendors': 'Impossible de charger la liste des fournisseurs',
    'wo_vendor_required': 'Le fournisseur est requis',
    'wo_title_required': 'Le titre est requis',
    'wo_created': 'Bon de travail créé avec succès',
    'wo_failed_to_create': 'Impossible de créer le bon de travail',
    'wo_title_placeholder': 'ex. Réparer une fuite dans le bâtiment A unité 302',
    'wo_description_placeholder': 'Fournissez des instructions détaillées au fournisseur...',
    'wo_linked_id_placeholder': 'ID lié optionnel',
    'wo_nothing_to_update': 'Rien à mettre à jour',
    'wo_updated': 'Bon de travail mis à jour',
    'wo_update_failed': 'Échec de la mise à jour',
    'sch_col_title': 'Titre',
    'sch_col_building': 'Bâtiment',
    'sch_col_frequency': 'Fréquence',
    'sch_col_next_due': 'Prochaine échéance',
    'sch_col_est_cost': 'Coût estimé',
    'sch_col_status': 'Statut',
    'sch_col_actions': 'Actions',
    'sch_error_loading': 'Erreur de chargement des plannings',
    'sch_mark_complete_success': 'Marqué comme terminé, prochaine date avancée',
    'sch_error_complete': 'Erreur lors de la complétion du planning',
    'sch_confirm_remove': 'Supprimer ce planning ?',
    'sch_removed': 'Planning supprimé',
    'sch_error_remove': 'Erreur lors de la suppression du planning',
    'sch_error_history': 'Erreur lors du chargement de l\'historique',
    'sch_search_placeholder': 'Rechercher des plannings...',
    'sch_status_active': 'Actif',
    'sch_status_inactive': 'Inactif',
    'sch_edit_success': 'Planning mis à jour',
    'sch_error_edit': 'Erreur lors de la mise à jour du planning',
    'sch_edit_schedule': 'Modifier le planning',
    'sch_title_freq_due_required': 'Le titre, la fréquence et la première date sont requis',
    'schedule_created': 'Planning créé',
    'sch_failed_to_create': 'Impossible de créer le planning',
    'sch_history_title': 'Historique',
    'sch_remove_title': 'Supprimer',
    'describe_task_placeholder': 'Décrire la tâche de maintenance...',
    'vendor_instructions_placeholder': 'Instructions spécifiques pour le prestataire...',
    'freq_daily': 'Quotidien',
    'freq_weekly': 'Hebdomadaire',
    'freq_biweekly': 'Bihebdomadaire',
    'freq_monthly': 'Mensuel',
    'freq_quarterly': 'Trimestriel',
    'freq_semiannual': 'Semestriel',
    'freq_biannual': 'Semestriel',
    'freq_annual': 'Annuel',

    'search_conversations': 'Rechercher des conversations...',
    'load_more': 'Charger plus',
    'no_results': 'Aucun résultat trouvé',
    'BULK_ADD': 'Ajout en masse',
    'QTY_PER_FLOOR': 'Qté / Étage',
    'SELECT_FLOORS': 'Sélectionner les étages',
    'SIZE': 'Taille',
    'bill_charged': 'Facture débitée au compte du locataire',
    'billing_day': 'Jour de facturation du mois',
    'building_meter_hint': 'Compteur du bâtiment — utiliser RUBS pour répartir les coûts entre tous les locataires',
    'calculating': 'Calcul en cours…',
    'charge_all': 'Facturer tout',
    'charging': 'Facturation en cours…',
    'custom': 'Personnalisé',
    'date': 'Date',
    'deleted': 'Supprimé',
    'done': 'Terminé',
    'ent_f1': 'Unités & Administrateurs illimités',
    'ent_f10': 'Accès API & Webhook',
    'ent_f11': '2FA via WhatsApp OTP',
    'ent_f2': 'Portails locataire & propriétaire',
    'ent_f3': 'Messagerie sécurisée bidirectionnelle',
    'ent_f4': 'Paiements de loyer Stripe E2E',
    'ent_f5': 'Système d\'e-mail automatisé',
    'ent_f6': 'Signature numérique de contrat',
    'ent_f7': 'Support multi-organisations',
    'ent_f8': 'Modèles de rapports personnalisés',
    'ent_f9': 'Journaux d\'activité avancés',
    'enterprise_desc': 'Contrôle institutionnel avec des portails en libre-service complets.',
    'generate_bills': 'Générer des factures',
    'generate_bills_now': 'Générer des factures maintenant',
    'individual_meter_hint': 'Compteur individuel — générer une facture pour cette unité',
    'pro_desc': 'Pour les entreprises professionnelles avec des flux de travail administratifs automatisés.',
    'pro_f1': 'Jusqu\'à 150 unités',
    'pro_f10': 'Support prioritaire standard',
    'pro_f2': '5 sièges administrateur',
    'pro_f3': 'Hub de maintenance global',
    'pro_f4': 'Conformité des dépôts de garantie',
    'pro_f5': 'Relevés mensuels automatisés',
    'pro_f6': 'Rappels WhatsApp',
    'pro_f7': 'Gestion des propriétaires & bons de travail',
    'pro_f8': 'Analyse d\'occupation',
    'pro_f9': 'Réservation, liste d\'attente & transferts',
    'run_rubs_btn': 'Exécuter la répartition RUBS',
    'save_20_annual': 'Économisez 20% · ${{amount}}/an facturé annuellement',
    'starter_desc': 'Pour les propriétaires indépendants gérant des dossiers internes.',
    'starter_f1': 'Jusqu\'à 100 unités',
    'starter_f2': '2 sièges administrateur',
    'starter_f3': 'Gestion des bâtiments & unités',
    'starter_f4': 'Grand livre à double entrée',
    'starter_f5': 'Suivi manuel des loyers',
    'starter_f6': 'Rapports financiers de base',
    'starter_f7': 'Notifications par e-mail',
    'starter_plan': 'Débutant',
    'unknown': 'Inconnu',
    'utility_step1': 'Ajouter un compte de service (électricité, eau, gaz…)',
    'utility_step2': 'Enregistrer un relevé de compteur',
    'utility_step3': 'Générer des factures à partir des relevés',
    'utility_step4': 'Facturer les factures directement au compte du locataire',
    'view_application': 'Voir la demande',
    'failed_to_update_document_status': 'Échec de la mise à jour du statut du document',
    'buyer_name_placeholder': 'p.ex. Ahmed Al-Rashidi',
    'col_amenity': 'Commodité',
    'col_space': 'Espace',
    'delete_document': 'Supprimer le document',
    'delete_draft_confirm': 'Voulez-vous vraiment supprimer cette inspection brouillon?',
    'delete_draft_inspection': 'Supprimer l\'inspection brouillon',
    'document_added': 'Document ajouté',
    'document_name_placeholder': 'Nom du document',
    'edit_unit_amenity': 'Modifier la commodité de l\'unité',
    'failed_create_inspection': 'Échec de la création de l\'inspection',
    'failed_delete_inspection': 'Seules les inspections brouillon peuvent être supprimées',
    'failed_generate_invite_link': 'Échec de la génération du lien d\'invitation',
    'failed_load_bookings': 'Échec du chargement des réservations',
    'failed_load_inspections': 'Échec du chargement des inspections',
    'failed_save_checklist': 'Échec de la sauvegarde de la liste de contrôle',
    'failed_sign_inspection': 'Échec de la signature de l\'inspection',
    'failed_update_condition': 'Échec de la mise à jour de l\'état',
    'fair': 'Passable',
    'inspection_completed': 'Inspection marquée comme terminée',
    'inspection_created': 'Inspection créée',
    'inspection_deleted': 'Inspection supprimée',
    'inspection_notes_placeholder': 'Observations ou notes initiales…',
    'inspection_signed': 'Inspection signée',
    'investment': 'Investissement',
    'item_notes_placeholder': 'Ajouter des notes pour cet élément…',
    'name_and_url_required': 'Le nom et l\'URL sont obligatoires',
    'poor': 'Mauvais',
    'portal_link_copied': 'Lien de configuration du portail copié dans le presse-papiers',
    'prospect_email_placeholder': 'john@example.com',
    'prospect_name_placeholder': 'p.ex. Jean Dupont',
    'prospect_phone_placeholder': '+964 770 000 0000',
    'sale_notes_placeholder': 'Notes optionnelles...',
    'search_apartment_placeholder': 'Rechercher un appartement...',
    'search_inspections_placeholder': 'Rechercher par unité, bâtiment ou locataire…',
    'search_owners_placeholder': 'Rechercher des propriétaires par nom, téléphone ou e-mail...',
    'search_unit_or_buyer': 'Rechercher une unité ou un acheteur...',
    'sign_inspection_message': 'Marquer cette inspection comme signée? Cette action est définitive et ne peut pas être annulée.',
    'stat_available_to_sell': 'Disponible à la vente',
    'stat_sold_units': 'Unités vendues',
    'status_all': 'Tous',
    'status_available': 'Disponible',
    'status_sold': 'Vendu',
    'uploaded_by': 'Téléchargé par',
    'hw_record_violation': '1. Enregistrer la violation',
    'hw_record_violation_desc': 'Enregistrez une violation avec type, gravité et amende optionnelle. L\'amende est automatiquement imputée au compte du locataire.',
    'hw_issue_notice': '2. Émettre un avis formel',
    'hw_issue_notice_desc': 'Joignez un avis légal et envoyez par e-mail ou WhatsApp.',
    'hw_track_resolution': '3. Suivre la résolution',
    'hw_track_resolution_desc': 'Mettre à jour le statut : reconnu → escaladé → résolu. Piste d\'audit complète conservée.',
    'hw_escalate': '4. Escalader si nécessaire',
    'hw_escalate_desc': 'Les violations escaladées peuvent alimenter le processus de demande d\'expulsion.',
    'notice_title_placeholder': 'p.ex. Avis de paiement ou départ — Loyer dû',
    'notice_body_placeholder': 'Entrez le texte complet de l\'avis légal...',
    'failed_to_load_tenants': 'Impossible de charger les locataires. Veuillez vérifier votre connexion.',
    'please_select_tenant': 'Veuillez d\'abord sélectionner un locataire',
    'title_is_required': 'Le titre est obligatoire',
    'violation_recorded_notice_sent': 'Violation enregistrée — avis automatiquement envoyé au locataire',
    'violation_recorded': 'Violation enregistrée',
    'error_creating_violation': 'Erreur lors de la création de la violation',
    'select_tenant_placeholder': 'Sélectionner un locataire...',
    'violation_title_placeholder': 'p.ex. Plainte pour bruit — musique forte après minuit',
    'violation_desc_placeholder': 'Décrivez la violation en détail...',
    'saving_ellipsis': 'Enregistrement...',
    'violation_status_open': 'Ouvert',
    'violation_status_acknowledged': 'Reconnu',
    'violation_status_resolved': 'Résolu',
    'violation_status_escalated': 'Escaladé',
    'violation_status_closed': 'Fermé',
    'violation_type_noise': 'Bruit',
    'violation_type_pets': 'Animaux',
    'violation_type_damage': 'Dommages',
    'violation_type_unauthorized_occupant': 'Occupant non autorisé',
    'violation_type_parking': 'Stationnement',
    'violation_type_smoking': 'Tabagisme',
    'violation_type_cleanliness': 'Propreté',
    'violation_type_lease_breach': 'Violation du bail',
    'violation_type_late_payment': 'Paiement tardif',
    'violation_type_general': 'Général',
    'violation_severity_warning': 'Avertissement',
    'violation_severity_minor': 'Mineur',
    'violation_severity_major': 'Majeur',
    'violation_severity_critical': 'Critique',
    'notice_type_pay_or_quit': 'Payer ou partir',
    'notice_type_cure_or_quit': 'Corriger ou partir',
    'notice_type_unconditional_quit': 'Départ inconditionnel',
    'notice_type_entry_notice': 'Avis d\'entrée',
    'notice_type_non_renewal': 'Non-renouvellement',
    'notice_type_eviction_filing': 'Demande d\'expulsion',
    'notice_type_lease_termination': 'Résiliation du bail',
    'notice_type_rent_increase': 'Augmentation du loyer',
    'notice_type_general': 'Général',
    'delivery_method_email': 'E-mail',
    'delivery_method_whatsapp': 'WhatsApp',
    'delivery_method_hand_delivered': 'Remis en main propre',
    'delivery_method_certified_mail': 'Courrier recommandé',
    'delivery_method_posted_on_door': 'Affiché sur la porte',
    'delivery_method_sms': 'SMS',
    'ev_reason_placeholder': 'Non-paiement du loyer, violation du bail, etc.',
    'select_placeholder': 'Sélectionner...',
    'opening_ellipsis': 'Ouverture...',
    'err_loading_tenants': 'Erreur lors du chargement des locataires',
    'identity_link_opened': 'Lien de vérification d\'identité ouvert — partagez-le avec le locataire',
    'failed_identity_verification': 'Échec du démarrage de la vérification d\'identité',
    'fcra_consent_required_toast': 'Vous devez confirmer le consentement FCRA avant d\'effectuer une vérification des antécédents',
    'bg_invitation_sent': 'Invitation de vérification des antécédents envoyée à l\'e-mail du locataire',
    'failed_bg_check': 'Échec du démarrage de la vérification des antécédents',
    'screening_decision_set': 'Décision de sélection définie sur : ',
    'failed_to_save_decision': 'Échec de l\'enregistrement de la décision',
    'search_tenants_placeholder': 'Rechercher des locataires...',
    'loading_ellipsis': 'Chargement...',
    'loading_screening_data': 'Chargement des données de sélection...',
    'dob_optional': 'Date de naissance (optionnel)',
    'zipcode_optional': 'Code postal (optionnel)',
    'state_optional': 'État/Province (optionnel)',
    'country_label': 'Pays',
    'sending_ellipsis': 'Envoi...',
    'send_to_tenant': 'Envoyer au locataire',
    'decision_label': 'Décision',
    'add_notes_decision_placeholder': 'Ajoutez des notes sur cette décision...',
    'save_decision': 'Enregistrer la décision',
    'badge_not_started': 'Non commencé',
    'badge_verified': 'Vérifié',
    'badge_action_needed': 'Action requise',
    'badge_canceled': 'Annulé',
    'badge_clear': 'Clair',
    'badge_consider': 'À considérer',
    'badge_dispute': 'Contesté',
    'badge_suspended': 'Suspendu',
    'badge_approved': 'Approuvé',
    'badge_rejected': 'Rejeté',
    'badge_manual_review': 'Révision manuelle',
}
};
